(function () {
  const products = document.querySelectorAll('[data-fd-product]');
  if (!products.length) return;

  const targetBcpoMainImageLinkHandles = new Set([
    'outdoor-curtain-custom-linen-curtains-chevrons',
    'sheer-cafe-curtains-for-small-windows',
    'sheer-cafe-curtains-for-white-kitchen',
    'custom-linen-curtains-bolonia',
    'heavy-duty-long-curtains-for-bathroom-showers-bolonia',
    'modern-curtains-for-bedroom-bolonia',
    'outdoor-curtain-bedroom-window-curtains-bolonia',
    'room-divider-curtain-bedroom-window-curtains-bolonia',
    'window-shades-for-baby-room-dp60-01-23',
    'velvet-christmas-kitchen-curtains-for-holiday',
    'velvet-kitchen-window-cafe-curtains',
    'outdoor-curtain-sliding-patio-door-curtains-hundred'
  ]);

  const forceTopGeneratedColorFieldHandles = new Set([
    'custom-natural-3-shades-on-1-headrail-nu-01-bamboo-shades',
    'custom-ramie-reed-top-down-bottom-up-alum-headrail-rs408-1-bamboo-shades'
  ]);

  const isNeutralBambooUploadHandle = (value) => {
    const handle = String(value || '').trim();
    return /^custom-(?:hazel|ivy|natural|nomi|ramie|willow)-/i.test(handle)
      || /^(?:hazel|ivy|nomi|ramie|reed|willow)-bamboo-shade-sample-book$/i.test(handle);
  };

  const handleize = (value) => String(value || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const uniqueKeys = (keys) => {
    const seen = new Set();
    return keys
      .map((key) => String(key || '').trim())
      .filter((key) => {
        if (!key || seen.has(key)) return false;
        seen.add(key);
        return true;
      });
  };

  const getColorCodeKeys = (value) => {
    const text = String(value || '');
    const keys = [];
    const matcher = /#?\b([a-z]{1,5}\d{2,5})(?:[-_\s]*(\d{1,2}))?\b/gi;
    let match = matcher.exec(text);
    while (match) {
      const family = String(match[1] || '').toUpperCase();
      const suffix = match[2] ? `-${Number(match[2])}` : '';
      const code = `${family}${suffix}`;
      keys.push(`#${code}`, code, code.toLowerCase(), handleize(code));
      match = matcher.exec(text);
    }
    return uniqueKeys(keys);
  };

  const cleanGeneratedColorKey = (value) => String(value || '')
    .replace(/[-_]+/g, ' ')
    .replace(/\s*\(\s*$/, '')
    .replace(/\s+/g, ' ')
    .trim();

  const getLabelKeyCandidates = (value) => {
    const text = String(value || '').trim();
    if (!text) return [];
    const withoutHash = text.replace(/^#/, '');
    const withoutColorCode = cleanGeneratedColorKey(text.replace(/\s*\([^)]*#?[a-z]{1,5}\d{2,5}[^)]*\)\s*$/i, ''));
    const keys = [
      text,
      text.toLowerCase(),
      handleize(text),
      withoutHash,
      withoutHash.toLowerCase(),
      handleize(withoutHash),
      withoutColorCode,
      withoutColorCode.toLowerCase(),
      handleize(withoutColorCode),
      ...getColorCodeKeys(text)
    ];
    return uniqueKeys(keys);
  };

  const findImageByLabel = (map, label) => {
    const candidates = getLabelKeyCandidates(label);
    for (const candidate of candidates) {
      const image = map.get(candidate);
      if (image) return image;
    }
    return '';
  };

  const isBrandedJ401SwatchMedia = (src) => {
    const value = String(src || '').toLowerCase();
    if (!value) return false;
    return value.includes('/fredesigner-')
      && value.includes('-j401-')
      && value.includes('.png');
  };

  const getVariantOptions = (variant) => {
    if (Array.isArray(variant.options)) return variant.options;
    return [variant.option1, variant.option2, variant.option3].filter(Boolean);
  };

  const formatMoney = (cents) => {
    if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
      return window.theme.Currency.formatMoney(cents, window.theme.settings && window.theme.settings.moneyFormat);
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return `$${(Number(cents || 0) / 100).toFixed(2)} USD`;
  };

  const expandBcpoImageUrl = (src) => {
    const value = String(src || '');
    if (!value || typeof window.atob !== 'function' || typeof window.btoa !== 'function') return value;

    try {
      const url = new URL(value, window.location.href);
      if (!url.hostname.includes('d17fzo7x83uajt.cloudfront.net')) return value;
      const payload = JSON.parse(window.atob(url.pathname.replace(/^\//, '')));
      payload.edits = payload.edits || {};
      payload.edits.resize = payload.edits.resize || {};
      payload.edits.resize.width = Math.max(Number(payload.edits.resize.width || 0), 1200);
      return `${url.origin}/${window.btoa(JSON.stringify(payload))}`;
    } catch (error) {
      return value;
    }
  };

  const normalizeMainImageUrl = (src) => {
    const value = String(src || '');
    if (!value) return value;

    try {
      const url = new URL(value, window.location.href);
      if (
        url.hostname.includes('d17fzo7x83uajt.cloudfront.net')
        && typeof window.atob === 'function'
        && typeof window.btoa === 'function'
      ) {
        const payload = JSON.parse(window.atob(url.pathname.replace(/^\//, '')));
        payload.edits = payload.edits || {};
        payload.edits.resize = payload.edits.resize || {};
        payload.edits.resize.width = Math.max(Number(payload.edits.resize.width || 0), 1200);
        delete payload.edits.resize.height;
        payload.edits.resize.fit = 'contain';
        return `${url.origin}/${window.btoa(JSON.stringify(payload))}`;
      }

      if (
        url.hostname.includes('shopify.com')
        || url.hostname.includes('shopifycdn.com')
        || url.pathname.includes('/cdn/shop/')
      ) {
        url.searchParams.set('width', '1200');
        url.searchParams.delete('height');
        url.searchParams.delete('crop');
        return url.toString();
      }

      return value;
    } catch (error) {
      return expandBcpoImageUrl(value);
    }
  };

  const getImageFileName = (src) => {
    const value = expandBcpoImageUrl(src);
    if (!value) return '';
    try {
      const url = new URL(value, window.location.href);
      return decodeURIComponent(url.pathname.split('/').pop() || '').toLowerCase();
    } catch (error) {
      return String(value).split('?')[0].split('/').pop().toLowerCase();
    }
  };

  const addColorImageKey = (map, key, src, replaceExisting, expandImage = true) => {
    const value = String(key || '').trim();
    if (!value || !src) return;
    const imageSrc = expandImage ? expandBcpoImageUrl(src) : String(src);
    const withoutHash = value.replace(/^#/, '');
    const withoutStyleCode = withoutHash
      .replace(/^style#?\d+[-\s]*\d*\s*/i, '')
      .replace(/^[a-z]{1,5}\d{0,4}[-\s]*\d+\s*/i, '')
      .trim();
    const withoutColorSuffix = withoutStyleCode.replace(/\s+color$/i, '').trim();
    [value, value.toLowerCase(), handleize(value), withoutHash, withoutHash.toLowerCase(), handleize(withoutHash), withoutStyleCode, withoutStyleCode.toLowerCase(), handleize(withoutStyleCode), withoutColorSuffix, withoutColorSuffix.toLowerCase(), handleize(withoutColorSuffix), ...getColorCodeKeys(value)]
      .filter(Boolean)
      .forEach((item) => {
        if (replaceExisting || !map.has(item)) map.set(item, imageSrc);
      });
  };

  const getGeneratedMediaColorKey = (value) => {
    const text = String(value || '').trim();
    if (!text) return '';
    const altMatch = text.match(/\s-\s(.+?)\s+browser generated product photo/i);
    if (altMatch) return altMatch[1].trim();
    const optionAltMatch = text.match(/\bcolor option\s+(.+?)(?:\s+by\s+fredesigner\b|$)/i);
    if (optionAltMatch) return cleanGeneratedColorKey(optionAltMatch[1]);
    const colorCode = getColorCodeKeys(text)[0];
    if (colorCode) return colorCode;
    return text
      .replace(/-?browser-generated-product-photo$/i, '')
      .replace(/\s+browser generated product photo$/i, '')
      .trim();
  };

  products.forEach((root) => {
    if (root.dataset.fdProductTwopagesLivefixReady === 'true') return;
    root.dataset.fdProductTwopagesLivefixReady = 'true';
    const productHandle = String(root.dataset.productHandle || '').trim();
    const optimizeVoImages = window.__fdVoImageOptimizationEnabled === true;
    const usesNativeBcpoOnly = productHandle === 'customizable-curtains-linen-curtains-sedge';
    const isNeutralBambooUploadedProduct = isNeutralBambooUploadHandle(productHandle);
    const usesNativeBcpoColorOnly = productHandle === 'custom-white-linen-plain-fold-roman-shade'
      || productHandle === 'roman-shade-blind';
    const usesStableTemplateColorField = isNeutralBambooUploadedProduct;
    const usesRomanNeutralParityConfigurator = root.classList.contains('fd-pdp--roman-ad')
      && !root.classList.contains('fd-pdp--neutral-v2');
    const preferBcpoColorImageAsMain = targetBcpoMainImageLinkHandles.has(productHandle);
    const preserveInitialMainImageDuringColorSync = /^custom-ramie-reed-/i.test(productHandle);
    const forceTopGeneratedColorField = /^custom-(?:hazel|ivy|natural|nomi|ramie|willow)-/i.test(productHandle) || forceTopGeneratedColorFieldHandles.has(productHandle);
    const targetBcpoMainImageState = { src: '', alt: '', correcting: false };
    let hasUserMainImageInteraction = false;
    let initialMainImageGuardStarted = false;
    const variantJson = root.querySelector('[data-fd-variants-json]');
    let variants = [];
    try {
      variants = JSON.parse(variantJson ? variantJson.textContent : '[]');
    } catch (error) {
      variants = [];
    }

    const form = root.querySelector('.fd-pdp-form');
    const variantInput = root.querySelector('[data-fd-variant-id]');
    const price = root.querySelector('[data-fd-price]');
    const stickyPrice = root.querySelector('[data-fd-sticky-price]');
    const comparePrice = root.querySelector('[data-fd-compare-price]');
    const atc = root.querySelector('[data-fd-atc]');
    const atcText = root.querySelector('[data-fd-atc-text]');
    const initialAtcDisabled = Boolean(atc && atc.disabled);
    const initialAtcText = atcText && atcText.textContent ? atcText.textContent.trim() : 'Add to Cart';
    const mainImage = root.querySelector('[data-fd-main-image]');
    const mainImageFrame = mainImage ? mainImage.closest('.fd-pdp__main-image') : null;
    const colorProperty = root.querySelector('[data-fd-color-property]');
    const thumbs = Array.from(root.querySelectorAll('[data-fd-thumb]'));
    const initialDefaultThumb = thumbs[0] || null;
    const quantityInput = root.querySelector('[data-fd-quantity]');
    const cordedBlocks = Array.from(root.querySelectorAll('[data-fd-corded-only]'));
    const selectedOptions = [];
    let bcpoA11ySequence = 0;
    const getReadableA11yText = (node) => {
      if (!node) return '';
      const text = String(node.textContent || '').replace(/\s+/g, ' ').trim();
      if (text) return text;
      const image = node.querySelector && node.querySelector('img[alt]');
      return String(
        (image && image.getAttribute('alt'))
        || (node.getAttribute && (node.getAttribute('aria-label') || node.getAttribute('title')))
        || ''
      ).replace(/\s+/g, ' ').trim();
    };
    const getAssociatedBcpoLabel = (input, bcpoRoot) => {
      const wrappingLabel = input.closest('label');
      if (wrappingLabel) return wrappingLabel;
      if (!input.id) return null;
      return Array.from(bcpoRoot.querySelectorAll('label[for]')).find((label) => label.htmlFor === input.id) || null;
    };
    const ensureUniqueBcpoRadioId = (input) => {
      const currentOwner = input.id ? document.getElementById(input.id) : null;
      if (input.id && (!currentOwner || currentOwner === input)) return input.id;
      const prefix = `fd-bcpo-radio-${handleize(productHandle) || 'product'}`;
      let candidate = '';
      do {
        bcpoA11ySequence += 1;
        candidate = `${prefix}-${bcpoA11ySequence}`;
      } while (document.getElementById(candidate));
      input.id = candidate;
      return candidate;
    };
    const getBcpoRadioName = (input, wrapper) => {
      const titleNode = wrapper && (
        wrapper.querySelector('.bcpo-title')
        || wrapper.querySelector('.bcpo-label')
        || Array.from(wrapper.children || []).find((child) => child.tagName === 'LABEL')
      );
      const groupName = getReadableA11yText(titleNode);
      const choice = input.closest('.bcpo-image-parent, .bcpo-color-parent, label');
      const image = choice && choice.querySelector ? choice.querySelector('img[alt]') : null;
      const valueName = String(
        input.dataset.label
        || input.dataset.title
        || input.dataset.value
        || (choice && (choice.getAttribute('data-fd-color-name') || choice.getAttribute('aria-label') || choice.getAttribute('title')))
        || (image && image.getAttribute('alt'))
        || input.value
        || ''
      ).replace(/\s+/g, ' ').trim();
      if (groupName && valueName && groupName.toLowerCase() !== valueName.toLowerCase()) {
        return `${groupName}: ${valueName}`;
      }
      return valueName || groupName || 'Customization option';
    };
    const syncRomanNeutralTrimFlow = (bcpoRoot) => {
      if (!usesRomanNeutralParityConfigurator || !bcpoRoot) return false;

      const upgradeInputs = Array.from(bcpoRoot.querySelectorAll(
        '[data-unique="_nc_upgrades"] input[type="radio"]'
      ));
      const trimBorderInputs = Array.from(bcpoRoot.querySelectorAll(
        '[data-unique="_nc_trim_border"] input[type="radio"]'
      ));
      const trimStyleInputs = Array.from(bcpoRoot.querySelectorAll(
        '[data-unique="_nc_trim_border_style"] input[type="radio"]'
      ));
      const normalizeValues = (inputs) => inputs.map(
        (input) => String(input.value || '').replace(/\s+/g, ' ').trim().toLowerCase()
      );
      const upgradeValues = normalizeValues(upgradeInputs);
      const trimBorderValues = normalizeValues(trimBorderInputs);
      const noNeedStyle = trimStyleInputs.find(
        (input) => normalizeVoText(input.value) === 'no need'
      );
      const validTrimStyles = trimStyleInputs.filter(
        (input) => normalizeVoText(input.value) !== 'no need'
      );
      const validTrimKeys = validTrimStyles.map((input) => normalizeVoText(input.value));
      const hasNeutralTrimStructure = upgradeInputs.length === 2
        && upgradeValues.includes('trim borders')
        && upgradeValues.includes('none')
        && trimBorderInputs.length === 2
        && trimBorderValues.includes('yes')
        && trimBorderValues.includes('no')
        && validTrimStyles.length === 14
        && new Set(validTrimKeys).size === 14
        && validTrimKeys.includes('trim 1 1')
        && validTrimKeys.includes('trim 13')
        && validTrimStyles.every((input) => Number(input.dataset.price || 0) === 69)
        && Boolean(noNeedStyle);

      bcpoRoot.classList.toggle('fd-bcpo-neutral-trim-flow', hasNeutralTrimStructure);
      if (!hasNeutralTrimStructure) {
        bcpoRoot.classList.remove('fd-bcpo-trim-active');
        delete bcpoRoot.dataset.fdBcpoTrimBridgeConfirmed;
        return false;
      }

      noNeedStyle.disabled = true;
      noNeedStyle.dataset.fdNeutralTrimIgnored = 'true';
      noNeedStyle.closest('.bcpo-image-parent')?.classList.add('fd-bcpo-trim-style-extra');

      const selectedUpgrade = upgradeInputs.find((input) => input.checked);
      const wantsTrim = normalizeVoText(selectedUpgrade?.value) === 'trim borders';
      bcpoRoot.classList.toggle('fd-bcpo-trim-active', wantsTrim);

      if (!selectedUpgrade || !wantsTrim) {
        trimBorderInputs.concat(trimStyleInputs).forEach((input) => {
          if (!input.checked) return;
          input.checked = false;
          input.setAttribute('aria-checked', 'false');
        });
        bcpoRoot.dataset.fdBcpoTrimBridgeConfirmed = selectedUpgrade ? 'none-cleared' : 'pending';
        return Boolean(selectedUpgrade);
      }

      const trimBorderYes = trimBorderInputs.find(
        (input) => normalizeVoText(input.value) === 'yes'
      );
      if (!trimBorderYes || trimBorderYes.disabled) {
        bcpoRoot.dataset.fdBcpoTrimBridgeConfirmed = 'pending';
        return false;
      }
      if (!trimBorderYes.checked) trimBorderYes.click();
      const bridgeConfirmed = trimBorderYes.checked
        && normalizeVoText(trimBorderYes.value) === 'yes';
      bcpoRoot.dataset.fdBcpoTrimBridgeConfirmed = bridgeConfirmed ? 'true' : 'false';
      return bridgeConfirmed;
    };
    const decorateBcpoRadioAccessibility = () => {
      const bcpoRoot = root.querySelector('#bcpo') || document.querySelector('#bcpo');
      if (!bcpoRoot) return;
      const radioWrappers = new Set();
      const flatLiningDetails = {
        'unlined': 'No liner · Maximum natural light',
        'white 90 gsm': 'Privacy white · Shading 60–80%',
        'cotton 100% white 117 gsm': 'Cotton white · Shading 70–85%',
        'belgian flax white': 'Belgian flax white · Shading 70–80%',
        'beige r06': 'Room darkening beige · Shading 70–80%',
        'khaki r08': 'Room darkening khaki · Shading 70–85%',
        'white 140 gsm': 'Room darkening white · Shading 75–90%',
        'blackout white 250 gsm': 'Thermal blackout white · Shading 100%',
        'premium woven blackout 350gsm': 'Premium woven blackout white · Shading over 90%',
        'blackout coffee 180 gsm': 'Dark blackout coffee · Shading 100%'
      };
      Object.assign(flatLiningDetails, {
        '70%-privacy lining 90gsm': 'Privacy lining - Shading 70%',
        '75%-cotton darkening lining 117gsm': 'Cotton darkening lining - Shading 75%',
        '80%-white darkening lining 140gsm': 'White darkening lining - Shading 80%',
        '90%-room darkening lining 220gsm': 'Room darkening lining - Shading 90%',
        '100%-blackout lining 150gsm': 'Blackout lining - Shading 100%',
        '100%-thermal blackout lining 250gsm': 'Thermal blackout lining - Shading 100%',
        'privacy, shading rate 50%-75%, beige white': 'Privacy beige white - Shading 50-75%',
        'blackout, shading rate 96-100%, white': 'Blackout white - Shading 96-100%',
        'premium woven blackout white 350gsm': 'Premium woven blackout white · Shading over 90%'
      });
      // Use the canonical liner photos already bound to the matching material
      // and shading options in the Roman configurator. The original BCPO radio
      // input remains the source of truth for selection and price.
      const flatLiningImages = {
        'unlined': 'https://cdn.shopify.com/s/files/1/0863/4200/9130/files/1pnaevg-unlined-2_1_-ymq.jpg',
        'white 90 gsm': 'https://cdn.shopify.com/s/files/1/0863/4200/9130/files/1t2meov-90_gsm-3-ymq.jpg',
        'cotton 100% white 117 gsm': 'https://cdn.shopify.com/s/files/1/0863/4200/9130/files/13rq9ol-117_-3-ymq.jpg',
        'belgian flax white': 'https://cdn.shopify.com/s/files/1/0863/4200/9130/files/vitrtv-belgian-ymq.jpg',
        'white 140 gsm': 'https://cdn.shopify.com/s/files/1/0863/4200/9130/files/120903c-140gsm1-ymq.jpg',
        'beige r06': 'https://cdn.shopify.com/s/files/1/0863/4200/9130/files/1cl86ah-120_gsm-ymq.jpg',
        'khaki r08': 'https://cdn.shopify.com/s/files/1/0863/4200/9130/files/1mfaki3-130_gsm-ymq.jpg',
        'blackout coffee 180 gsm': 'https://cdn.shopify.com/s/files/1/0863/4200/9130/files/1ojkhle-R07-11-ymq.jpg?v=1777533462',
        'blackout white 250 gsm': 'https://cdn.shopify.com/s/files/1/0863/4200/9130/files/ph5yqa-250gsm-ymq.jpg',
        'premium woven blackout 350gsm': 'https://cdn.shopify.com/s/files/1/0863/4200/9130/files/17ozzga-blackout-350gsm-ymq.jpg?v=1756431986',
        'premium woven blackout white 350gsm': 'https://cdn.shopify.com/s/files/1/0863/4200/9130/files/17ozzga-blackout-350gsm-ymq.jpg?v=1756431986',
        '70%-privacy lining 90gsm': 'https://cdn.shopify.com/s/files/1/0863/4200/9130/files/1t2meov-90_gsm-3-ymq.jpg',
        '75%-cotton darkening lining 117gsm': 'https://cdn.shopify.com/s/files/1/0863/4200/9130/files/13rq9ol-117_-3-ymq.jpg',
        '80%-white darkening lining 140gsm': 'https://cdn.shopify.com/s/files/1/0863/4200/9130/files/120903c-140gsm1-ymq.jpg',
        '90%-room darkening lining 220gsm': 'https://cdn.shopify.com/s/files/1/0863/4200/9130/files/gzjhn5-room_darkening-220gsm-ymq.jpg',
        '100%-blackout lining 150gsm': 'https://cdn.shopify.com/s/files/1/0863/4200/9130/files/1aw4wtl-150gsm-3-ymq.jpg',
        '100%-thermal blackout lining 250gsm': 'https://cdn.shopify.com/s/files/1/0863/4200/9130/files/ph5yqa-250gsm-ymq.jpg',
        'privacy, shading rate 50%-75%, beige white': 'https://cdn.shopify.com/s/files/1/0863/4200/9130/files/1t2meov-90_gsm-3-ymq.jpg',
        'blackout, shading rate 96-100%, white': 'https://cdn.shopify.com/s/files/1/0863/4200/9130/files/1aw4wtl-150gsm-3-ymq.jpg'
      };
      const flatLiningSections = {
        'unlined': { key: 'unlined', label: 'Unlined' },
        'white 90 gsm': { key: 'white', label: 'White Lining' },
        'cotton 100% white 117 gsm': { key: 'white', label: 'White Lining' },
        'belgian flax white': { key: 'white', label: 'White Lining' },
        'white 140 gsm': { key: 'white', label: 'White Lining' },
        'beige r06': { key: 'dark', label: 'Dark Lining' },
        'khaki r08': { key: 'dark', label: 'Dark Lining' },
        'blackout coffee 180 gsm': { key: 'dark', label: 'Dark Lining' },
        'blackout white 250 gsm': { key: 'blackout', label: 'Blackout Lining' },
        'premium woven blackout 350gsm': { key: 'blackout', label: 'Blackout Lining' },
        'premium woven blackout white 350gsm': { key: 'blackout', label: 'Blackout Lining' },
        '70%-privacy lining 90gsm': { key: 'white', label: 'White Lining' },
        '75%-cotton darkening lining 117gsm': { key: 'white', label: 'White Lining' },
        '80%-white darkening lining 140gsm': { key: 'white', label: 'White Lining' },
        '90%-room darkening lining 220gsm': { key: 'dark', label: 'Dark Lining' },
        '100%-blackout lining 150gsm': { key: 'blackout', label: 'Blackout Lining' },
        '100%-thermal blackout lining 250gsm': { key: 'blackout', label: 'Blackout Lining' },
        'privacy, shading rate 50%-75%, beige white': { key: 'white', label: 'White Lining' },
        'blackout, shading rate 96-100%, white': { key: 'blackout', label: 'Blackout Lining' }
      };
      const flatLiningSectionOrder = [
        { key: 'white', label: 'White Lining' },
        { key: 'blackout', label: 'Blackout Lining' },
        { key: 'dark', label: 'Dark Lining' },
        { key: 'unlined', label: 'Unlined' }
      ];
      const legacySevenLiningValues = new Set([
        'unlined',
        '70%-privacy lining 90gsm',
        '75%-cotton darkening lining 117gsm',
        '80%-white darkening lining 140gsm',
        '90%-room darkening lining 220gsm',
        '100%-blackout lining 150gsm',
        '100%-thermal blackout lining 250gsm'
      ]);
      const legacyThreeLiningValues = new Set([
        'unlined',
        'privacy, shading rate 50%-75%, beige white',
        'blackout, shading rate 96-100%, white'
      ]);
      const normalizeFlatLiningValue = (input) => (
        String(input?.value || '')
          .replace(/[–—]/g, '-')
          .replace(/\s*-\s*/g, '-')
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase()
      );
      const restoreFlatLiningChoicePresentation = (choice) => {
        const label = choice?.querySelector('.bcpo-front-button-label');
        if (!label || !label.dataset.fdLiningFlatDisplayName) return;
        label.textContent = label.dataset.fdLiningFlatDisplayName;
        delete label.dataset.fdLiningFlatDisplayName;
        delete label.dataset.fdLiningFlatImage;
        delete label.dataset.fdLiningFlatImageFailed;
      };
      const decorateFlatLiningChoicePresentation = (choice, normalizedValue) => {
        const label = choice?.querySelector('.bcpo-front-button-label');
        const imageUrl = flatLiningImages[normalizedValue];
        if (!label || !imageUrl) return;
        if (!label.dataset.fdLiningFlatDisplayName) {
          label.dataset.fdLiningFlatDisplayName = String(label.textContent || '')
            .replace(/\s+/g, ' ')
            .trim();
        }
        const displayName = label.dataset.fdLiningFlatDisplayName || normalizedValue;
        let media = label.querySelector('.fd-bcpo-lining-flat-media');
        let image = media?.querySelector('.fd-bcpo-lining-flat-image') || null;
        let name = label.querySelector('.fd-bcpo-lining-flat-name');
        if (!name) {
          name = document.createElement('span');
          name.className = 'fd-bcpo-lining-flat-name';
        }
        name.textContent = displayName;
        if (!media && label.dataset.fdLiningFlatImageFailed !== imageUrl) {
          media = document.createElement('span');
          media.className = 'fd-bcpo-lining-flat-media';
          image = document.createElement('img');
          image.className = 'fd-bcpo-lining-flat-image';
          image.alt = '';
          image.loading = 'lazy';
          image.decoding = 'async';
          image.addEventListener('error', () => {
            label.dataset.fdLiningFlatImageFailed = imageUrl;
            media?.remove();
          }, { once: true });
          media.appendChild(image);
        }
        if (image && image.getAttribute('src') !== imageUrl) image.src = imageUrl;
        label.dataset.fdLiningFlatImage = imageUrl;
        label.replaceChildren(...(media ? [media, name] : [name]));
      };
      const matchesExactLiningValues = (values, expected) => (
        values.length === expected.size
        && new Set(values).size === expected.size
        && values.every((value) => expected.has(value))
      );
      const getFlatLiningConfiguration = (groupTitleKey, inputs) => {
        if (!/\b(?:lining|liner)\b/.test(groupTitleKey)) return null;
        const values = inputs.map(normalizeFlatLiningValue);
        if (matchesExactLiningValues(values, legacySevenLiningValues)) {
          return { key: 'legacy-7', values };
        }
        if (matchesExactLiningValues(values, legacyThreeLiningValues)) {
          return { key: 'legacy-3', values };
        }
        if (values.length !== 10 || new Set(values).size !== 10) return null;
        const requiredTenValues = [
          'unlined',
          'white 90 gsm',
          'cotton 100% white 117 gsm',
          'belgian flax white',
          'white 140 gsm',
          'beige r06',
          'khaki r08',
          'blackout coffee 180 gsm',
          'blackout white 250 gsm'
        ];
        const premiumValues = new Set([
          'premium woven blackout 350gsm',
          'premium woven blackout white 350gsm'
        ]);
        if (
          !requiredTenValues.every((value) => values.includes(value))
          || values.filter((value) => premiumValues.has(value)).length !== 1
          || values.some((value) => !flatLiningSections[value])
        ) {
          return null;
        }
        const counts = values.reduce((result, value) => {
          const categoryKey = flatLiningSections[value].key;
          result[categoryKey] = (result[categoryKey] || 0) + 1;
          return result;
        }, {});
        if (
          counts.unlined !== 1
          || counts.white !== 4
          || counts.dark !== 3
          || counts.blackout !== 2
        ) {
          return null;
        }
        return { key: 'neutral-10', values };
      };
      const activateFlatLiningTab = (wrapper, categoryKey, options = {}) => {
        const tabList = wrapper.querySelector('.fd-lining-category-tabs');
        if (!tabList) return false;
        const tabs = Array.from(tabList.querySelectorAll('.fd-lining-category-tab'));
        const panels = Array.from(wrapper.querySelectorAll('.fd-lining-category-panel'));
        const activeTab = tabs.find((tab) => tab.dataset.fdLiningCategory === categoryKey);
        const activePanel = panels.find((panel) => panel.dataset.fdLiningCategory === categoryKey);
        if (!activeTab || !activePanel) return false;
        tabs.forEach((tab) => {
          const isActive = tab === activeTab;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.tabIndex = isActive ? 0 : -1;
        });
        panels.forEach((panel) => {
          const isActive = panel === activePanel;
          panel.classList.toggle('is-active', isActive);
          panel.classList.toggle('is-hidden', !isActive);
          panel.hidden = !isActive;
          panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
        wrapper.dataset.fdLiningActiveCategory = categoryKey;
        if (options.focus === true) activeTab.focus();
        return true;
      };
      const restoreFlatLiningTabs = (wrapper) => {
        const selector = wrapper.querySelector(':scope > .single-option-selector');
        if (!selector) return;
        const tabList = selector.querySelector(':scope > .fd-lining-category-tabs');
        const panels = Array.from(selector.querySelectorAll(':scope > .fd-lining-category-panel'));
        if (tabList || panels.length) {
          const choices = Array.from(
            selector.querySelectorAll('.fd-lining-category-panel > .fd-bcpo-lining-flat-choice')
          ).sort((left, right) => (
            Number(left.dataset.fdLiningOriginalIndex || 0)
            - Number(right.dataset.fdLiningOriginalIndex || 0)
          ));
          const anchor = tabList || panels[0] || null;
          choices.forEach((choice) => selector.insertBefore(choice, anchor));
          tabList?.remove();
          panels.forEach((panel) => panel.remove());
          choices.forEach((choice) => delete choice.dataset.fdLiningOriginalIndex);
        }
        wrapper.classList.remove(
          'fd-bcpo-lining-categorized',
          'fd-bcpo-lining-flat--tabs'
        );
        delete wrapper.dataset.fdLiningActiveCategory;
        delete wrapper.dataset.fdLiningSelectedValue;
        delete wrapper.dataset.fdLiningTabsId;
      };
      const renderFlatLiningTabs = (wrapper, selector, choices, inputs) => {
        const groupTitleNode = wrapper.querySelector('.bcpo-title')
          || wrapper.querySelector('.bcpo-label')
          || Array.from(wrapper.children || []).find((child) => child.tagName === 'LABEL');
        const liningGuideText = getReadableA11yText(
          groupTitleNode?.querySelector('.fd-bcpo-lining-guide-link')
        );
        const groupTitleKey = getReadableA11yText(groupTitleNode)
          .replace(liningGuideText, '')
          .replace(/:\s*$/, '')
          .trim()
          .toLowerCase();
        const configuration = getFlatLiningConfiguration(groupTitleKey, inputs);
        if (!configuration || choices.length !== inputs.length) {
          restoreFlatLiningTabs(wrapper);
          return false;
        }
        const availableCategories = new Set(
          configuration.values.map((value) => flatLiningSections[value]?.key).filter(Boolean)
        );
        const categoryOrder = flatLiningSectionOrder.filter(
          (section) => availableCategories.has(section.key)
        );
        if (!categoryOrder.length) {
          restoreFlatLiningTabs(wrapper);
          return false;
        }
        selector.querySelectorAll(':scope > .fd-bcpo-lining-flat-section-title').forEach(
          (title) => title.remove()
        );
        const existingTabList = selector.querySelector(':scope > .fd-lining-category-tabs');
        const hadTabList = Boolean(existingTabList);
        let tabList = existingTabList;
        if (!tabList) {
          tabList = document.createElement('div');
          tabList.className = 'fd-lining-category-tabs';
          tabList.setAttribute('role', 'tablist');
          tabList.setAttribute('aria-label', 'Lining categories');
          tabList.setAttribute('aria-orientation', 'horizontal');
          selector.insertBefore(tabList, selector.firstElementChild);
        }
        if (!wrapper.dataset.fdLiningTabsId) {
          bcpoA11ySequence += 1;
          wrapper.dataset.fdLiningTabsId = `fd-lining-categories-${bcpoA11ySequence}`;
        }
        const idPrefix = wrapper.dataset.fdLiningTabsId;
        choices.forEach((choice, index) => {
          if (!choice.dataset.fdLiningOriginalIndex) {
            choice.dataset.fdLiningOriginalIndex = String(index);
          }
        });
        const validCategoryKeys = new Set(categoryOrder.map((section) => section.key));
        tabList.querySelectorAll('.fd-lining-category-tab').forEach((tab) => {
          if (!validCategoryKeys.has(tab.dataset.fdLiningCategory)) tab.remove();
        });
        selector.querySelectorAll(':scope > .fd-lining-category-panel').forEach((panel) => {
          if (!validCategoryKeys.has(panel.dataset.fdLiningCategory)) panel.remove();
        });
        let previousTab = null;
        let previousPanel = tabList;
        categoryOrder.forEach((section) => {
          let tab = Array.from(tabList.querySelectorAll('.fd-lining-category-tab')).find(
            (candidate) => candidate.dataset.fdLiningCategory === section.key
          );
          if (!tab) {
            tab = document.createElement('button');
            tab.type = 'button';
            tab.className = 'fd-lining-category-tab';
            tab.dataset.fdLiningCategory = section.key;
            tab.setAttribute('role', 'tab');
          }
          tab.id = `${idPrefix}-tab-${section.key}`;
          tab.textContent = section.label;
          tab.setAttribute('aria-controls', `${idPrefix}-panel-${section.key}`);
          if (!previousTab) {
            if (tabList.firstElementChild !== tab) tabList.insertBefore(tab, tabList.firstElementChild);
          } else if (previousTab.nextElementSibling !== tab) {
            tabList.insertBefore(tab, previousTab.nextElementSibling);
          }
          previousTab = tab;
          let panel = Array.from(selector.querySelectorAll(':scope > .fd-lining-category-panel')).find(
            (candidate) => candidate.dataset.fdLiningCategory === section.key
          );
          if (!panel) {
            panel = document.createElement('div');
            panel.className = 'fd-lining-category-panel';
            panel.dataset.fdLiningCategory = section.key;
            panel.setAttribute('role', 'tabpanel');
          }
          panel.id = `${idPrefix}-panel-${section.key}`;
          panel.setAttribute('aria-labelledby', tab.id);
          if (previousPanel.nextElementSibling !== panel) {
            selector.insertBefore(panel, previousPanel.nextElementSibling);
          }
          previousPanel = panel;
          const categoryChoices = choices
            .filter((choice) => choice.dataset.fdLiningSection === section.key)
            .sort((left, right) => (
              Number(left.dataset.fdLiningOriginalIndex)
              - Number(right.dataset.fdLiningOriginalIndex)
            ));
          let previousChoice = null;
          categoryChoices.forEach((choice) => {
            if (!previousChoice) {
              if (panel.firstElementChild !== choice) panel.insertBefore(choice, panel.firstElementChild);
            } else if (previousChoice.nextElementSibling !== choice) {
              panel.insertBefore(choice, previousChoice.nextElementSibling);
            }
            previousChoice = choice;
          });
        });
        if (tabList.dataset.fdLiningTabsBound !== 'true') {
          tabList.dataset.fdLiningTabsBound = 'true';
          tabList.addEventListener('click', (event) => {
            const target = event.target instanceof Element
              ? event.target.closest('.fd-lining-category-tab')
              : null;
            if (!target || !tabList.contains(target)) return;
            activateFlatLiningTab(wrapper, target.dataset.fdLiningCategory);
          });
          tabList.addEventListener('keydown', (event) => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            const tabs = Array.from(tabList.querySelectorAll('.fd-lining-category-tab'));
            const currentIndex = tabs.indexOf(event.target);
            if (currentIndex < 0 || !tabs.length) return;
            event.preventDefault();
            let nextIndex = currentIndex;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = tabs.length - 1;
            if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
            if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
            activateFlatLiningTab(
              wrapper,
              tabs[nextIndex].dataset.fdLiningCategory,
              { focus: true }
            );
          });
        }
        if (wrapper.dataset.fdLiningTabsChangeBound !== 'true') {
          wrapper.dataset.fdLiningTabsChangeBound = 'true';
          wrapper.addEventListener('change', (event) => {
            if (!wrapper.classList.contains('fd-bcpo-lining-flat--tabs')) return;
            const input = event.target instanceof HTMLInputElement ? event.target : null;
            const choice = input?.closest('.fd-bcpo-lining-flat-choice');
            const categoryKey = choice?.dataset.fdLiningSection;
            if (!input?.checked || !categoryKey) return;
            wrapper.dataset.fdLiningSelectedValue = normalizeFlatLiningValue(input);
            activateFlatLiningTab(wrapper, categoryKey);
          });
        }
        wrapper.classList.add(
          'fd-bcpo-lining-categorized',
          'fd-bcpo-lining-flat--tabs'
        );
        const checkedChoice = choices.find((choice) => choice.querySelector('input[type="radio"]:checked'));
        const checkedInput = checkedChoice?.querySelector('input[type="radio"]:checked');
        const selectedValue = checkedInput ? normalizeFlatLiningValue(checkedInput) : '';
        const selectedCategory = checkedChoice?.dataset.fdLiningSection;
        const savedCategory = wrapper.dataset.fdLiningActiveCategory;
        const selectedValueChanged = selectedValue !== (wrapper.dataset.fdLiningSelectedValue || '');
        let activeCategory = '';
        if ((!hadTabList || selectedValueChanged) && availableCategories.has(selectedCategory)) {
          activeCategory = selectedCategory;
        } else if (availableCategories.has(savedCategory)) {
          activeCategory = savedCategory;
        } else if (availableCategories.has(selectedCategory)) {
          activeCategory = selectedCategory;
        } else {
          activeCategory = categoryOrder[0]?.key || '';
        }
        if (selectedValue) wrapper.dataset.fdLiningSelectedValue = selectedValue;
        else delete wrapper.dataset.fdLiningSelectedValue;
        return Boolean(activeCategory && activateFlatLiningTab(wrapper, activeCategory));
      };
      bcpoRoot.querySelectorAll('input[type="radio"]').forEach((input) => {
        const inputId = ensureUniqueBcpoRadioId(input);
        const wrapper = input.closest('.selector-wrapper, .bcpo-selector-wrapper, .bold_option, [data-option]') || bcpoRoot;
        radioWrappers.add(wrapper);
        const groupTitleNode = wrapper.querySelector('.bcpo-title')
          || wrapper.querySelector('.bcpo-label')
          || Array.from(wrapper.children || []).find((child) => child.tagName === 'LABEL');
        const liningGuideText = getReadableA11yText(
          groupTitleNode?.querySelector('.fd-bcpo-lining-guide-link')
        );
        const groupTitle = getReadableA11yText(groupTitleNode)
          .replace(liningGuideText, '')
          .replace(/:\s*$/, '')
          .trim();
        const groupTitleKey = groupTitle.toLowerCase();
        const isLiningDetailGroup = [
          'white lining',
          'neutral lining',
          'blackout lining',
          'dark lining',
          'same color lining',
          'unlined'
        ].includes(groupTitleKey);
        const isRomanLiningDetailGroup = usesRomanNeutralParityConfigurator && isLiningDetailGroup;
        const isRomanImageDetailGroup = usesRomanNeutralParityConfigurator
          && ['upgrades', 'trim border style'].includes(groupTitleKey);
        const detailChoice = (isRomanLiningDetailGroup || isRomanImageDetailGroup)
          ? input.closest('.bcpo-image-parent')
          : null;
        if (detailChoice) {
          if (isRomanLiningDetailGroup) {
            wrapper.classList.add('fd-bcpo-lining-detail');
            detailChoice.classList.add('fd-bcpo-lining-choice');
          }
          if (isRomanImageDetailGroup) {
            wrapper.classList.add('fd-bcpo-image-detail');
            detailChoice.classList.add('fd-bcpo-image-detail-choice');
          }
          let caption = detailChoice.querySelector('.fd-bcpo-detail-caption, .fd-bcpo-lining-caption');
          if (!caption) {
            caption = document.createElement('label');
            detailChoice.appendChild(caption);
          }
          caption.classList.add('fd-bcpo-detail-caption');
          caption.classList.toggle('fd-bcpo-lining-caption', isRomanLiningDetailGroup);
          caption.htmlFor = inputId;
          caption.replaceChildren();
          const name = document.createElement('span');
          name.className = 'fd-bcpo-detail-caption__name';
          name.textContent = String(input.value || '').replace(/\s+/g, ' ').trim();
          caption.appendChild(name);
          const priceAmount = Number(input.dataset.price || 0);
          const price = document.createElement('span');
          price.className = 'fd-bcpo-detail-caption__price';
          if (isRomanLiningDetailGroup) price.classList.add('fd-bcpo-lining-caption__price');
          price.textContent = Number.isFinite(priceAmount) && priceAmount !== 0
            ? `(${priceAmount > 0 ? '+' : '-'}$${Math.abs(priceAmount).toFixed(2)})`
            : 'Included';
          caption.appendChild(price);
        }
        const flatLiningInputs = Array.from(wrapper.querySelectorAll('input[type="radio"]'));
        const flatLiningConfiguration = getFlatLiningConfiguration(
          groupTitleKey,
          flatLiningInputs
        );
        const isFlatLiningGroup = Boolean(flatLiningConfiguration);
        const isLiningTitle = /\b(?:lining|liner)\b/.test(groupTitleKey);
        if (groupTitleKey === 'lining') {
          wrapper.classList.toggle(
            'fd-bcpo-lining-parent-tabs',
            usesRomanNeutralParityConfigurator && !isFlatLiningGroup
          );
        }
        if (
          (usesRomanNeutralParityConfigurator && groupTitleKey === 'lining' && !isFlatLiningGroup)
          || isFlatLiningGroup
        ) {
          const labelRow = wrapper.querySelector('.bcpo-label');
          if (labelRow && !labelRow.querySelector('.fd-bcpo-lining-guide-link')) {
            const guideLink = document.createElement('a');
            guideLink.className = 'fd-bcpo-lining-guide-link';
            guideLink.href = '/pages/instructions-about-the-liner';
            guideLink.textContent = 'Liner & shading rate';
            guideLink.setAttribute('aria-label', 'Open liner and shading rate guide');
            labelRow.appendChild(guideLink);
          }
        }
        if (isLiningTitle && !isFlatLiningGroup) {
          restoreFlatLiningTabs(wrapper);
          wrapper.classList.remove('fd-bcpo-lining-flat');
          wrapper.querySelectorAll('.fd-bcpo-lining-flat-choice').forEach((choice) => {
            restoreFlatLiningChoicePresentation(choice);
            choice.classList.remove('fd-bcpo-lining-flat-choice');
            delete choice.dataset.fdLiningSection;
            choice.querySelector('.fd-bcpo-lining-flat-detail')?.remove();
          });
        }
        const flatLiningChoice = isFlatLiningGroup ? input.closest('.bcpo-button-parent') : null;
        const normalizedFlatLiningValue = normalizeFlatLiningValue(input);
        const flatLiningDescription = flatLiningDetails[normalizedFlatLiningValue];
        if (flatLiningChoice && flatLiningDescription) {
          wrapper.classList.add('fd-bcpo-lining-flat');
          flatLiningChoice.classList.add('fd-bcpo-lining-flat-choice');
          const flatLiningSection = flatLiningSections[normalizedFlatLiningValue];
          if (flatLiningSection) {
            flatLiningChoice.dataset.fdLiningSection = flatLiningSection.key;
          }
          let detail = flatLiningChoice.querySelector('.fd-bcpo-lining-flat-detail');
          if (!detail) {
            detail = document.createElement('label');
            detail.className = 'fd-bcpo-lining-flat-detail';
            flatLiningChoice.appendChild(detail);
          }
          detail.htmlFor = inputId;
          detail.replaceChildren();
          const description = document.createElement('span');
          description.className = 'fd-bcpo-lining-flat-detail__description';
          description.textContent = flatLiningDescription;
          detail.appendChild(description);
          const priceAmount = Number(input.dataset.price || 0);
          const price = document.createElement('span');
          price.className = 'fd-bcpo-lining-flat-detail__price';
          price.textContent = Number.isFinite(priceAmount) && priceAmount !== 0
            ? `${priceAmount > 0 ? '+' : '-'}$${Math.abs(priceAmount).toFixed(2)}`
            : 'Included';
          detail.appendChild(price);
          decorateFlatLiningChoicePresentation(flatLiningChoice, normalizedFlatLiningValue);
        }
        const associatedLabel = getAssociatedBcpoLabel(input, bcpoRoot);
        const ariaLabel = String(input.getAttribute('aria-label') || '').trim();
        const labelledBy = String(input.getAttribute('aria-labelledby') || '').trim();
        const labelledByText = labelledBy
          .split(/\s+/)
          .map((id) => getReadableA11yText(document.getElementById(id)))
          .filter(Boolean)
          .join(' ');
        if (ariaLabel || labelledByText || getReadableA11yText(associatedLabel)) return;

        let generatedLabel = input.dataset.fdBcpoA11yLabelId
          ? document.getElementById(input.dataset.fdBcpoA11yLabelId)
          : null;
        if (!generatedLabel) {
          let labelId = `${inputId}-fd-label`;
          let suffix = 1;
          while (document.getElementById(labelId)) {
            suffix += 1;
            labelId = `${inputId}-fd-label-${suffix}`;
          }
          generatedLabel = document.createElement('label');
          generatedLabel.id = labelId;
          generatedLabel.className = 'fd-bcpo-a11y-label';
          generatedLabel.htmlFor = inputId;
          generatedLabel.dataset.fdBcpoA11yGenerated = 'true';
          wrapper.appendChild(generatedLabel);
          input.dataset.fdBcpoA11yLabelId = labelId;
        }
        generatedLabel.textContent = getBcpoRadioName(input, wrapper);
      });
      radioWrappers.forEach((wrapper) => {
        if (!wrapper.classList.contains('fd-bcpo-lining-flat')) return;
        const selector = wrapper.querySelector(':scope > .single-option-selector');
        if (!selector) {
          restoreFlatLiningTabs(wrapper);
          return;
        }
        const choices = Array.from(
          selector.querySelectorAll('.fd-bcpo-lining-flat-choice')
        );
        const liningInputs = Array.from(wrapper.querySelectorAll('input[type="radio"]'));
        if (!renderFlatLiningTabs(wrapper, selector, choices, liningInputs)) {
          restoreFlatLiningTabs(wrapper);
        }
      });
      if (usesRomanNeutralParityConfigurator) {
        const liningParentWrapper = Array.from(bcpoRoot.querySelectorAll('.selector-wrapper')).find((wrapper) => {
          const title = wrapper.querySelector('.bcpo-title') || wrapper.querySelector('.bcpo-label');
          return normalizeVoText(getReadableA11yText(title).replace(/:\s*$/, '')) === 'lining';
        });
        const neutralDetailExists = Array.from(bcpoRoot.querySelectorAll('.selector-wrapper')).some((wrapper) => {
          const title = wrapper.querySelector('.bcpo-title') || wrapper.querySelector('.bcpo-label');
          const isNeutralDetail = normalizeVoText(getReadableA11yText(title).replace(/:\s*$/, '')) === 'neutral lining';
          return isNeutralDetail && wrapper.querySelectorAll('input[type="radio"]').length > 0;
        });
        const neutralParentInput = liningParentWrapper
          ? Array.from(liningParentWrapper.querySelectorAll('input[type="radio"]')).find(
            (input) => normalizeVoText(input.value) === 'neutral lining'
          )
          : null;
        if (neutralParentInput) {
          const neutralParentChoice = neutralParentInput.closest('.bcpo-button-parent');
          if (!neutralDetailExists) {
            if (neutralParentInput.dataset.fdOrphanLiningParent !== 'true') {
              neutralParentInput.dataset.fdOrphanLiningWasRequired = neutralParentInput.required ? 'true' : 'false';
            }
            neutralParentInput.dataset.fdOrphanLiningParent = 'true';
            neutralParentInput.disabled = true;
            neutralParentInput.required = false;
            neutralParentChoice?.classList.add('fd-bcpo-orphan-lining-parent');
            if (neutralParentInput.checked) {
              neutralParentInput.checked = false;
              neutralParentInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
          } else if (neutralParentInput.dataset.fdOrphanLiningParent === 'true') {
            neutralParentInput.disabled = false;
            neutralParentInput.required = neutralParentInput.dataset.fdOrphanLiningWasRequired === 'true';
            delete neutralParentInput.dataset.fdOrphanLiningParent;
            delete neutralParentInput.dataset.fdOrphanLiningWasRequired;
            neutralParentChoice?.classList.remove('fd-bcpo-orphan-lining-parent');
          }
        }
        syncRomanNeutralTrimFlow(bcpoRoot);
      }
      radioWrappers.forEach((wrapper) => {
        if (wrapper === bcpoRoot) return;
        if (wrapper.classList.contains('fd-bcpo-lining-detail')) {
          const hasEnabledLiningChoice = Array.from(wrapper.querySelectorAll('input[type="radio"]'))
            .some((input) => !input.disabled);
          wrapper.classList.toggle('fd-bcpo-lining-detail--active', hasEnabledLiningChoice);
        }
        if (wrapper.classList.contains('fd-bcpo-image-detail')) {
          const hasEnabledImageChoice = Array.from(wrapper.querySelectorAll('input[type="radio"]'))
            .some((input) => !input.disabled);
          wrapper.classList.toggle('fd-bcpo-image-detail--active', hasEnabledImageChoice);
        }
        const titleNode = wrapper.querySelector('.bcpo-title')
          || wrapper.querySelector('.bcpo-label')
          || Array.from(wrapper.children || []).find((child) => child.tagName === 'LABEL' && !child.dataset.fdBcpoA11yGenerated);
        const groupName = getReadableA11yText(titleNode);
        if (!wrapper.hasAttribute('role')) wrapper.setAttribute('role', 'radiogroup');
        if (groupName && !wrapper.hasAttribute('aria-label') && !wrapper.hasAttribute('aria-labelledby')) {
          wrapper.setAttribute('aria-label', groupName);
        }
      });
    };
    root.querySelectorAll('.fd-bcpo-keyboard-focus').forEach((item) => {
      item.classList.remove('fd-bcpo-keyboard-focus');
    });
    const normalizeTopCurtainHelper = () => {
      const existingTopLinks = root.querySelector('.fd-pdp__badges > .fd-pdp-top-links');
      if (existingTopLinks) {
        const offer = existingTopLinks.querySelector('.fd-pdp-top-links__offer') ||
          Array.from(existingTopLinks.querySelectorAll('span')).find((item) => /NEW20/i.test(item.textContent || ''));
        if (offer) {
          offer.classList.add('fd-pdp-top-links__offer');
          offer.style.setProperty('display', 'inline', 'important');
          offer.style.setProperty('font-style', 'normal', 'important');
        }
        return;
      }

      const helper = root.querySelector('.fd-pdp__badges > .fd-pdp-ad-helper');
      if (!helper) return;
      const helperText = helper.textContent || '';
      if (!/Order fabric samples/i.test(helperText) || !/Measure curtains/i.test(helperText)) return;

      const makeLink = (href, label) => {
        const link = document.createElement('a');
        link.href = href;
        link.textContent = label;
        return link;
      };
      const makeSeparator = () => {
        const separator = document.createElement('span');
        separator.setAttribute('aria-hidden', 'true');
        separator.textContent = '/';
        return separator;
      };
      const discount = document.createElement('i');
      discount.className = 'fd-pdp-top-links__offer';
      discount.textContent = 'NEW20 saves 20%';
      discount.style.setProperty('display', 'inline', 'important');
      discount.style.setProperty('font-style', 'normal', 'important');

      helper.className = 'fd-pdp-top-links';
      helper.replaceChildren(
        makeLink('/pages/free-fabric-swatches#curtain-sample-books', 'Order Fabric Samples'),
        makeSeparator(),
        makeLink('/pages/measuring-instruction-for-drapery-curtains', 'Measure curtains'),
        makeSeparator(),
        discount
      );
    };

    normalizeTopCurtainHelper();

    const installInlineGuideLinks = () => {
      const isCurtainGuideProduct = /(curtain|drape|drapery|valance)/i.test(productHandle);
      if (!isCurtainGuideProduct) return;

      if (!document.getElementById('fd-inline-guide-pilot-style')) {
        const style = document.createElement('style');
        style.id = 'fd-inline-guide-pilot-style';
        style.textContent = `
          .fd-pdp[data-product-handle*="curtain"] .fd-pdp-order-helper,
          .fd-pdp[data-product-handle*="drape"] .fd-pdp-order-helper,
          .fd-pdp[data-product-handle*="drapery"] .fd-pdp-order-helper,
          .fd-pdp[data-product-handle*="valance"] .fd-pdp-order-helper { display: none !important; }
          .fd-pdp[data-product-handle*="curtain"] .fd-pdp-top-links,
          .fd-pdp[data-product-handle*="drape"] .fd-pdp-top-links,
          .fd-pdp[data-product-handle*="drapery"] .fd-pdp-top-links,
          .fd-pdp[data-product-handle*="valance"] .fd-pdp-top-links { display: none !important; }
          .fd-pdp-inline-guide-row { display: block; margin: 20px 0 10px; padding: 0; border: 0; background: transparent; }
          .fd-pdp-inline-guide-row--header { margin-top: 22px; }
          .fd-pdp-inline-guide-link { color: #7b4e36; font-size: 13px; font-weight: 400; line-height: 1.4; letter-spacing: 0; text-decoration: underline; text-underline-offset: 3px; text-transform: none; }
          .fd-pdp-inline-guide-link:hover { color: #4f2f20; }
          .fd-bcpo-color-title .fd-pdp-inline-guide-link { margin-left: 8px; }
          .fd-pdp-step-label .fd-pdp-inline-guide-link { margin-left: 8px; }
          body.fd-pdp-guide-modal-open { overflow: hidden; }
          .fd-pdp-guide-modal[hidden] { display: none !important; }
          .fd-pdp-guide-modal { position: fixed; inset: 0; z-index: 2147483000; display: flex; align-items: center; justify-content: center; padding: 24px; }
          .fd-pdp-guide-modal__backdrop { position: absolute; inset: 0; background: rgba(43, 34, 28, 0.46); }
          .fd-pdp-guide-modal__dialog { position: relative; width: min(720px, calc(100vw - 36px)); max-height: min(82vh, 760px); overflow: auto; background: #fffdf9; border: 1px solid #d8c8ba; box-shadow: 0 24px 70px rgba(43, 34, 28, 0.22); color: #2d211b; }
          .fd-pdp-guide-modal__close { position: absolute; top: 16px; right: 16px; width: 34px; height: 34px; border: 1px solid #d8c8ba; border-radius: 50%; background: #fffdf9; color: #4f2f20; font-size: 24px; line-height: 1; cursor: pointer; }
          .fd-pdp-guide-modal__inner { padding: 34px 38px 36px; }
          .fd-pdp-guide-modal__eyebrow { margin: 0 0 8px; color: #8a644d; font-size: 12px; letter-spacing: 0.08em; text-transform: uppercase; }
          .fd-pdp-guide-modal__title { margin: 0 44px 18px 0; color: #2d211b; font-size: 26px; line-height: 1.22; font-weight: 400; letter-spacing: 0; }
          .fd-pdp-guide-modal__body { display: grid; gap: 14px; color: #5b4a40; font-size: 15px; line-height: 1.65; }
          .fd-pdp-guide-modal__body p { margin: 0; }
          .fd-pdp-guide-modal__body h3,
          .fd-pdp-guide-modal__body h4 { margin: 8px 0 0; color: #2d211b; font-size: 18px; line-height: 1.35; font-weight: 400; letter-spacing: 0; }
          .fd-pdp-guide-modal__body h4 { font-size: 16px; color: #4f2f20; }
          .fd-pdp-guide-modal__body strong { color: #2d211b; font-weight: 500; }
          .fd-pdp-guide-modal__body a { color: #7b4e36; text-decoration: underline; text-underline-offset: 3px; }
          .fd-pdp-guide-modal__body img { display: block; width: min(100%, 460px); height: auto; margin: 6px 0 4px; border: 1px solid #eadfd5; background: #fff; }
          .fd-pdp-guide-modal__body img.fd-guide-image-loading { display: none !important; }
          .fd-pdp-guide-modal__body .fd-guide-panel { display: grid; gap: 10px; padding: 14px 0 2px; border-top: 1px solid #eadfd5; }
          .fd-pdp-guide-modal__body .fd-guide-note { color: #7e6a60; font-size: 14px; }
          .fd-pdp-guide-modal__body .fd-guide-formula { padding: 10px 12px; border-left: 3px solid #b8957f; background: #fbf7f1; color: #3f3028; }
          .fd-pdp-guide-modal__list { display: grid; gap: 10px; margin: 2px 0 0; padding: 0; list-style: none; }
          .fd-pdp-guide-modal__list li { position: relative; padding-left: 18px; }
          .fd-pdp-guide-modal__list li::before { content: ''; position: absolute; left: 0; top: 0.78em; width: 5px; height: 5px; border-radius: 50%; background: #b7947d; }
          .fd-pdp-guide-modal__actions { display: flex; flex-wrap: wrap; align-items: center; gap: 16px; margin-top: 24px; }
          .fd-pdp-guide-modal__actions[hidden] { display: none !important; }
          .fd-pdp-guide-modal__cta { display: inline-flex; align-items: center; justify-content: center; min-height: 42px; padding: 0 22px; border: 1px solid #5b3827; background: #5b3827; color: #fff !important; text-decoration: none; font-size: 13px; letter-spacing: 0.04em; text-transform: uppercase; }
          .fd-pdp-guide-modal__note { color: #8a7770; font-size: 13px; line-height: 1.5; }
          .fd-pdp #fd-pdp-description .fd-pdp-ad-helper { display: none !important; }
          .fd-pdp-description-option3 .fd-pdp-detail__facts,
          .fd-pdp-description-option3 .fd-pdp-detail__intro { display: none !important; }
          .fd-pdp-description-option3__intro { max-width: 650px; margin: 22px 0 30px !important; color: #5f554f !important; font-size: 15px !important; line-height: 1.62 !important; }
          .fd-pdp-description-option3__summary { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 22px 28px; max-width: 650px; margin: 0 0 52px; padding: 24px 0 25px; border-top: 1px solid #e3d9cf; border-bottom: 1px solid #e3d9cf; }
          .fd-pdp-description-option3__item { min-width: 0; }
          .fd-pdp-description-option3__label { display: block; margin: 0 0 8px; color: #75685f; font-size: 11px; font-weight: 400; line-height: 1.2; letter-spacing: 0.04em; text-transform: uppercase; }
          .fd-pdp-description-option3__value { display: block; color: #2f251f; font-size: 15px; line-height: 1.35; }
          .fd-pdp-description-option3__help { display: flex; flex-wrap: wrap; gap: 10px 18px; align-items: baseline; max-width: 650px; margin: 32px 0 0; padding: 20px 0 0; border-top: 1px solid #e3d9cf; color: #2f251f; font-size: 14px; line-height: 1.5; }
          .fd-pdp-description-option3__help strong { color: #2f251f; font-weight: 700; }
          .fd-pdp-description-option3__help .fd-pdp-inline-guide-link { font-size: 14px; }
          .fd-pdp-description-option3__sep { color: #9a8a7f; }
          @media (max-width: 768px) {
            .fd-pdp-inline-guide-row { margin: 16px 0 9px; }
            .fd-bcpo-color-title .fd-pdp-inline-guide-link,
            .fd-pdp-step-label .fd-pdp-inline-guide-link { display: inline-block; margin-left: 0; margin-top: 5px; }
            .fd-pdp-description-option3__summary { grid-template-columns: 1fr; gap: 18px; margin-bottom: 38px; padding: 20px 0; }
            .fd-pdp-description-option3__help { display: grid; gap: 8px; }
            .fd-pdp-guide-modal { align-items: flex-end; padding: 14px; }
            .fd-pdp-guide-modal__dialog { width: 100%; max-height: 86vh; }
            .fd-pdp-guide-modal__inner { padding: 28px 22px 28px; }
            .fd-pdp-guide-modal__title { font-size: 22px; }
            .fd-pdp-guide-modal__actions { align-items: stretch; flex-direction: column; }
            .fd-pdp-guide-modal__cta { width: 100%; }
          }
        `;
        document.head.appendChild(style);
      }

      const guideModalContent = {
        samples: {
          eyebrow: 'Fabric Samples',
          title: 'Compare Fabric Samples',
          html: `
            <p><a href="/pages/free-fabric-swatches#curtain-sample-books">Browse Curtain Fabric Sample Books &gt;</a></p>
            <h3>Why compare Fabric Samples?</h3>
            <p>Fabric color, texture, opacity, and weight can look different from screen to room. Fabric Samples help you compare the real material beside your wall color, flooring, trim, and furniture before placing a custom order.</p>
            <p>Use a Sample Book to review coordinated colors in natural light and evening light, then choose the best option for your window treatment.</p>
          `
        },
        'header-styles': {
          eyebrow: 'Header styles',
          title: 'Hanging Header Style',
          html: `
            <p><a href="/pages/header-style">Click here to know more about Hanging Header Style</a></p>
          `
        },
        measurement: {
          eyebrow: 'Measurement guide',
          title: 'Measurement Guide',
          html: `
            <p><a href="/pages/measuring-instruction-for-drapery-curtains">Measurement Finder &gt;</a></p>
            <h3>Step 1: Measure the Width</h3>
            <p>If you have already installed the rod or track, measure the rod or track length and record the finished width.</p>
            <p>If the rod is not installed yet, decide where it will mount above and beyond the window frame. Most curtain rods sit 6-10 inches above the window frame and extend 6-15 inches past each side so the panels can stack neatly.</p>
            <img src="https://cdn.shopify.com/s/files/1/0863/4200/9130/files/c6d0b9e663c71dbf63c9842af7790f1.png?v=1733125694" alt="Curtain rod width measuring guide">
            <div class="fd-guide-panel">
              <h3>Step 2: Determine the Curtain Panel Width</h3>
              <p>For pleated headers such as Pinch Pleat, Tailor Pleat, Triple Tailor Pleat, Tape Pleat, Pinch Pleat with Back Tab, and French Pleat, calculate panel width from the rod or track width and desired fullness.</p>
              <p class="fd-guide-formula">Per Panel Width = Rod or track width x Pleat Fullness / Panel Quantity</p>
              <p>Common fullness choices: 1x, 1.5x, and 2x.</p>
            </div>
            <div class="fd-guide-panel">
              <h3>Step 3: Determine the Curtain Panel Length</h3>
              <p>For pleated curtains, measure from the curtain top position to the floor, then add the desired bottom finish. Choose the length style before entering custom sizes.</p>
            </div>
          `
        },
        lining: {
          eyebrow: 'Lining guide',
          title: 'Liner and shading rate',
          html: `
            <p><a href="/pages/instructions-about-the-liner">Click to Know How to Select Liners</a></p>
            <img src="https://cdn.shopify.com/s/files/1/0863/4200/9130/files/7hf8r4-_1_-ymq.png" alt="Curtain liner shading comparison">
            <h3>Recommended to You</h3>
            <div class="fd-guide-panel">
              <h4>Natural Lining</h4>
              <p><strong>Cotton 117 gsm:</strong> Made from 100% natural cotton. It keeps a soft, eco-friendly hand feel while offering about 70%-85% shading.</p>
              <p><strong>Belgian Flax 100%:</strong> Made from 100% European flax with a premium natural texture. It offers about 70%-80% shading and a sustainable feel.</p>
            </div>
            <div class="fd-guide-panel">
              <h4>Blackout Lining</h4>
              <p><strong>Premium Woven Blackout 350 gsm:</strong> An 80% polyester and 20% cotton blend that blocks over 90% of light through physical blackout construction, without chemical coating.</p>
            <img src="https://cdn.shopify.com/s/files/1/0863/4200/9130/files/1210p95-__17657682115587-ymq.png" alt="Premium woven blackout liner Fabric Sample">
              <img src="https://cdn.shopify.com/s/files/1/0863/4200/9130/files/jnwjst-blackout_-ymq.webp" alt="Blackout curtain liner light control example">
              <p class="fd-guide-note"><strong>Attention:</strong> If a stitched shade or curtain style uses blackout lining, tiny stitch points may be visible in strong light. Choose the style and lining level that best matches your room needs.</p>
            </div>
          `
        }
      };

      const ensureGuideModal = () => {
        let modal = document.getElementById('fd-pdp-guide-modal');
        if (modal) return modal;

        modal = document.createElement('div');
        modal.id = 'fd-pdp-guide-modal';
        modal.className = 'fd-pdp-guide-modal';
        modal.hidden = true;
        modal.setAttribute('role', 'dialog');
        modal.setAttribute('aria-modal', 'true');
        modal.setAttribute('aria-hidden', 'true');
        modal.innerHTML = `
          <div class="fd-pdp-guide-modal__backdrop" data-fd-guide-close></div>
          <div class="fd-pdp-guide-modal__dialog" role="document">
            <button class="fd-pdp-guide-modal__close" type="button" aria-label="Close" data-fd-guide-close>&times;</button>
            <div class="fd-pdp-guide-modal__inner">
              <p class="fd-pdp-guide-modal__eyebrow"></p>
              <h2 class="fd-pdp-guide-modal__title"></h2>
              <div class="fd-pdp-guide-modal__body"></div>
              <div class="fd-pdp-guide-modal__actions">
                <a class="fd-pdp-guide-modal__cta"></a>
                <span class="fd-pdp-guide-modal__note"></span>
              </div>
            </div>
          </div>
        `;
        document.body.appendChild(modal);
        return modal;
      };

      const closeGuideModal = () => {
        const modal = document.getElementById('fd-pdp-guide-modal');
        if (!modal) return;
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('fd-pdp-guide-modal-open');
      };

      const openGuideModal = (key) => {
        const config = guideModalContent[key];
        if (!config) return false;

        const modal = ensureGuideModal();
        const body = modal.querySelector('.fd-pdp-guide-modal__body');
        if (config.html) {
          body.innerHTML = config.html;
          body.querySelectorAll('img').forEach((image) => {
            const revealImage = () => image.classList.remove('fd-guide-image-loading');
            const removeImage = () => image.remove();
            image.loading = 'eager';
            image.decoding = 'async';
            image.classList.add('fd-guide-image-loading');
            image.addEventListener('load', revealImage, { once: true });
            image.addEventListener('error', removeImage, { once: true });
            if (image.complete && image.naturalWidth > 0) revealImage();
          });
        } else {
          const list = document.createElement('ul');
          list.className = 'fd-pdp-guide-modal__list';
          (config.items || []).forEach((item) => {
            const li = document.createElement('li');
            li.textContent = item;
            list.appendChild(li);
          });

          body.replaceChildren(
            ...(config.body || []).map((copy) => {
              const paragraph = document.createElement('p');
              paragraph.textContent = copy;
              return paragraph;
            }),
            list
          );
        }
        modal.querySelector('.fd-pdp-guide-modal__eyebrow').textContent = config.eyebrow;
        modal.querySelector('.fd-pdp-guide-modal__title').textContent = config.title;
        const actions = modal.querySelector('.fd-pdp-guide-modal__actions');
        const cta = modal.querySelector('.fd-pdp-guide-modal__cta');
        const note = modal.querySelector('.fd-pdp-guide-modal__note');
        if (config.cta && config.href) {
          actions.hidden = false;
          cta.href = config.href;
          cta.textContent = config.cta;
          note.textContent = config.note || '';
        } else {
          actions.hidden = true;
          cta.removeAttribute('href');
          cta.textContent = '';
          note.textContent = '';
        }
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('fd-pdp-guide-modal-open');
        window.setTimeout(() => modal.querySelector('.fd-pdp-guide-modal__close')?.focus(), 0);
        return true;
      };

      if (!document.documentElement.dataset.fdInlineGuideModalBound) {
        document.documentElement.dataset.fdInlineGuideModalBound = 'true';
        document.addEventListener('click', (event) => {
          const closeTarget = event.target.closest('[data-fd-guide-close]');
          if (closeTarget) {
            event.preventDefault();
            closeGuideModal();
            return;
          }

          const link = event.target.closest('[data-fd-inline-guide]');
          const guideKey = link && link.dataset ? link.dataset.fdInlineGuide : '';
          if (!guideKey) return;
          if (openGuideModal(guideKey)) {
            event.preventDefault();
          }
        });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') closeGuideModal();
        });
      }

      root.querySelectorAll('.fd-pdp-order-helper').forEach((helper) => {
        helper.hidden = true;
        helper.style.setProperty('display', 'none', 'important');
      });
      root.querySelectorAll('.fd-pdp-top-links').forEach((links) => {
        links.hidden = true;
        links.style.setProperty('display', 'none', 'important');
      });

      const makeInlineLink = (href, label, key) => {
        const link = document.createElement('a');
        link.className = 'fd-pdp-inline-guide-link fd-pdp-inline-guide-link--generated';
        link.href = href;
        link.dataset.fdInlineGuide = key;
        link.setAttribute('aria-haspopup', 'dialog');
        link.textContent = label;
        return link;
      };

      const inlineGuideLabels = {
        samples: 'Fabric Samples',
        'header-styles': 'Header guide',
        measurement: 'Measuring guide',
        lining: 'Lining guide'
      };

      const normalizeInlineGuideLinks = () => {
        root.querySelectorAll('[data-fd-inline-guide]').forEach((link) => {
          const key = link.dataset ? link.dataset.fdInlineGuide : '';
          const label = inlineGuideLabels[key];
          if (!label) return;
          link.textContent = label;
          link.setAttribute('aria-haspopup', 'dialog');
          link.classList.add('fd-pdp-inline-guide-link');
        });
      };

      const installDescriptionOption3Pilot = () => {
        if (!/(curtain|drape|drapery|valance)/i.test(productHandle)) return;

        const panel = root.querySelector('#fd-pdp-description') || document.getElementById('fd-pdp-description');
        const copy = panel && panel.querySelector('.fd-pdp-detail__copy');
        if (!copy) return;

        copy.classList.add('fd-pdp-description-option3');
        panel.querySelectorAll('.fd-pdp-ad-helper').forEach((helper) => {
          helper.hidden = true;
          helper.style.setProperty('display', 'none', 'important');
        });

        if (copy.querySelector('.fd-pdp-description-option3__summary')) return;

        const cleanText = (value) => String(value || '')
          .replace(/\s+/g, ' ')
          .trim();
        const normalizeLabel = (value) => String(value || '')
          .replace(/:$/, '')
          .trim()
          .toLowerCase();
        const facts = copy.querySelector('.fd-pdp-detail__facts');
        const intro = copy.querySelector('.fd-pdp-detail__intro');
        const heading = copy.querySelector('h2');
        const factMap = new Map();

        if (facts) {
          facts.querySelectorAll('p').forEach((paragraph) => {
            const strong = paragraph.querySelector('strong');
            if (!strong) return;
            const label = normalizeLabel(strong.textContent);
            const value = cleanText(paragraph.textContent.replace(strong.textContent || '', ''));
            if (label && value) factMap.set(label, value);
          });
        }

        const descriptionText = cleanText(intro && intro.textContent) ||
          'Sedge linen curtains are made for light control, privacy, and soft layered rooms. The fabric has a warm, natural texture with a simple palette that works across modern, minimalist, and farmhouse interiors.';
        const introNode = document.createElement('p');
        introNode.className = 'fd-pdp-description-option3__intro';
        introNode.textContent = descriptionText;

        const summaryItems = [
          ['STYLE / FAMILY', factMap.get('style / color family') || 'Sedge'],
          ['COLOR RANGE', (factMap.get('color range') || '49 coordinated colors').replace(/\s+from the .+$/i, '')],
          ['MATERIAL', factMap.get('material') || '50% cotton / 50% polyester']
        ].filter((item) => item[1]);

        const summary = document.createElement('div');
        summary.className = 'fd-pdp-description-option3__summary';
        summaryItems.forEach(([label, value]) => {
          const item = document.createElement('div');
          item.className = 'fd-pdp-description-option3__item';
          const labelNode = document.createElement('span');
          labelNode.className = 'fd-pdp-description-option3__label';
          labelNode.textContent = label;
          const valueNode = document.createElement('span');
          valueNode.className = 'fd-pdp-description-option3__value';
          valueNode.textContent = value;
          item.append(labelNode, valueNode);
          summary.appendChild(item);
        });

        if (heading) {
          heading.insertAdjacentElement('afterend', summary);
          heading.insertAdjacentElement('afterend', introNode);
        } else {
          copy.prepend(summary);
          copy.prepend(introNode);
        }

        const featureHeading = Array.from(copy.querySelectorAll('h3'))
          .find((item) => /features/i.test(item.textContent || ''));
        const featureList = featureHeading && featureHeading.nextElementSibling && featureHeading.nextElementSibling.matches('ul')
          ? featureHeading.nextElementSibling
          : copy.querySelector('ul');
        if (featureList && !copy.querySelector('.fd-pdp-description-option3__help')) {
          const help = document.createElement('div');
          help.className = 'fd-pdp-description-option3__help';
          const label = document.createElement('strong');
          label.textContent = 'Need help?';
          const sep = () => {
            const span = document.createElement('span');
            span.className = 'fd-pdp-description-option3__sep';
            span.textContent = '/';
            return span;
          };
          help.append(
            label,
            makeInlineLink('/pages/free-fabric-swatches#curtain-sample-books', 'Browse Sample Books >', 'samples'),
            sep(),
            makeInlineLink('/pages/measuring-instruction-for-drapery-curtains', 'Measure guide >', 'measurement')
          );
          featureList.insertAdjacentElement('afterend', help);
        }
      };

      root.querySelectorAll('.fd-pdp-top-links a').forEach((link) => {
        const href = link.getAttribute('href') || '';
        if (/free-fabric-swatches/i.test(href)) {
          link.dataset.fdInlineGuide = 'samples';
          link.setAttribute('aria-haspopup', 'dialog');
        }
        if (/measuring-instruction-for-drapery-curtains/i.test(href)) {
          link.dataset.fdInlineGuide = 'measurement';
          link.setAttribute('aria-haspopup', 'dialog');
        }
      });
      normalizeInlineGuideLinks();

      const colorTitle = root.querySelector('.fd-bcpo-color-title label, .fd-bcpo-color-title .bcpo-title, .fd-bcpo-color-title');
      if (colorTitle && !colorTitle.querySelector('[data-fd-inline-guide="samples"]')) {
        colorTitle.append(' ');
        colorTitle.append(makeInlineLink('/pages/free-fabric-swatches#curtain-sample-books', 'Fabric samples', 'samples'));
      }

      const nativeOptionWrappers = Array.from(root.querySelectorAll('#bcpo .selector-wrapper, .selector-wrapper.bcpo-simple'));
      const nativeOptionTitle = (wrapper) => wrapper && wrapper.querySelector('.bcpo-title');
      const setNativeOptionLabel = (wrapper, labelText, guide) => {
        if (!usesNativeBcpoOnly || !wrapper) return;
        const title = nativeOptionTitle(wrapper);
        if (title && title.textContent !== labelText) title.textContent = labelText;
        const label = wrapper.querySelector('.bcpo-label');
        if (guide && label && !label.querySelector(`[data-fd-inline-guide="${guide.key}"]`)) {
          label.append(' ');
          label.append(makeInlineLink(guide.href, guide.label, guide.key));
        }
      };

      const headerWrapper = nativeOptionWrappers
        .find((item) => /Hanging Header Style|Header Style/i.test(item.textContent || ''));
      if (usesNativeBcpoOnly && headerWrapper) {
        setNativeOptionLabel(headerWrapper, 'Header style (hooks included)', {
          href: '/pages/header-style', label: 'Header guide', key: 'header-styles'
        });
      } else if (headerWrapper && !root.querySelector('[data-fd-inline-guide="header-styles"]')) {
        const row = document.createElement('div');
        row.className = 'fd-pdp-inline-guide-row fd-pdp-inline-guide-row--header';
        row.append(makeInlineLink('/pages/header-style', 'Header styles', 'header-styles'));
        headerWrapper.parentNode.insertBefore(row, headerWrapper);
      }

      if (usesNativeBcpoOnly) {
        const widthWrapper = nativeOptionWrappers.find((item) => /Width/i.test(nativeOptionTitle(item)?.textContent || ''));
        const lengthWrapper = nativeOptionWrappers.find((item) => /Length|Height/i.test(nativeOptionTitle(item)?.textContent || ''));
        const liningWrapper = nativeOptionWrappers.find((item) => /Lining|Liner/i.test(nativeOptionTitle(item)?.textContent || ''));
        const memoryWrapper = nativeOptionWrappers.find((item) => /Memory/i.test(nativeOptionTitle(item)?.textContent || ''));
        const tiebackWrapper = nativeOptionWrappers.find((item) => /Tieback|Tie back/i.test(nativeOptionTitle(item)?.textContent || ''));
        setNativeOptionLabel(widthWrapper, 'Finished width per panel (in.)', {
          href: '/pages/measuring-instruction-for-drapery-curtains', label: 'Measuring guide', key: 'measurement'
        });
        setNativeOptionLabel(lengthWrapper, 'Finished length per panel (in.)');
        setNativeOptionLabel(liningWrapper, 'Lining', {
          href: '/pages/instructions-about-the-liner', label: 'Lining guide', key: 'lining'
        });
        setNativeOptionLabel(memoryWrapper, 'Memory shaping');
        setNativeOptionLabel(tiebackWrapper, 'Matching tieback');
      }

      const customPanel = root.querySelector('.fd-pdp-custom');
      const sizeLegend = Array.from(root.querySelectorAll('legend.fd-pdp-step-label'))
        .find((item) => {
          const labelText = (item.querySelector('span')?.textContent || item.textContent || '').trim();
          return /^Size$/i.test(labelText) || /\bSize\b/i.test(labelText);
        });
      if (customPanel && sizeLegend && !root.querySelector('.fd-pdp-inline-guide-link[data-fd-inline-guide="measurement"]')) {
        const sizeFieldset = sizeLegend.closest('fieldset');
        if (sizeFieldset && sizeFieldset.parentNode) {
          const row = document.createElement('div');
          row.className = 'fd-pdp-inline-guide-row fd-pdp-inline-guide-row--measurement';
          row.append(makeInlineLink('/pages/measuring-instruction-for-drapery-curtains', 'Measuring guide', 'measurement'));
          sizeFieldset.parentNode.insertBefore(row, sizeFieldset);
        }
      }

      const liningLegend = Array.from(root.querySelectorAll('legend.fd-pdp-step-label'))
        .find((item) => /Lining/i.test(item.textContent || ''));
      if (liningLegend && !liningLegend.querySelector('[data-fd-inline-guide="lining"]')) {
        const label = liningLegend.querySelector('span');
        if (label && /Lining and Edge Binding/i.test(label.textContent || '')) {
          label.textContent = 'Lining';
        }
        liningLegend.append(' ');
        liningLegend.append(makeInlineLink('/pages/instructions-about-the-liner', 'Lining guide', 'lining'));
      }

      installDescriptionOption3Pilot();
      normalizeInlineGuideLinks();
    };

    installInlineGuideLinks();
    window.setTimeout(installInlineGuideLinks, 300);
    window.setTimeout(installInlineGuideLinks, 1200);
    window.setTimeout(installInlineGuideLinks, 2600);
    let inlineGuideAttemptCount = 0;
    const retryInlineGuideLinks = () => {
      inlineGuideAttemptCount += 1;
      installInlineGuideLinks();
      if (inlineGuideAttemptCount < 20) window.setTimeout(retryInlineGuideLinks, 700);
    };
    window.setTimeout(retryInlineGuideLinks, 500);

    const installJennaBcpoPriceFallback = () => {
      const targetHandles = new Set([
        'custom-light-filtering-roman-shade',
        'custom-white-linen-plain-fold-roman-shade',
        'custom-textured-sheer-roman-shade',
        'roman-shade-blind'
      ]);
      const targetProductIds = new Set(['9238055649530', '9238055780602', '9238055059706', '8549981946106']);
      const productHandle = String(root.dataset.productHandle || '').trim();
      const isTarget = () => {
        const data = window.bcpo_data || {};
        return targetHandles.has(productHandle) || targetProductIds.has(String(data.product_id || ''));
      };
      if (!isTarget()) return null;

      const normalizeOptionText = (value) => String(value || '')
        .replace(/\s+\|\s*[-+]?[$€£]?\s*[\d,.]+.*$/i, '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
      const parseAddonPrice = (value) => {
        const number = Number(String(value || '').replace(/[^-\d.]/g, ''));
        return Number.isFinite(number) ? number : 0;
      };
      const optionTitleFromControl = (control) => {
        const match = String(control && control.name ? control.name : '').match(/^properties\[(.+)\]$/);
        if (match) return match[1];
        const indexedMatch = String(control && control.name ? control.name : '').match(/^name(\d+)$/);
        if (indexedMatch) {
          const indexedOption = getBcpoOptions()[Number(indexedMatch[1])];
          if (indexedOption && indexedOption.title) return indexedOption.title;
        }
        const wrapper = control && control.closest ? control.closest('#bcpo .selector-wrapper') : null;
        const label = wrapper && (wrapper.querySelector('.bcpo-label, .bcpo-title, label') || wrapper);
        return label ? label.textContent : '';
      };
      const getBcpoOptions = () => {
        const data = window.bcpo_data || {};
        return Array.isArray(data.virtual_options) ? data.virtual_options : [];
      };
      const findBcpoValue = (title, value) => {
        const option = getBcpoOptions().find((item) => normalizeOptionText(item && item.title) === normalizeOptionText(title));
        if (!option || !Array.isArray(option.values)) return null;
        const wanted = normalizeOptionText(value);
        return option.values.find((item) => normalizeOptionText(item && item.key) === wanted) || null;
      };
      const getSelectedValue = (control) => {
        if (!control) return '';
        if (control.tagName === 'SELECT') {
          const selected = control.options && control.selectedIndex >= 0 ? control.options[control.selectedIndex] : null;
          return selected ? (selected.value || selected.textContent) : control.value;
        }
        return control.value;
      };
      const getSelectedControls = () => Array.from(document.querySelectorAll('#bcpo input:checked, #bcpo select, #bcpo textarea'))
        .filter((control) => !control.disabled && !control.closest('[hidden], .fd-bcpo-force-hidden'));
      const getBaseVariantPrice = () => {
        const currentId = variantInput ? String(variantInput.value || '') : '';
        const variant = variants.find((item) => String(item.id) === currentId) || variants[0] || {};
        return Number(variant.price || 0);
      };
      const getAddonTotalCents = () => getSelectedControls().reduce((sum, control) => {
        const match = findBcpoValue(optionTitleFromControl(control), getSelectedValue(control));
        const priceValue = parseAddonPrice(match && match.price);
        return sum + Math.round(priceValue * 100);
      }, 0);
      const updateDisplay = () => {
        const total = getBaseVariantPrice() + getAddonTotalCents();
        if (price) price.textContent = formatMoney(total);
        if (stickyPrice) stickyPrice.textContent = formatMoney(total);
      };
      const prepareProperties = () => {
        if (window.bcpo && window.bcpo.$) return;
        getSelectedControls().forEach((control) => {
          if (!control || control.tagName === 'TEXTAREA' || String(control.type || '').toLowerCase() === 'file') return;
          const match = findBcpoValue(optionTitleFromControl(control), getSelectedValue(control));
          const priceValue = parseAddonPrice(match && match.price);
          if (!priceValue) return;
          const baseValue = String(getSelectedValue(control) || '').replace(/\s+\|\s*[-+]?[$€£]?\s*[\d,.]+.*$/i, '').trim();
          const suffixedValue = `${baseValue} | $${priceValue.toFixed(2)}`;
          if (control.tagName === 'SELECT') {
            const selected = control.options && control.selectedIndex >= 0 ? control.options[control.selectedIndex] : null;
            if (selected) selected.value = suffixedValue;
          } else {
            control.value = suffixedValue;
          }
        });
      };

      if (form) form.addEventListener('submit', prepareProperties, true);
      root.addEventListener('click', (event) => {
        const target = event.target && event.target.closest ? event.target : null;
        if (target && target.closest('[data-fd-atc], [data-fd-sticky-submit]')) prepareProperties();
        window.setTimeout(updateDisplay, 40);
      }, true);
      root.addEventListener('change', () => window.setTimeout(updateDisplay, 40), true);
      root.addEventListener('input', () => window.setTimeout(updateDisplay, 40), true);
      window.setTimeout(updateDisplay, 800);
      window.setTimeout(updateDisplay, 1800);
      return { updateDisplay, prepareProperties };
    };

    // Pricing is owned by fd-pdp-p0-20260710.js. Keep the legacy helper
    // definition for rollback compatibility, but never install its fuzzy,
    // fail-open price suffix fallback.
    const jennaBcpoPriceFallback = null;

    root.querySelectorAll('[data-fd-option-position]').forEach((group) => {
      const position = Number(group.dataset.fdOptionPosition || '1') - 1;
      const selected = group.querySelector('[data-fd-option-value].is-selected') || group.querySelector('[data-fd-option-value]');
      selectedOptions[position] = selected ? selected.dataset.optionValue : '';
    });

    const colorImageMap = new Map();
    const colorThumbnailMap = new Map();
    const productColorImageMap = new Map();
    thumbs.forEach((thumb) => {
      if (isBrandedJ401SwatchMedia(thumb.dataset.full)) return;
      addColorImageKey(productColorImageMap, thumb.dataset.alt, thumb.dataset.full);
      addColorImageKey(productColorImageMap, getGeneratedMediaColorKey(thumb.dataset.alt), thumb.dataset.full, true);
      addColorImageKey(productColorImageMap, getGeneratedMediaColorKey(thumb.dataset.group), thumb.dataset.full, true);
    });

    const refreshThemeColorImages = () => {
      const themeMapJson = root.querySelector('[data-fd-theme-color-images]');
      if (!themeMapJson) return;
      let themeMap = {};
      try {
        themeMap = JSON.parse(themeMapJson.textContent || '{}');
      } catch (error) {
        themeMap = {};
      }

      Object.keys(themeMap).forEach((key) => {
        addColorImageKey(colorImageMap, key, themeMap[key], true);
      });
    };

    const refreshBcpoColorImages = () => {
      const fullSources = [];
      const thumbnailSources = [];
      const bcpoData = window.bcpo_data;
      const fullBcpoData = window.__fdVoFullData || bcpoData;
      const bcpoProduct = window.bcpo_product;
      if (fullBcpoData && Array.isArray(fullBcpoData.virtual_options)) fullSources.push(fullBcpoData.virtual_options);
      if (bcpoProduct && Array.isArray(bcpoProduct.options)) fullSources.push(bcpoProduct.options);
      if (bcpoData && Array.isArray(bcpoData.virtual_options)) thumbnailSources.push(bcpoData.virtual_options);
      if (bcpoProduct && Array.isArray(bcpoProduct.options)) thumbnailSources.push(bcpoProduct.options);

      fullSources.forEach((options) => {
        options.forEach((option) => {
          const title = String(option && option.title ? option.title : '').toLowerCase();
          const type = String(option && option.type ? option.type : '').toLowerCase();
          if (type !== 'images' || !title.includes('color') || !Array.isArray(option.values)) return;
          option.values.forEach((item) => addColorImageKey(colorImageMap, item && item.key, item && item.value));
        });
      });

      thumbnailSources.forEach((options) => {
        options.forEach((option) => {
          const title = String(option && option.title ? option.title : '').toLowerCase();
          const type = String(option && option.type ? option.type : '').toLowerCase();
          if (type !== 'images' || !title.includes('color') || !Array.isArray(option.values)) return;
          option.values.forEach((item) => addColorImageKey(colorThumbnailMap, item && item.key, item && item.value, false, false));
        });
      });
    };

    refreshBcpoColorImages();
    refreshThemeColorImages();

    const getBcpoColorOptionIndexes = () => {
      const indexes = new Set();
      const sources = [];
      const bcpoData = window.bcpo_data;
      const bcpoProduct = window.bcpo_product;
      if (bcpoData && Array.isArray(bcpoData.virtual_options)) sources.push(bcpoData.virtual_options);
      if (bcpoProduct && Array.isArray(bcpoProduct.options)) sources.push(bcpoProduct.options);

      sources.forEach((options) => {
        options.forEach((option, index) => {
          const title = String(option && option.title ? option.title : '').toLowerCase();
          const type = String(option && option.type ? option.type : '').toLowerCase();
          if (type === 'images' && (title.includes('color') || title.includes('colour') || title.includes('fabric'))) {
            indexes.add(index);
          }
        });
      });

      return indexes;
    };

    const getColorImage = (label) => {
      refreshBcpoColorImages();
      refreshThemeColorImages();
      return findImageByLabel(colorImageMap, label);
    };

    const getColorThumbnail = (label) => {
      refreshBcpoColorImages();
      return findImageByLabel(colorThumbnailMap, label);
    };

    const getProductColorImage = (label) => {
      return findImageByLabel(productColorImageMap, label);
    };

    const getCssBackgroundUrl = (element) => {
      if (!element || !window.getComputedStyle) return '';
      const background = window.getComputedStyle(element).backgroundImage || '';
      const match = background.match(/url\(["']?([^"')]+)["']?\)/);
      return match ? match[1] : '';
    };

    const isSceneColorSwatchImage = (src) => {
      const value = String(src || '').toLowerCase();
      return value.includes('roman-shade-color-')
        || value.includes('custom-roman-shade-color')
        || value.includes('relaxed-custom-roman-shade-color')
        || value.includes('cafe-curtain')
        || value.includes('cafe-style');
    };

    const canUseSwatchImageAsMain = (src) => {
      const value = String(src || '').toLowerCase();
      if (!value || value.includes('d17fzo7x83uajt.cloudfront.net')) return false;
      const isMadeBlackCurtainScene = productHandle === 'made-black-100-blackout-curtains'
        && (
          value.includes('blackoutcurtain-browser-')
          || value.includes('fd-g004-blackoutcurtain-')
        );
      return isSceneColorSwatchImage(value) || isMadeBlackCurtainScene;
    };

    const isBcpoColorTitle = (value) => {
      const title = String(value || '').toLowerCase();
      return title.includes('color') || title.includes('colour') || title.includes('fabric');
    };

    const getBcpoWrapperTitle = (wrapper) => {
      if (!wrapper) return '';
      const titleLabel = wrapper.querySelector('.bcpo-title, .bcpo-label label') || Array.from(wrapper.children || []).find((child) => child.tagName === 'LABEL');
      return titleLabel ? titleLabel.textContent : (wrapper.getAttribute('data-title') || wrapper.getAttribute('aria-label') || '');
    };

    const getBcpoWrapperIndex = (wrapper) => {
      const dataOption = wrapper ? (wrapper.getAttribute('data-option') || '') : '';
      const dataOptionMatch = dataOption.match(/^option(\d+)$/);
      return dataOptionMatch ? Number(dataOptionMatch[1]) - 1 : -1;
    };

    const isBcpoColorWrapper = (wrapper, colorIndexes) => {
      if (!wrapper) return false;
      if (isBcpoColorTitle(getBcpoWrapperTitle(wrapper))) return true;
      if (isColorInputName(wrapper.querySelector('input, select'))) return true;
      const index = getBcpoWrapperIndex(wrapper);
      return index >= 0 && colorIndexes.has(index);
    };

    const applyBcpoChoiceImage = (element, src) => {
      if (!element || !src) return;
      const imageSrc = optimizeVoImages ? String(src) : expandBcpoImageUrl(src);
      const useSceneCrop = isSceneColorSwatchImage(imageSrc);
      const useFabricOnlyCrop = !useSceneCrop
        && imageSrc.toLowerCase().includes('fredesigner-')
        && imageSrc.toLowerCase().includes('j401-');
      element.style.backgroundImage = `url("${imageSrc.replace(/"/g, '\\"')}")`;
      element.style.backgroundRepeat = 'no-repeat';
      const backgroundPosition = useSceneCrop ? '50% 35%' : (useFabricOnlyCrop ? '50% 14%' : 'center');
      const backgroundSize = useSceneCrop ? '260% 260%' : (useFabricOnlyCrop ? '180% 180%' : 'cover');
      if (element.style.setProperty) {
        element.style.setProperty('background-position', backgroundPosition, 'important');
        element.style.setProperty('background-size', backgroundSize, 'important');
      } else {
        element.style.backgroundPosition = backgroundPosition;
        element.style.backgroundSize = backgroundSize;
      }
      element.classList.toggle('fd-bcpo-scene-color-label', useSceneCrop);
      element.classList.toggle('fd-bcpo-fabric-only-color-label', useFabricOnlyCrop);
      const parent = element.closest && element.closest('#bcpo .bcpo-image-parent, #bcpo .bcpo-color-parent');
      if (parent) parent.classList.toggle('fd-bcpo-scene-color-choice', useSceneCrop);
      if (parent) parent.classList.toggle('fd-bcpo-fabric-only-color-choice', useFabricOnlyCrop);
    };

    root.querySelectorAll('[data-fd-media-swatch]').forEach((swatch) => {
      if (swatch.dataset.image) return;
      const swatchImage = getColorImage(swatch.dataset.label || swatch.dataset.alt);
      if (swatchImage) swatch.dataset.image = swatchImage;
    });

    const validatedMainImageSources = new Set();
    const failedMainImageSources = new Set();
    const pendingMainImageLoads = new Map();
    let mainImageRequestRevision = 0;
    let lastKnownGoodMainImageSrc = '';
    let lastKnownGoodMainImageAlt = '';
    let restoringLastKnownGoodMainImage = false;

    const getCurrentMainImageSrc = () => {
      if (!mainImage) return '';
      return normalizeMainImageUrl(
        mainImage.currentSrc
        || mainImage.getAttribute('src')
        || mainImage.src
        || ''
      );
    };

    const rememberKnownGoodMainImage = () => {
      if (
        !mainImage
        || !mainImage.complete
        || Number(mainImage.naturalWidth || 0) <= 0
      ) {
        return false;
      }
      const currentSrc = getCurrentMainImageSrc();
      if (!currentSrc) return false;
      lastKnownGoodMainImageSrc = currentSrc;
      lastKnownGoodMainImageAlt = mainImage.alt || '';
      validatedMainImageSources.add(currentSrc);
      failedMainImageSources.delete(currentSrc);
      return true;
    };

    const commitMainImage = (normalizedSrc, alt) => {
      if (!mainImage || !normalizedSrc) return false;
      if (
        getCurrentMainImageSrc() === normalizedSrc
        && mainImage.complete
        && Number(mainImage.naturalWidth || 0) > 0
      ) {
        if (alt) mainImage.alt = alt;
        rememberKnownGoodMainImage();
        return true;
      }
      mainImage.style.opacity = '0';
      mainImage.src = normalizedSrc;
      mainImage.removeAttribute('srcset');
      if (alt) mainImage.alt = alt;
      window.setTimeout(() => {
        mainImage.style.opacity = '';
      }, 80);
      return true;
    };

    const preloadMainImage = (src) => {
      const normalizedSrc = normalizeMainImageUrl(src);
      if (!normalizedSrc || typeof window.Image !== 'function') return Promise.resolve(false);
      if (validatedMainImageSources.has(normalizedSrc)) return Promise.resolve(true);
      if (failedMainImageSources.has(normalizedSrc)) return Promise.resolve(false);
      if (pendingMainImageLoads.has(normalizedSrc)) return pendingMainImageLoads.get(normalizedSrc);

      const request = new Promise((resolve) => {
        const preload = new window.Image();
        let settled = false;
        const finish = (loaded) => {
          if (settled) return;
          settled = true;
          window.clearTimeout(timeout);
          preload.onload = null;
          preload.onerror = null;
          if (loaded && Number(preload.naturalWidth || 0) > 0) {
            validatedMainImageSources.add(normalizedSrc);
            failedMainImageSources.delete(normalizedSrc);
            resolve(true);
          } else {
            failedMainImageSources.add(normalizedSrc);
            validatedMainImageSources.delete(normalizedSrc);
            resolve(false);
          }
        };
        const timeout = window.setTimeout(() => finish(false), 8000);
        preload.onload = () => finish(true);
        preload.onerror = () => finish(false);
        preload.src = normalizedSrc;
      }).finally(() => {
        pendingMainImageLoads.delete(normalizedSrc);
      });

      pendingMainImageLoads.set(normalizedSrc, request);
      return request;
    };

    const setMainImage = (src, alt, options = {}) => {
      if (!mainImage || !src) return Promise.resolve(false);
      const normalizedSrc = normalizeMainImageUrl(src);
      if (!normalizedSrc) return Promise.resolve(false);
      if (
        getCurrentMainImageSrc() === normalizedSrc
        && mainImage.complete
        && Number(mainImage.naturalWidth || 0) > 0
      ) {
        if (alt) mainImage.alt = alt;
        rememberKnownGoodMainImage();
        return Promise.resolve(true);
      }

      const requestRevision = ++mainImageRequestRevision;
      const fallbackSrc = normalizeMainImageUrl(
        options.fallbackSrc
        || lastKnownGoodMainImageSrc
        || ''
      );
      const fallbackAlt = options.fallbackAlt || lastKnownGoodMainImageAlt || alt || '';

      return preloadMainImage(normalizedSrc).then((loaded) => {
        if (requestRevision !== mainImageRequestRevision) return false;
        if (loaded) return commitMainImage(normalizedSrc, alt);
        if (!fallbackSrc || fallbackSrc === normalizedSrc) return false;
        return preloadMainImage(fallbackSrc).then((fallbackLoaded) => {
          if (requestRevision !== mainImageRequestRevision || !fallbackLoaded) return false;
          return commitMainImage(fallbackSrc, fallbackAlt);
        });
      });
    };

    if (mainImage) {
      rememberKnownGoodMainImage();
      mainImage.addEventListener('load', () => {
        restoringLastKnownGoodMainImage = false;
        rememberKnownGoodMainImage();
      });
      mainImage.addEventListener('error', () => {
        const failedSrc = getCurrentMainImageSrc();
        if (failedSrc) {
          failedMainImageSources.add(failedSrc);
          validatedMainImageSources.delete(failedSrc);
        }
        if (
          restoringLastKnownGoodMainImage
          || !lastKnownGoodMainImageSrc
          || failedSrc === lastKnownGoodMainImageSrc
        ) {
          return;
        }
        restoringLastKnownGoodMainImage = true;
        mainImageRequestRevision += 1;
        commitMainImage(lastKnownGoodMainImageSrc, lastKnownGoodMainImageAlt);
      });
    }

    const clearTargetBcpoMainImage = () => {
      if (!preferBcpoColorImageAsMain) return;
      targetBcpoMainImageState.src = '';
      targetBcpoMainImageState.alt = '';
    };

    const enforceTargetBcpoMainImage = () => {
      if (!preferBcpoColorImageAsMain || !mainImage || !targetBcpoMainImageState.src || targetBcpoMainImageState.correcting) return;
      const currentFile = getImageFileName(mainImage.getAttribute('src') || mainImage.currentSrc || mainImage.src);
      const targetFile = getImageFileName(targetBcpoMainImageState.src);
      if (!targetFile || currentFile === targetFile) return;
      targetBcpoMainImageState.correcting = true;
      setMainImage(targetBcpoMainImageState.src, targetBcpoMainImageState.alt);
      window.setTimeout(() => {
        targetBcpoMainImageState.correcting = false;
      }, 0);
    };

    const activateThumb = (thumb) => {
      thumbs.forEach((item) => item.classList.toggle('is-active', item === thumb));
      if (thumb) setMainImage(thumb.dataset.full, thumb.dataset.alt);
    };

    const markUserMainImageInteraction = () => {
      hasUserMainImageInteraction = true;
    };

    const isDirectUserClick = (event) => Boolean(event && event.isTrusted && event.detail > 0);

    const restoreInitialActiveThumbImage = () => {
      if (!preserveInitialMainImageDuringColorSync || hasUserMainImageInteraction || !mainImage) return false;
      const activeThumb = initialDefaultThumb || thumbs.find((thumb) => thumb.classList.contains('is-active')) || thumbs[0];
      if (!activeThumb || !activeThumb.dataset.full) return false;
      const currentFile = getImageFileName(mainImage.getAttribute('src') || mainImage.currentSrc || mainImage.src);
      const targetFile = getImageFileName(activeThumb.dataset.full);
      if (!targetFile || currentFile === targetFile) return false;
      thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb === activeThumb));
      setMainImage(activeThumb.dataset.full, activeThumb.dataset.alt);
      return true;
    };

    const scheduleInitialActiveThumbRestore = () => {
      if (!preserveInitialMainImageDuringColorSync || hasUserMainImageInteraction) return;
      [0, 80, 260, 800, 1600].forEach((delay) => {
        window.setTimeout(restoreInitialActiveThumbImage, delay);
      });
      if (initialMainImageGuardStarted) return;
      initialMainImageGuardStarted = true;
      const startedAt = Date.now();
      const guardTick = () => {
        if (!preserveInitialMainImageDuringColorSync || hasUserMainImageInteraction) return;
        restoreInitialActiveThumbImage();
        if (Date.now() - startedAt < 9000) {
          window.setTimeout(guardTick, 300);
        }
      };
      guardTick();
    };

    const getSwipeThumbs = () => thumbs.filter((thumb) => thumb && !thumb.hidden);

    const getActiveSwipeThumbIndex = (availableThumbs) => {
      const activeIndex = availableThumbs.findIndex((thumb) => thumb.classList.contains('is-active'));
      if (activeIndex >= 0) return activeIndex;

      const currentFile = getImageFileName(mainImage && (mainImage.getAttribute('src') || mainImage.currentSrc || mainImage.src));
      const matchingIndex = availableThumbs.findIndex((thumb) => currentFile && getImageFileName(thumb.dataset.full) === currentFile);
      return matchingIndex >= 0 ? matchingIndex : 0;
    };

    const activateSwipeThumb = (direction) => {
      const availableThumbs = getSwipeThumbs();
      if (availableThumbs.length < 2) return false;

      const currentIndex = getActiveSwipeThumbIndex(availableThumbs);
      const nextIndex = Math.max(0, Math.min(availableThumbs.length - 1, currentIndex + direction));
      if (nextIndex === currentIndex) return false;

      markUserMainImageInteraction();
      clearTargetBcpoMainImage();
      const nextThumb = availableThumbs[nextIndex];
      activateThumb(nextThumb);
      if (nextThumb && nextThumb.scrollIntoView) {
        try {
          nextThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        } catch (error) {
          nextThumb.scrollIntoView(false);
        }
      }
      return true;
    };

    const initMobileGallerySwipe = () => {
      if (!mainImageFrame || thumbs.length < 2) return;

      let isTracking = false;
      let isHorizontalGesture = false;
      let activePointerId = null;
      let startX = 0;
      let startY = 0;
      let lastX = 0;
      let lastY = 0;
      const minSwipeDistance = 44;

      const resetSwipe = () => {
        isTracking = false;
        isHorizontalGesture = false;
        activePointerId = null;
      };

      const beginSwipe = (clientX, clientY, pointerId) => {
        startX = clientX;
        startY = clientY;
        lastX = startX;
        lastY = startY;
        isTracking = true;
        isHorizontalGesture = false;
        activePointerId = pointerId == null ? null : pointerId;
      };

      const moveSwipe = (clientX, clientY, event) => {
        if (!isTracking) return;
        lastX = clientX;
        lastY = clientY;
        const deltaX = lastX - startX;
        const deltaY = lastY - startY;

        if (!isHorizontalGesture && Math.abs(deltaX) > 14 && Math.abs(deltaX) > Math.abs(deltaY) * 1.25) {
          isHorizontalGesture = true;
        }

        if (isHorizontalGesture && event.cancelable) event.preventDefault();
      };

      const endSwipe = (clientX, clientY, event) => {
        if (!isTracking) return;
        const deltaX = clientX - startX;
        const deltaY = clientY - startY;
        const isSwipe = Math.abs(deltaX) >= minSwipeDistance && Math.abs(deltaX) > Math.abs(deltaY) * 1.35;

        resetSwipe();
        if (!isSwipe) return;
        if (event.cancelable) event.preventDefault();
        activateSwipeThumb(deltaX < 0 ? 1 : -1);
      };

      const getChangedTouch = (event) => {
        if (event.changedTouches && event.changedTouches.length) return event.changedTouches[0];
        if (event.touches && event.touches.length) return event.touches[0];
        return null;
      };

      if (window.PointerEvent) {
        mainImageFrame.addEventListener('pointerdown', (event) => {
          if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
          beginSwipe(event.clientX, event.clientY, event.pointerId);
          if (mainImageFrame.setPointerCapture) {
            try {
              mainImageFrame.setPointerCapture(event.pointerId);
            } catch (error) {}
          }
        });

        mainImageFrame.addEventListener('pointermove', (event) => {
          if (!isTracking || activePointerId !== event.pointerId) return;
          moveSwipe(event.clientX, event.clientY, event);
        });

        mainImageFrame.addEventListener('pointerup', (event) => {
          if (!isTracking || activePointerId !== event.pointerId) return;
          endSwipe(event.clientX, event.clientY, event);
          if (mainImageFrame.releasePointerCapture) {
            try {
              mainImageFrame.releasePointerCapture(event.pointerId);
            } catch (error) {}
          }
        });

        mainImageFrame.addEventListener('pointercancel', resetSwipe);
        return;
      }

      mainImageFrame.addEventListener('touchstart', (event) => {
        if (!event.touches || event.touches.length !== 1) {
          resetSwipe();
          return;
        }
        const touch = event.touches[0];
        beginSwipe(touch.clientX, touch.clientY);
      }, { passive: true });

      mainImageFrame.addEventListener('touchmove', (event) => {
        if (!isTracking || !event.touches || event.touches.length !== 1) return;
        const touch = event.touches[0];
        moveSwipe(touch.clientX, touch.clientY, event);
      }, { passive: false });

      mainImageFrame.addEventListener('touchend', (event) => {
        const touch = getChangedTouch(event);
        endSwipe(touch ? touch.clientX : lastX, touch ? touch.clientY : lastY, event);
      }, { passive: false });

      mainImageFrame.addEventListener('touchcancel', resetSwipe, { passive: true });
    };

    const updateCordedControls = (value) => {
      const isCorded = String(value || '').trim().toLowerCase() === 'corded';
      cordedBlocks.forEach((block) => {
        const shouldShow = isCorded && block.dataset.fdVoUnavailable !== 'true';
        block.hidden = !shouldShow;
        block.querySelectorAll('[data-fd-vo-sync]').forEach((control) => {
          control.disabled = !shouldShow;
        });
      });
      refreshTemplateStepNumbers();
    };

    const updateQuantity = (direction) => {
      if (!quantityInput) return;
      const current = Math.max(Number(quantityInput.value || 1), 1);
      const next = direction === 'plus' ? current + 1 : Math.max(current - 1, 1);
      quantityInput.value = String(next);
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const groupMatchesValue = (group, handle) => {
      if (!group || group === 'all') return false;
      return group === handle || group === `color-${handle}` || group.endsWith(`-${handle}`) || group.includes(handle);
    };

    const syncSeeMoreState = (seeMore, expanded) => {
      if (!seeMore) return;
      seeMore.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      seeMore.textContent = expanded
        ? (seeMore.dataset.fdLabelLess || 'See less')
        : (seeMore.dataset.fdLabelMore || 'See more');
    };

    const revealDefaultGallery = () => {
      const seeMore = root.querySelector('[data-fd-see-more]');
      const expanded = Boolean(seeMore && seeMore.getAttribute('aria-expanded') === 'true');
      if (seeMore) seeMore.hidden = false;
      syncSeeMoreState(seeMore, expanded);
      thumbs.forEach((thumb) => {
        thumb.hidden = !expanded && thumb.classList.contains('is-extra');
      });
    };

    const updateGalleryGroup = (handle, fallbackImage) => {
      if (!handle) return;
      const matchingThumbs = thumbs.filter((thumb) => groupMatchesValue(thumb.dataset.group, handle));

      if (matchingThumbs.length < 2) {
        revealDefaultGallery();
        if (fallbackImage) setMainImage(fallbackImage);
        return;
      }

      const seeMore = root.querySelector('[data-fd-see-more]');
      if (seeMore) seeMore.hidden = true;
      syncSeeMoreState(seeMore, false);
      let firstVisible = null;
      thumbs.forEach((thumb) => {
        const visible = groupMatchesValue(thumb.dataset.group, handle);
        thumb.hidden = !visible;
        if (visible && !firstVisible) firstVisible = thumb;
      });

      activateThumb(firstVisible);
    };

    const findSelectedVariant = () => {
      return variants.find((variant) => {
        const options = getVariantOptions(variant);
        return selectedOptions.every((value, index) => !value || options[index] === value);
      });
    };

    const updateVariant = (variant) => {
      if (!variant) {
        if (atc) atc.disabled = false;
        if (atcText) atcText.textContent = 'Add to Cart';
        return;
      }

      if (variantInput) variantInput.value = variant.id;
      root.dispatchEvent(new CustomEvent('fd:variant-updated', {
        bubbles: true,
        detail: {
          variantId: String(variant.id || ''),
          basePriceCents: Number(variant.price || 0)
        }
      }));

      if (comparePrice) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePrice.hidden = false;
          comparePrice.textContent = formatMoney(variant.compare_at_price);
        } else {
          comparePrice.hidden = true;
        }
      }

      if (jennaBcpoPriceFallback) {
        window.setTimeout(jennaBcpoPriceFallback.updateDisplay, 40);
      }

      if (atc) atc.disabled = !variant.available;
      if (atcText) atcText.textContent = variant.available ? 'Add to Cart' : 'Sold Out';

      const variantImage = variant.featured_image || variant.featured_media;
      if (variantImage && variantImage.src) {
        setMainImage(variantImage.src, variantImage.alt);
      }

      if (window.history && variant.id) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    };

    const getBcpoInput = (target, scope) => {
      if (!target || !target.closest) return null;
      const directInput = target.closest('#bcpo input');
      if (directInput) return directInput;
      const label = target.closest('#bcpo label');
      if (label) {
        const nestedInput = label.querySelector('input');
        if (nestedInput) return nestedInput;
        const controlId = label.getAttribute('for');
        const control = controlId ? document.getElementById(controlId) : null;
        if (control && control.closest && control.closest('#bcpo')) return control;
      }
      return scope ? scope.querySelector('.bcpo-front-image-option, .bcpo-front-color-option, input') : null;
    };

    const isColorInputName = (input) => {
      const inputName = String(input ? input.name : '').toLowerCase();
      return inputName.includes('[color]') || inputName.includes('[colour]') || inputName.includes('[fabric]');
    };

    const getBcpoLabel = (target, input, parent) => {
      if (!target || !target.closest) return null;
      const directLabel = target.closest('#bcpo .bcpo-front-image-label, #bcpo .bcpo-front-color-label, #bcpo label');
      if (directLabel) return directLabel;
      const parentLabel = parent ? parent.querySelector('.bcpo-front-image-label, .bcpo-front-color-label, label') : null;
      if (parentLabel) return parentLabel;
      if (!input || !input.id) return null;
      return Array.from(document.querySelectorAll('#bcpo label')).find((label) => label.getAttribute('for') === input.id) || null;
    };

    const decorateBcpoColorChoice = (choice) => {
      if (!choice || !choice.closest) return;
      const parent = choice.closest('#bcpo .bcpo-image-parent, #bcpo .bcpo-color-parent') || choice;
      const input = getBcpoInput(choice, parent);
      const labelElement = getBcpoLabel(choice, input, parent) || (choice.matches('label') ? choice : null);
      const selectedColor = input ? input.value : (labelElement ? labelElement.textContent : '');
      const swatchImage = (optimizeVoImages ? getColorThumbnail(selectedColor) : getColorImage(selectedColor))
        || getCssBackgroundUrl(labelElement)
        || getCssBackgroundUrl(parent);

      parent.classList.add('fd-bcpo-color-choice');
      if (selectedColor) {
        const colorName = String(selectedColor).replace(/\s+/g, ' ').trim();
        parent.dataset.fdColorName = colorName;
        parent.setAttribute('title', colorName);
        parent.setAttribute('aria-label', colorName);
        if (input && !input.hasAttribute('aria-label') && !input.hasAttribute('aria-labelledby')) {
          input.setAttribute('aria-label', colorName);
        }
      }
      if (labelElement) {
        labelElement.classList.add('fd-bcpo-color-label');
        if (selectedColor) labelElement.setAttribute('title', selectedColor);
        if (swatchImage) applyBcpoChoiceImage(labelElement, swatchImage);
      } else if (swatchImage) {
        applyBcpoChoiceImage(parent, swatchImage);
      }

      const classText = `${parent.className || ''} ${labelElement ? labelElement.className : ''}`;
      const isSelected = Boolean(input && input.checked) || /\b(active|selected|checked)\b/i.test(classText);
      parent.classList.toggle('fd-bcpo-is-selected', isSelected);
    };

    const getBcpoColorChoice = (target) => {
      return target && target.closest ? target.closest('#bcpo .bcpo-image-parent, #bcpo .bcpo-color-parent') : null;
    };

    const getBcpoColorChoiceValue = (choice) => {
      if (!choice) return '';
      const input = getBcpoInput(choice, choice);
      if (input && input.value) return input.value;
      return choice.dataset.fdColorName || choice.textContent || '';
    };

    const getBcpoColorTargetValue = (target) => {
      if (!target || !target.closest) return '';
      const wrapper = target.closest('#bcpo .selector-wrapper');
      const parent = getBcpoColorChoice(target);
      const input = getBcpoInput(target, parent || wrapper || target.closest('#bcpo'));
      return String((input && input.value) || getBcpoColorChoiceValue(parent) || '').trim();
    };

    const findBcpoColorChoiceByValue = (wrapper, value) => {
      const selectedValue = String(value || '').trim();
      if (!wrapper || !selectedValue) return null;
      return Array.from(wrapper.querySelectorAll('.bcpo-image-parent, .bcpo-color-parent')).find((choice) => (
        isSameBcpoColorValue(getBcpoColorChoiceValue(choice), selectedValue)
      )) || null;
    };

    const isSameBcpoColorValue = (first, second) => {
      const firstValue = String(first || '').trim();
      const secondValue = String(second || '').trim();
      return Boolean(firstValue && secondValue) && (
        firstValue === secondValue
        || firstValue.toLowerCase() === secondValue.toLowerCase()
        || handleize(firstValue) === handleize(secondValue)
      );
    };

    const setBcpoColorChoiceSelected = (choice, selected) => {
      if (!choice || !choice.classList) return;
      choice.classList.toggle('fd-bcpo-is-selected', selected);
      if (selected) return;
      ['active', 'selected', 'checked'].forEach((className) => choice.classList.remove(className));
      choice.querySelectorAll('.bcpo-front-image-label, .bcpo-front-color-label, label').forEach((label) => {
        ['active', 'selected', 'checked'].forEach((className) => label.classList.remove(className));
      });
    };

    const syncBcpoColorSelection = (wrapper, activeTarget, expectedValue = '') => {
      if (!wrapper || !wrapper.querySelectorAll) return;
      const choices = Array.from(wrapper.querySelectorAll('.bcpo-image-parent, .bcpo-color-parent'));
      if (!choices.length) return;

      const activeChoice = findBcpoColorChoiceByValue(wrapper, expectedValue) || getBcpoColorChoice(activeTarget);
      const checkedChoices = choices.filter((choice) => {
        const input = getBcpoInput(choice, choice);
        return Boolean(input && input.checked);
      });
      const currentColorLabel = root.querySelector('[data-fd-color-label]');
      const currentColor = (colorProperty && colorProperty.value) || (currentColorLabel ? currentColorLabel.textContent : '');
      const currentColorChoice = currentColor
        ? choices.find((choice) => isSameBcpoColorValue(getBcpoColorChoiceValue(choice), currentColor))
        : null;
      const selectedByClass = choices.filter((choice) => {
        const labelElement = getBcpoLabel(choice, getBcpoInput(choice, choice), choice);
        const classText = `${choice.className || ''} ${labelElement ? labelElement.className : ''}`;
        return /\b(active|selected|checked|fd-bcpo-is-selected)\b/i.test(classText);
      });
      const fallbackChoice = checkedChoices[checkedChoices.length - 1]
        || (activeChoice && wrapper.contains(activeChoice) ? activeChoice : null)
        || currentColorChoice
        || null;

      choices.forEach((choice) => {
        const input = getBcpoInput(choice, choice);
        const selected = activeChoice && wrapper.contains(activeChoice)
          ? choice === activeChoice
          : checkedChoices.length
          ? Boolean(input && input.checked)
          : choice === fallbackChoice;
        setBcpoColorChoiceSelected(choice, selected);
      });
    };

    const decorateBcpoColorOptions = () => {
      const bcpoRoot = root.querySelector('#bcpo') || document.querySelector('#bcpo');
      if (!bcpoRoot) return;
      const colorIndexes = getBcpoColorOptionIndexes();

      bcpoRoot.querySelectorAll('.selector-wrapper').forEach((wrapper) => {
        if (!isBcpoColorWrapper(wrapper, colorIndexes)) return;
        wrapper.classList.add('fd-bcpo-color-option');
        const titleLabel = wrapper.querySelector('.bcpo-label') || wrapper.querySelector('.bcpo-title') || Array.from(wrapper.children || []).find((child) => child.tagName === 'LABEL');
        if (titleLabel) titleLabel.classList.add('fd-bcpo-color-title');
        if (!wrapper.querySelector('.fd-bcpo-color-note')) {
          const note = document.createElement('div');
          note.className = 'fd-bcpo-color-note';
      note.textContent = 'Lighting, screen, and batch variations may affect color -- compare Fabric Samples first.';
          if (titleLabel && titleLabel.parentNode === wrapper) {
            titleLabel.insertAdjacentElement('afterend', note);
          } else {
            wrapper.insertBefore(note, wrapper.firstChild);
          }
        }

        wrapper.querySelectorAll('.bcpo-image-parent, .bcpo-color-parent').forEach((choice) => {
          decorateBcpoColorChoice(choice);
        });
        syncBcpoColorSelection(wrapper);
      });
    };

    const isBcpoColorTarget = (target) => {
      if (!target || !target.closest) return false;
      const wrapper = target.closest('#bcpo .selector-wrapper');
      const scope = wrapper || target.closest('#bcpo .bcpo-image-parent, #bcpo .bcpo-color-parent, #bcpo label, #bcpo');
      const input = getBcpoInput(target, scope);

      if (isColorInputName(input)) return true;

      const colorIndexes = getBcpoColorOptionIndexes();
      const nameMatch = input && String(input.name || '').match(/^name(\d+)$/);
      if (nameMatch && colorIndexes.has(Number(nameMatch[1]))) return true;

      if (wrapper && isBcpoColorWrapper(wrapper, colorIndexes)) return true;

      return Boolean(input && input.matches && input.matches('.bcpo-front-image-option, .bcpo-front-color-option') && getColorImage(input.value));
    };

    const updateBcpoColorImage = (target, options = {}) => {
      if (!isBcpoColorTarget(target)) return false;
      const shouldUpdateMainImage = options.updateMainImage !== false;
      const wrapper = target.closest('#bcpo .selector-wrapper');
      const lockedColor = String(options.selectedValue || '').trim();
      syncBcpoColorSelection(wrapper, target, lockedColor);
      const parent = getBcpoColorChoice(target);
      const input = getBcpoInput(target, parent || wrapper || target.closest('#bcpo'));
      const labelElement = getBcpoLabel(target, input, parent);
      const selectedColor = lockedColor || (input ? input.value : '');
      const productImage = getProductColorImage(selectedColor);
      const fullColorImage = getColorImage(selectedColor);
      const swatchImage = fullColorImage || getCssBackgroundUrl(labelElement) || getCssBackgroundUrl(parent);
      if (shouldUpdateMainImage && preferBcpoColorImageAsMain) {
        if (fullColorImage) {
          targetBcpoMainImageState.src = normalizeMainImageUrl(fullColorImage);
          targetBcpoMainImageState.alt = selectedColor || '';
        } else {
          clearTargetBcpoMainImage();
        }
      }
      const mainImageSrc = shouldUpdateMainImage
        ? (preferBcpoColorImageAsMain
          ? fullColorImage
          : (productImage || (canUseSwatchImageAsMain(swatchImage) ? swatchImage : '')))
        : '';

      if (!selectedColor && !swatchImage && !productImage) return false;
      root.querySelectorAll('[data-fd-color-label]').forEach((label) => {
        label.textContent = selectedColor;
      });
      if (colorProperty && selectedColor) colorProperty.value = selectedColor;
      if (mainImageSrc) {
        setMainImage(mainImageSrc, selectedColor);
        enforceTargetBcpoMainImage();
      }
      decorateBcpoColorOptions();
      syncBcpoColorSelection(wrapper, target, selectedColor);
      return true;
    };

    let bcpoColorUpdateRevision = 0;
    let bcpoColorSettleTimer = 0;
    let lastBcpoColorImmediateValue = '';
    let lastBcpoColorImmediateAt = 0;
    const scheduleBcpoColorImageUpdate = (target) => {
      const selectedValue = getBcpoColorTargetValue(target);
      if (!selectedValue) return;
      const sourceWrapper = target && target.closest ? target.closest('#bcpo .selector-wrapper') : null;
      const revision = ++bcpoColorUpdateRevision;
      const commit = () => {
        if (revision !== bcpoColorUpdateRevision) return;
        const currentWrapper = (sourceWrapper && document.documentElement.contains(sourceWrapper))
          ? sourceWrapper
          : (target && target.closest ? target.closest('#bcpo .selector-wrapper') : null);
        const lockedChoice = findBcpoColorChoiceByValue(currentWrapper, selectedValue);
        const updateTarget = lockedChoice || target;
        if (!updateTarget || !document.documentElement.contains(updateTarget)) return;
        decorateBcpoColorOptions();
        updateBcpoColorImage(updateTarget, { selectedValue });
        enforceTargetBcpoMainImage();
      };

      const now = Date.now();
      const isDuplicateBurst = isSameBcpoColorValue(lastBcpoColorImmediateValue, selectedValue)
        && now - lastBcpoColorImmediateAt < 80;
      if (!isDuplicateBurst) {
        lastBcpoColorImmediateValue = selectedValue;
        lastBcpoColorImmediateAt = now;
        commit();
      }

      if (bcpoColorSettleTimer) window.clearTimeout(bcpoColorSettleTimer);
      bcpoColorSettleTimer = window.setTimeout(() => {
        bcpoColorSettleTimer = 0;
        commit();
      }, 160);
    };

    const normalizeVoText = (value) => String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();

    const normalizeVoIdentifier = (value) => String(value == null ? '' : value).trim().toLowerCase();

    const VO_OPTION_TITLE_ALIASES = Object.freeze({
      'mounting type': 'mount type',
      'mount type': 'mounting type',
      'lift type': 'lift style',
      'lift style': 'lift type',
      'cord loop position': 'corded position',
      'corded position': 'cord loop position',
      'single panel width': 'width inch',
      'width inch': 'single panel width',
      'width fraction': 'width eighths',
      'width eighths': 'width fraction',
      'single panel length': 'height inch',
      'height inch': 'single panel length',
      'height fraction': 'height eighths',
      'height eighths': 'height fraction',
      'lining type': 'lining',
      lining: 'lining type'
    });

    const VO_VALUE_ALIASES = Object.freeze({
      'inside mount': 'inside',
      'outside mount': 'outside',
      cordless: 'cordless lift',
      corded: 'corded lift'
    });

    const CONDITIONAL_LINING_CHILD_TITLES = new Set([
      'white lining',
      'neutral lining',
      'blackout lining',
      'dark lining',
      'same color lining',
      'unlined'
    ]);

    let cachedBcpoOptions = [];
    const getBcpoOptions = () => {
      const sources = [
        [window.bcpo_data, ['virtual_options', 'options']],
        [window.__fdVoFullData, ['virtual_options', 'options']],
        [window.bcpo_product, ['virtual_options', 'options']],
        [window.bcpo, ['virtual_options', 'options']]
      ];
      for (const [source, properties] of sources) {
        if (!source) continue;
        for (const property of properties) {
          const options = source[property];
          if (!Array.isArray(options) || !options.length) continue;
          cachedBcpoOptions = options.slice();
          return cachedBcpoOptions;
        }
      }

      return cachedBcpoOptions;
    };

    const getOnlyBcpoCandidate = (candidates) => (
      Array.isArray(candidates) && candidates.length === 1 ? candidates[0] : null
    );

    const getBcpoOptionIdentifiers = (option) => ['unique', 'id']
      .map((key) => normalizeVoIdentifier(option && option[key]))
      .filter(Boolean);

    const isConditionalLiningChildOption = (option, options = getBcpoOptions()) => {
      const conditionalOption = normalizeVoIdentifier(option && option.conditional_option);
      if (!conditionalOption) return false;

      const parentMatches = options.filter((candidate) => (
        getBcpoOptionIdentifiers(candidate).includes(conditionalOption)
      ));
      const parent = getOnlyBcpoCandidate(parentMatches);
      if (parent && normalizeVoText(parent.title) === 'lining') return true;
      return CONDITIONAL_LINING_CHILD_TITLES.has(normalizeVoText(option && option.title));
    };

    const resolveBcpoOptionReference = (query, options = {}) => {
      const optionQuery = String(query == null ? '' : query).trim();
      if (!optionQuery) return null;

      const allOptions = getBcpoOptions();
      const candidates = options.allowConditionalLiningChildren
        ? allOptions
        : allOptions.filter((option) => !isConditionalLiningChildOption(option, allOptions));
      const identifierQuery = normalizeVoIdentifier(optionQuery);
      const identifierMatches = candidates.filter((option) => (
        getBcpoOptionIdentifiers(option).includes(identifierQuery)
      ));
      if (identifierMatches.length) return getOnlyBcpoCandidate(identifierMatches);

      const titleQuery = normalizeVoText(optionQuery);
      const exactTitleMatches = candidates.filter((option) => (
        normalizeVoText(option && option.title) === titleQuery
      ));
      if (exactTitleMatches.length) return getOnlyBcpoCandidate(exactTitleMatches);

      if (options.allowAliases === false) return null;
      const aliasTarget = VO_OPTION_TITLE_ALIASES[titleQuery];
      if (!aliasTarget) return null;
      return getOnlyBcpoCandidate(candidates.filter((option) => (
        normalizeVoText(option && option.title) === aliasTarget
      )));
    };

    const getBcpoOptionByIndex = (index) => {
      const options = getBcpoOptions();
      if (index >= 0 && options[index]) return options[index];
      if (index > 0 && options[index - 1]) return options[index - 1];
      return null;
    };

    const getBcpoWrapperOption = (wrapper) => {
      if (!wrapper) return null;
      const control = wrapper.querySelector('input, select, textarea');
      const nameMatch = control && String(control.name || '').match(/^name(\d+)$/);
      if (nameMatch) return getBcpoOptionByIndex(Number(nameMatch[1]));

      const propertyMatch = control && String(control.name || '').match(/^properties\[(.+)\]$/);
      if (propertyMatch) {
        const propertyTitle = propertyMatch[1];
        const matchingOption = resolveBcpoOptionReference(propertyTitle, {
          allowConditionalLiningChildren: true
        });
        if (matchingOption) return matchingOption;
      }

      const dataOption = String(wrapper.getAttribute('data-option') || '');
      const dataMatch = dataOption.match(/^option(\d+)$/i);
      if (dataMatch) return getBcpoOptionByIndex(Number(dataMatch[1]));

      const title = normalizeVoText(getBcpoWrapperTitle(wrapper));
      return resolveBcpoOptionReference(title, {
        allowConditionalLiningChildren: true,
        allowAliases: false
      });
    };

    const getBcpoWrapperOptionTitle = (wrapper) => {
      const option = getBcpoWrapperOption(wrapper);
      return option && option.title ? option.title : getBcpoWrapperTitle(wrapper);
    };

    const getBcpoWrappers = () => {
      const bcpoRoot = root.querySelector('#bcpo') || document.querySelector('#bcpo');
      const scope = bcpoRoot || root;
      return Array.from(new Set(Array.from(scope.querySelectorAll('.selector-wrapper, [data-option], .bcpo-selector-wrapper, .bold_option'))))
        .filter((wrapper) => wrapper !== root && wrapper !== form);
    };

    const isForceHiddenFractionText = (title) => {
      const titleText = normalizeVoText(title);
      return titleText === 'width fraction'
        || titleText.startsWith('width fraction ')
        || titleText === 'height fraction'
        || titleText.startsWith('height fraction ');
    };

    const isForceHiddenBcpoTitle = (title) => isForceHiddenFractionText(title);

    const isForceHiddenBcpoControl = (control) => {
      if (!control) return false;
      const controlText = normalizeVoText(`${control.name || ''} ${control.id || ''}`);
      return controlText.includes('width fraction') || controlText.includes('height fraction');
    };

    // A native BCPO field may only be hidden after a one-to-one proxy mapping
    // has written the value and successfully read it back. No title-based
    // force hiding is allowed, including the required fraction fields.
    const isForceHiddenBcpoWrapper = () => false;

    const setForceHiddenBcpoDefault = (control) => {
      if (!control) return;
      if (control.tagName === 'BUTTON') return;
      const type = String(control.type || '').toLowerCase();
      if (control.tagName === 'SELECT') {
        const options = Array.from(control.options || []);
        const previousValue = control.value;
        const isPlaceholderOption = (option) => {
          const text = normalizeVoText(option ? option.textContent : '');
          const value = normalizeVoText(option ? option.value : '');
          return !value || value === 'choose one' || text === 'choose one' || text === 'select one' || text === 'select';
        };
        if (isPlaceholderOption(options[control.selectedIndex])) {
          const preferred = options.find((option) => {
            const text = normalizeVoText(`${option.value || ''} ${option.textContent || ''}`);
            return !isPlaceholderOption(option) && (text === '0' || text.includes('no fraction') || text.includes('none'));
          }) || options.find((option) => !isPlaceholderOption(option));
          if (preferred) control.value = preferred.value;
        }
        if (control.value !== previousValue) dispatchVoChange(control);
        return;
      }
      if (type === 'radio' || type === 'checkbox') {
        const group = control.name
          ? Array.from((control.form || document).querySelectorAll(`input[type="${type}"][name="${CSS.escape(control.name)}"]`))
          : [control];
        if (!group.some((item) => item.checked)) {
          const choice = group.find((item) => !item.disabled) || control;
          choice.checked = true;
          dispatchVoChange(choice);
        }
        return;
      }
      if (!String(control.value || '').trim()) {
        control.value = '0';
        dispatchVoChange(control);
      }
    };

    const setForceHiddenBcpoWrapper = (wrapper, shouldHide) => {
      if (!wrapper) return;
      wrapper.classList.toggle('fd-bcpo-force-hidden', shouldHide);
      if (shouldHide) {
        if (!Object.prototype.hasOwnProperty.call(wrapper.dataset, 'fdForceHiddenAriaHiddenPresent')) {
          wrapper.dataset.fdForceHiddenAriaHiddenPresent = wrapper.hasAttribute('aria-hidden') ? 'true' : 'false';
          wrapper.dataset.fdForceHiddenAriaHiddenValue = wrapper.getAttribute('aria-hidden') || '';
        }
        wrapper.setAttribute('aria-hidden', 'true');
        if (!Object.prototype.hasOwnProperty.call(wrapper.dataset, 'fdForceHiddenDisplay')) {
          wrapper.dataset.fdForceHiddenDisplay = wrapper.style.display || '';
        }
        wrapper.style.display = 'none';
        wrapper.querySelectorAll('input, select, textarea, button').forEach((control) => {
          if (!Object.prototype.hasOwnProperty.call(control.dataset, 'fdForceHiddenDisabled')) {
            control.dataset.fdForceHiddenDisabled = control.disabled ? 'true' : 'false';
          }
          if (!Object.prototype.hasOwnProperty.call(control.dataset, 'fdForceHiddenRequired')) {
            control.dataset.fdForceHiddenRequired = control.hasAttribute('required') ? 'true' : 'false';
          }
          if (!Object.prototype.hasOwnProperty.call(control.dataset, 'fdForceHiddenAriaHiddenPresent')) {
            control.dataset.fdForceHiddenAriaHiddenPresent = control.hasAttribute('aria-hidden') ? 'true' : 'false';
            control.dataset.fdForceHiddenAriaHiddenValue = control.getAttribute('aria-hidden') || '';
          }
          setForceHiddenBcpoDefault(control);
          control.dataset.fdForceHiddenBcpo = 'true';
          control.removeAttribute('required');
          control.disabled = control.dataset.fdForceHiddenDisabled === 'true';
          control.setAttribute('aria-hidden', 'true');
        });
      } else if (!wrapper.classList.contains('fd-bcpo-template-hidden')) {
        if (wrapper.dataset.fdForceHiddenAriaHiddenPresent === 'true') {
          wrapper.setAttribute('aria-hidden', wrapper.dataset.fdForceHiddenAriaHiddenValue || '');
        } else {
          wrapper.removeAttribute('aria-hidden');
        }
        delete wrapper.dataset.fdForceHiddenAriaHiddenPresent;
        delete wrapper.dataset.fdForceHiddenAriaHiddenValue;
        if (Object.prototype.hasOwnProperty.call(wrapper.dataset, 'fdForceHiddenDisplay')) {
          wrapper.style.display = wrapper.dataset.fdForceHiddenDisplay;
          delete wrapper.dataset.fdForceHiddenDisplay;
        }
        wrapper.querySelectorAll('[data-fd-force-hidden-bcpo]').forEach((control) => {
          delete control.dataset.fdForceHiddenBcpo;
          if (Object.prototype.hasOwnProperty.call(control.dataset, 'fdForceHiddenDisabled')) {
            control.disabled = control.dataset.fdForceHiddenDisabled === 'true';
            delete control.dataset.fdForceHiddenDisabled;
          }
          if (control.dataset.fdForceHiddenRequired === 'true') control.setAttribute('required', '');
          else control.removeAttribute('required');
          delete control.dataset.fdForceHiddenRequired;
          if (control.dataset.fdForceHiddenAriaHiddenPresent === 'true') {
            control.setAttribute('aria-hidden', control.dataset.fdForceHiddenAriaHiddenValue || '');
          } else {
            control.removeAttribute('aria-hidden');
          }
          delete control.dataset.fdForceHiddenAriaHiddenPresent;
          delete control.dataset.fdForceHiddenAriaHiddenValue;
        });
      }
    };

    const applyForceHiddenBcpoOptions = () => {
      getBcpoWrappers().forEach((wrapper) => {
        setForceHiddenBcpoWrapper(wrapper, isForceHiddenBcpoWrapper(wrapper));
      });
    };

    const getNativeBcpoRank = (wrapper) => {
      const title = normalizeVoText(getBcpoWrapperOptionTitle(wrapper));
      if (isBcpoColorTitle(title) || title === 'fabric') return 0;
      if (title.includes('header') || title.includes('heading')) return 1;
      if (title.includes('width')) return 2;
      if (title.includes('length') || title.includes('height')) return 3;
      if (title.includes('lining') || title.includes('liner')) return 4;
      if (title.includes('memory')) return 5;
      if (title.includes('tieback') || title.includes('tie back')) return 6;
      return 99;
    };

    const orderNativeBcpoWrappers = () => {
      if (!usesNativeBcpoOnly) return;
      const wrappers = getBcpoWrappers().filter((wrapper) => !isForceHiddenBcpoWrapper(wrapper));
      wrappers.forEach((wrapper) => {
        const rank = getNativeBcpoRank(wrapper);
        if (rank < 0 || rank > 6) return;
        const order = String(rank + 1);
        if (wrapper.style.getPropertyValue('order') === order && wrapper.style.getPropertyPriority('order') === 'important') return;
        wrapper.style.setProperty('order', order, 'important');
      });
    };

    const syncNativeBcpoReadiness = () => {
      if (!usesNativeBcpoOnly) return true;
      orderNativeBcpoWrappers();
      const ranks = new Set(getBcpoWrappers()
        .filter((wrapper) => !isForceHiddenBcpoWrapper(wrapper))
        .map(getNativeBcpoRank)
        .filter((rank) => rank >= 0 && rank <= 6));
      const ready = [0, 1, 2, 3, 4, 5, 6].every((rank) => ranks.has(rank));
      const readinessValue = ready ? 'true' : 'false';
      if (root.dataset.fdNativeBcpoReady !== readinessValue) root.dataset.fdNativeBcpoReady = readinessValue;

      const variant = findSelectedVariant();
      const unavailable = Boolean(variant && variant.available === false);
      const shouldDisableAtc = unavailable;
      const currentAtc = root.querySelector('[data-fd-atc]');
      const currentAtcText = root.querySelector('[data-fd-atc-text]');
      const currentStickyAtc = root.querySelector('[data-fd-sticky-submit]');
      const nextAtcText = variant && !variant.available ? 'Sold Out' : 'Add to Cart';
      if (currentAtc && currentAtc.disabled !== shouldDisableAtc) currentAtc.disabled = shouldDisableAtc;
      if (currentAtcText) {
        if (currentAtcText.textContent !== nextAtcText) currentAtcText.textContent = nextAtcText;
      }
      if (currentStickyAtc) {
        if (currentStickyAtc.textContent.trim() !== nextAtcText) currentStickyAtc.textContent = nextAtcText;
        if (currentStickyAtc.disabled !== shouldDisableAtc) currentStickyAtc.disabled = shouldDisableAtc;
        if (shouldDisableAtc) currentStickyAtc.setAttribute('aria-disabled', 'true');
        else currentStickyAtc.removeAttribute('aria-disabled');
      }
      return ready;
    };

    if (usesNativeBcpoOnly) {
      let nativeBcpoStateTimer = 0;
      let nativeBcpoObserver = null;
      let observedNativeBcpoRoot = null;
      const nativeBcpoCtaIsSynced = () => {
        if (root.dataset.fdNativeBcpoReady !== 'true') return false;
        const variant = findSelectedVariant();
        const shouldDisableAtc = Boolean(variant && variant.available === false);
        const expectedText = variant && !variant.available ? 'Sold Out' : 'Add to Cart';
        const currentAtc = root.querySelector('[data-fd-atc]');
        const currentAtcText = root.querySelector('[data-fd-atc-text]');
        const currentStickyAtc = root.querySelector('[data-fd-sticky-submit]');
        return Boolean(
          currentAtc
          && currentAtcText
          && currentStickyAtc
          && currentAtcText.textContent.trim() === expectedText
          && currentStickyAtc.textContent.trim() === expectedText
          && currentAtc.disabled === shouldDisableAtc
          && currentStickyAtc.disabled === shouldDisableAtc
        );
      };
      const scheduleNativeBcpoStateSync = () => {
        if (nativeBcpoStateTimer) window.clearTimeout(nativeBcpoStateTimer);
        nativeBcpoStateTimer = window.setTimeout(() => {
          nativeBcpoStateTimer = 0;
          syncNativeBcpoReadiness();
        }, 40);
      };
      const observeNativeBcpoRoot = () => {
        const nextBcpoRoot = root.querySelector('#bcpo') || document.querySelector('#bcpo');
        if (!nextBcpoRoot) return false;
        if (observedNativeBcpoRoot === nextBcpoRoot) return true;

        if (nativeBcpoObserver) nativeBcpoObserver.disconnect();
        if (observedNativeBcpoRoot) {
          observedNativeBcpoRoot.removeEventListener('change', scheduleNativeBcpoStateSync, true);
          observedNativeBcpoRoot.removeEventListener('input', scheduleNativeBcpoStateSync, true);
        }

        observedNativeBcpoRoot = nextBcpoRoot;
        observedNativeBcpoRoot.addEventListener('change', scheduleNativeBcpoStateSync, true);
        observedNativeBcpoRoot.addEventListener('input', scheduleNativeBcpoStateSync, true);
        if (window.MutationObserver) {
          nativeBcpoObserver = new MutationObserver(scheduleNativeBcpoStateSync);
          nativeBcpoObserver.observe(observedNativeBcpoRoot, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['disabled', 'aria-disabled']
          });
        }
        return true;
      };
      const nativeBcpoCheckDelays = [120, 350, 800, 1600, 3200, 6000, 9000];
      let nativeBcpoCheckIndex = 0;
      const runNativeBcpoCheck = () => {
        const observingBcpo = observeNativeBcpoRoot();
        syncNativeBcpoReadiness();
        if (observingBcpo && nativeBcpoCtaIsSynced()) return;
        if (nativeBcpoCheckIndex >= nativeBcpoCheckDelays.length) return;
        const delay = nativeBcpoCheckDelays[nativeBcpoCheckIndex];
        nativeBcpoCheckIndex += 1;
        window.setTimeout(runNativeBcpoCheck, delay);
      };
      runNativeBcpoCheck();
    }

    const refreshDuplicateThemeColorOptions = () => {
      if (root.dataset.windowTreatment === 'true') return false;
      const colorIndexes = getBcpoColorOptionIndexes();
      const hasBcpoColor = getBcpoWrappers().some((wrapper) => (
        isBcpoColorWrapper(wrapper, colorIndexes) || isBcpoColorTitle(getBcpoWrapperOptionTitle(wrapper))
      ));
      root.querySelectorAll('[data-fd-theme-color-option]').forEach((field) => {
        field.hidden = hasBcpoColor;
        if (hasBcpoColor) field.setAttribute('aria-hidden', 'true');
        else field.removeAttribute('aria-hidden');
      });
      return hasBcpoColor;
    };

    const findBcpoOption = (query) => resolveBcpoOptionReference(query);

    const getBcpoColorOption = () => {
      const matches = getBcpoOptions().filter((option) => {
        const type = String(option && option.type ? option.type : '').toLowerCase();
        return type === 'images'
          && isBcpoColorTitle(option && option.title)
          && Array.isArray(option && option.values)
          && option.values.some((item) => String(item && item.key ? item.key : '').trim());
      });
      return getOnlyBcpoCandidate(matches);
    };

    const hasNativeBcpoColorWrapper = () => {
      const colorIndexes = getBcpoColorOptionIndexes();
      return getBcpoWrappers().some((wrapper) => {
        const title = getBcpoWrapperOptionTitle(wrapper);
        return isBcpoColorWrapper(wrapper, colorIndexes) || isBcpoColorTitle(title);
      });
    };

    const isVisibleBcpoNode = (element) => {
      if (!element || element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
      if (element.closest('[hidden], .fd-bcpo-template-hidden, .fd-bcpo-force-hidden, [aria-hidden="true"]')) return false;
      if (!window.getComputedStyle) return true;
      const style = window.getComputedStyle(element);
      if (!style || style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity || 1) <= 0.01) return false;
      const rect = element.getBoundingClientRect ? element.getBoundingClientRect() : null;
      return !rect || (rect.width > 2 && rect.height > 2);
    };

    const hasVisibleNativeBcpoColorMedia = (wrapper) => {
      if (!isVisibleBcpoNode(wrapper)) return false;
      const mediaItems = Array.from(wrapper.querySelectorAll([
        'img',
        'picture',
        '[style*="background-image"]',
        '[data-image]',
        '[data-img]',
        '.bcpo-image',
        '.bcpo-image-option',
        '.bcpo-option-image',
        '.bcpo_color',
        '.swatch',
        '.color-swatch'
      ].join(',')));

      return mediaItems.some((item) => {
        if (!isVisibleBcpoNode(item)) return false;
        const tag = String(item.tagName || '').toLowerCase();
        if (tag === 'img' || tag === 'picture') return true;
        if (item.querySelector && item.querySelector('img, picture')) return true;
        if (item.getAttribute('data-image') || item.getAttribute('data-img')) return true;
        const bg = window.getComputedStyle ? window.getComputedStyle(item).backgroundImage : '';
        return /url\(/i.test(bg || '');
      });
    };

    const hasRenderableNativeBcpoColorWrapper = () => {
      const colorIndexes = getBcpoColorOptionIndexes();
      return getBcpoWrappers().some((wrapper) => {
        const title = getBcpoWrapperOptionTitle(wrapper);
        const isColorWrapper = isBcpoColorWrapper(wrapper, colorIndexes) || isBcpoColorTitle(title);
        return isColorWrapper && hasVisibleNativeBcpoColorMedia(wrapper);
      });
    };

    const findBcpoWrapperForOption = (option) => {
      if (!option) return null;
      const wrappers = getBcpoWrappers();
      const optionIdentifiers = getBcpoOptionIdentifiers(option);
      const identityMatches = wrappers.filter((wrapper) => {
        const wrapperOption = getBcpoWrapperOption(wrapper);
        if (wrapperOption && wrapperOption === option) return true;
        if (!wrapperOption || !optionIdentifiers.length) return false;
        return getBcpoOptionIdentifiers(wrapperOption).some((identifier) => (
          optionIdentifiers.includes(identifier)
        ));
      });
      if (identityMatches.length) return identityMatches.length === 1 ? identityMatches[0] : null;

      const title = normalizeVoText(option.title);
      if (!title) return null;
      const exactTitleMatches = wrappers.filter((wrapper) => (
        normalizeVoText(getBcpoWrapperOptionTitle(wrapper)) === title
      ));
      return exactTitleMatches.length === 1 ? exactTitleMatches[0] : null;
    };

    const normalizeVoValue = (value) => {
      const normalized = normalizeVoText(value);
      return VO_VALUE_ALIASES[normalized] || normalized;
    };

    const valueMatches = (candidate, desired) => {
      const candidateText = normalizeVoValue(candidate);
      const desiredText = normalizeVoValue(desired);
      if (!candidateText || !desiredText) return false;
      return candidateText === desiredText;
    };

    const findUniqueVoValue = (items, getValue, desired) => {
      const matches = Array.from(items || []).filter((item) => {
        const values = getValue(item);
        return (Array.isArray(values) ? values : [values]).some((value) => valueMatches(value, desired));
      });
      return matches.length === 1 ? matches[0] : null;
    };

    const getVoChoiceValues = (control) => {
      const label = control && control.closest ? control.closest('label') : null;
      return [
        control && (control.value || control.getAttribute('value')),
        control && control.dataset ? control.dataset.value : '',
        label ? label.textContent : ''
      ];
    };

    const proxyValueSetCoversOptionValues = (optionValues, proxyValues, hasNumericControl = false) => {
      const requiredValues = Array.from(optionValues || [])
        .map((item) => String(item && typeof item === 'object' ? item.key : item || '').trim())
        .filter(Boolean);
      if (!requiredValues.length) return false;
      if (hasNumericControl) return false;
      const requiredKeys = requiredValues.map(normalizeVoValue).filter(Boolean);
      const availableKeys = Array.from(proxyValues || []).map(normalizeVoValue).filter(Boolean);
      const requiredSet = new Set(requiredKeys);
      const availableSet = new Set(availableKeys);
      if (
        requiredSet.size !== requiredKeys.length
        || availableSet.size !== availableKeys.length
        || requiredSet.size !== availableSet.size
      ) return false;
      return Array.from(requiredSet).every((key) => availableSet.has(key));
    };

    const isTemplateProxyCoverageComplete = (option) => {
      const template = root.querySelector('[data-fd-vo-template]');
      if (!template || !option || !Array.isArray(option.values)) return false;
      const controls = Array.from(template.querySelectorAll('[data-fd-vo-sync]')).filter((control) => (
        findBcpoOption(control.dataset.fdVoOption) === option
      ));
      if (!controls.length) return false;
      const hasNumericControl = controls.some((control) => String(control.type || '').toLowerCase() === 'number');
      const proxyValues = [];
      controls.forEach((control) => {
        if (control.tagName === 'SELECT') {
          Array.from(control.options || []).forEach((item) => {
            const value = String(item.value || item.textContent || '').trim();
            if (value) proxyValues.push(value);
          });
          return;
        }
        if (/^(radio|checkbox)$/i.test(control.type || '')) {
          proxyValues.push(String(control.dataset.fdVoValue || control.value || '').trim());
          return;
        }
        proxyValues.push(String(control.value || '').trim());
      });
      return proxyValueSetCoversOptionValues(option.values, proxyValues, hasNumericControl);
    };

    const isBcpoWrapperValueConfirmed = (wrapper, desired) => {
      if (!wrapper || !desired) return false;

      const select = wrapper.querySelector('select');
      if (select) {
        const selected = select.options && select.selectedIndex >= 0 ? select.options[select.selectedIndex] : null;
        return [select.value, selected ? selected.value : '', selected ? selected.textContent : '']
          .some((value) => valueMatches(value, desired));
      }

      const inputs = Array.from(wrapper.querySelectorAll('input, textarea'));
      const checkedChoices = inputs.filter((input) => (
        /^(radio|checkbox)$/i.test(input.type || '') && input.checked
      ));
      if (checkedChoices.length) {
        return checkedChoices.some((input) => getVoChoiceValues(input).some((value) => valueMatches(value, desired)));
      }

      const openInputs = inputs.filter((input) => !/^(radio|checkbox|hidden)$/i.test(input.type || ''));
      return openInputs.length === 1 && valueMatches(openInputs[0].value, desired);
    };

    const isBcpoOptionValueConfirmed = (option, desired) => (
      isBcpoWrapperValueConfirmed(findBcpoWrapperForOption(option), desired)
    );

    const syncBcpoOptionValue = (option, value) => {
      const wrapper = findBcpoWrapperForOption(option);
      if (!wrapper || !value) return false;

      const select = wrapper.querySelector('select');
      if (select) {
        const match = findUniqueVoValue(select.options, (item) => [item.value, item.textContent], value);
        if (!match) return false;
        select.value = match.value;
        dispatchVoChange(select);
        return isBcpoOptionValueConfirmed(option, value);
      }

      const inputs = Array.from(wrapper.querySelectorAll('input, textarea'));
      const choice = findUniqueVoValue(
        inputs.filter((input) => /^(radio|checkbox)$/i.test(input.type || '')),
        getVoChoiceValues,
        value
      );
      if (choice) {
        if (!choice.checked) choice.click();
        choice.checked = true;
        dispatchVoChange(choice);
        return isBcpoOptionValueConfirmed(option, value);
      }

      const openInputs = inputs.filter((input) => !/^(radio|checkbox|hidden)$/i.test(input.type || ''));
      if (openInputs.length !== 1) return false;
      openInputs[0].value = value;
      dispatchVoChange(openInputs[0]);
      return isBcpoOptionValueConfirmed(option, value);
    };

    const setBcpoWrapperProxyHidden = (wrapper, shouldHide) => {
      if (!wrapper) return;
      setForceHiddenBcpoWrapper(wrapper, false);
      const hideForProxy = Boolean(shouldHide);
      wrapper.dataset.fdVoSyncConfirmed = hideForProxy ? 'true' : 'false';
      wrapper.classList.toggle('fd-bcpo-template-hidden', hideForProxy);
      if (hideForProxy) wrapper.setAttribute('aria-hidden', 'true');
      else wrapper.removeAttribute('aria-hidden');
    };

    const voProxyBindings = new WeakMap();

    const isOptionalVoTemplateField = (field) => Boolean(
      field && (field.dataset.fdVoOptionalField === 'true' || field.hasAttribute('data-fd-vo-optional-field'))
    );

    const isInactiveVoTemplateField = (field) => {
      if (!field || isOptionalVoTemplateField(field)) return true;
      if (!field.hasAttribute('data-fd-corded-only')) return false;
      const checkedLift = root.querySelector('[data-fd-lift-input]:checked');
      return !normalizeVoText(checkedLift && checkedLift.value).startsWith('corded');
    };

    const clearStaleBcpoWrapperValue = (wrapper) => {
      if (!wrapper) return;
      const select = wrapper.querySelector('select');
      if (select) {
        const options = Array.from(select.options || []);
        const placeholder = options.find((item) => {
          const value = normalizeVoText(item && item.value);
          const text = normalizeVoText(item && item.textContent);
          return !value || value === 'choose one' || text === 'choose one' || text === 'select one' || text === 'select';
        });
        const nextIndex = placeholder ? placeholder.index : -1;
        if (select.selectedIndex !== nextIndex) {
          select.selectedIndex = nextIndex;
          dispatchVoChange(select);
        }
        return;
      }

      const inputs = Array.from(wrapper.querySelectorAll('input, textarea'));
      inputs.filter((input) => /^(radio|checkbox)$/i.test(input.type || '') && input.checked).forEach((input) => {
        input.checked = false;
        dispatchVoChange(input);
      });
      const openInputs = inputs.filter((input) => !/^(radio|checkbox|hidden)$/i.test(input.type || ''));
      openInputs.forEach((input) => {
        if (!String(input.value || '').trim()) return;
        input.value = '';
        dispatchVoChange(input);
      });
    };

    const restoreFailedVoProxyBinding = (control, binding) => {
      if (control) control.dataset.fdVoSyncConfirmed = 'false';
      const wrapper = binding && binding.wrapper ? binding.wrapper : null;
      if (wrapper) {
        setBcpoWrapperProxyHidden(wrapper, false);
        if (binding && binding.writtenByProxy === true) clearStaleBcpoWrapperValue(wrapper);
      }
      const option = binding && binding.option ? binding.option : (
        control ? findBcpoOption(control.dataset.fdVoOption) : null
      );
      const field = control && control.closest ? control.closest('[data-fd-vo-template-field]') : null;
      if (field) {
        Array.from(field.querySelectorAll('[data-fd-vo-sync]')).forEach((item) => {
          const sameOption = option
            ? findBcpoOption(item.dataset.fdVoOption) === option
            : normalizeVoText(item.dataset.fdVoOption) === normalizeVoText(control.dataset.fdVoOption);
          if (!sameOption) return;
          item.dataset.fdVoFallback = 'true';
          item.dataset.fdVoSyncConfirmed = 'false';
          setTemplateControlToVoMode(item, false);
        });
        const hasUsableProxy = Array.from(field.querySelectorAll('[data-fd-vo-sync]'))
          .some((item) => item.dataset.fdVoReady === 'true' && item.dataset.fdVoFallback !== 'true');
        field.dataset.fdVoUnavailable = hasUsableProxy ? 'false' : 'true';
        field.hidden = !hasUsableProxy;
      }
    };

    const getRequiredVoProxyControls = () => {
      const template = root.querySelector('[data-fd-vo-template]');
      if (!template) return [];
      return Array.from(template.querySelectorAll('[data-fd-vo-sync]')).filter((control) => {
        const field = control.closest('[data-fd-vo-template-field]');
        if (isInactiveVoTemplateField(field)) return false;
        if (field && field.dataset.fdVoUnavailable === 'true') return false;
        if (control.dataset.fdVoFallback === 'true' || control.dataset.fdVoReady !== 'true') return false;
        if (/^(radio|checkbox)$/i.test(control.type || '') && !control.checked) return false;
        return true;
      });
    };

    const refreshVoMappingErrorState = () => {
      const proxyControls = getRequiredVoProxyControls();
      const generatedColorField = root.querySelector('[data-fd-template-color-field]');
      const colorNeedsConfirmation = Boolean(
        generatedColorField
        && !generatedColorField.hidden
        && !isOptionalVoTemplateField(generatedColorField)
      );
      const colorOption = colorNeedsConfirmation ? getBcpoColorOption() : null;
      const colorWrapper = colorOption ? findBcpoWrapperForOption(colorOption) : null;
      const colorHasNativeFallback = Boolean(
        colorWrapper
        && !colorWrapper.hidden
        && colorWrapper.getAttribute('aria-hidden') !== 'true'
        && !colorWrapper.classList.contains('fd-bcpo-template-hidden')
      );
      const hasFailure = proxyControls.some((control) => control.dataset.fdVoSyncConfirmed !== 'true')
        || (
          colorNeedsConfirmation
          && generatedColorField.dataset.fdVoSyncConfirmed !== 'true'
          && !colorHasNativeFallback
        );
      root.dataset.fdVoMappingError = hasFailure ? 'true' : 'false';
      return !hasFailure;
    };

    const getBcpoValueKey = (item) => String(item && item.key ? item.key : '').trim();

    const createColorSwatchButton = (item, index) => {
      const key = getBcpoValueKey(item);
      const sourceImage = item && item.value ? item.value : getColorImage(key);
      const thumbnailImage = optimizeVoImages
        ? String(sourceImage || getColorThumbnail(key) || '')
        : expandBcpoImageUrl(sourceImage);
      const fullImage = optimizeVoImages ? getColorImage(key) : thumbnailImage;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'fd-pdp-option__value fd-pdp-swatch fd-pdp-vo-color-swatch';
      button.dataset.fdTemplateBcpoColor = 'true';
      button.dataset.label = key;
      button.dataset.alt = key;
      button.dataset.value = key;
      button.dataset.valueHandle = handleize(key);
      if (fullImage) button.dataset.image = fullImage;
      button.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');
      button.innerHTML = [
        `<span class="fd-pdp-swatch__chip" ${thumbnailImage ? `style="background-image:url('${thumbnailImage.replace(/'/g, '%27')}');"` : ''}></span>`,
        `<span>${key}</span>`
      ].join('');
      return button;
    };

    const syncBcpoColorValue = (option, value) => {
      const wrapper = findBcpoWrapperForOption(option);
      if (!wrapper || !value) {
        restoreFailedVoProxyBinding(null, { option, wrapper });
        return false;
      }
      const confirmed = syncBcpoOptionValue(option, value);
      setBcpoWrapperProxyHidden(findBcpoWrapperForOption(option) || wrapper, confirmed);
      if (!confirmed) restoreFailedVoProxyBinding(null, { option, wrapper });
      return confirmed;
    };

    const activateNativeBcpoColorChoice = (target, options = {}) => {
      const wrapper = target && target.closest ? target.closest('#bcpo .selector-wrapper') : null;
      const parent = getBcpoColorChoice(target);
      const input = getBcpoInput(target, parent || wrapper || (target && target.closest ? target.closest('#bcpo') : null));
      if (!input || input.disabled) return false;

      const type = String(input.type || '').toLowerCase();
      if (
        (type === 'radio' || type === 'checkbox')
        && !input.checked
        && options.nativeClick !== false
        && typeof input.click === 'function'
      ) {
        input.click();
        if (input.checked) return true;
      }
      const wasChecked = type === 'radio' || type === 'checkbox' ? input.checked : true;
      if (type === 'radio' || type === 'checkbox') {
        if (type === 'radio' && input.name) {
          Array.from((input.form || document).querySelectorAll(`input[type="radio"][name="${CSS.escape(input.name)}"]`)).forEach((item) => {
            if (item !== input) item.checked = false;
          });
        }
        input.checked = true;
      }

      const changed = type === 'radio' || type === 'checkbox' ? input.checked !== wasChecked : false;
      if (changed && options.dispatch !== false) dispatchVoChange(input);
      return type === 'radio' || type === 'checkbox' ? input.checked : true;
    };

    const selectTemplateBcpoColor = (button, shouldSyncVo, options = {}) => {
      if (!button) return false;
      const shouldUpdateMainImage = options.updateMainImage !== false;
      const field = button.closest('[data-fd-template-color-field]');
      const value = String(button.dataset.value || button.dataset.label || '').trim();
      if (!field || !value) return false;

      field.querySelectorAll('[data-fd-template-bcpo-color]').forEach((item) => {
        const selected = item === button;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      const label = field.querySelector('[data-fd-generated-color-label]');
      if (label) label.textContent = value;
      const hidden = field.querySelector('[data-fd-template-color-property]');
      if (hidden) hidden.value = value;
      field.dataset.fdCurrentColorValue = value;
      root.querySelectorAll('[data-fd-color-label]').forEach((item) => {
        item.textContent = value;
      });

      const option = getBcpoColorOption();
      const syncConfirmed = Boolean(shouldSyncVo && option && syncBcpoColorValue(option, value));
      if (shouldSyncVo) {
        field.dataset.fdVoSyncConfirmed = syncConfirmed ? 'true' : 'false';
        refreshVoMappingErrorState();
      }

      const swatchImage = button.dataset.image || getColorImage(value);
      const productImage = getProductColorImage(value);
      if (shouldUpdateMainImage && productImage) {
        setMainImage(productImage, value);
        updateGalleryGroup(button.dataset.valueHandle || handleize(value), productImage);
      } else if (shouldUpdateMainImage && canUseSwatchImageAsMain(swatchImage)) {
        setMainImage(swatchImage, value);
      }

      return true;
    };

    const getInitialSkuColorValue = (option) => {
      if (!preserveInitialMainImageDuringColorSync || hasUserMainImageInteraction || !option || !Array.isArray(option.values)) return '';
      const skuMatch = productHandle.match(/(?:^|-)rs\d+-\d+(?:-|$)/i);
      if (!skuMatch) return '';
      const sku = skuMatch[0].replace(/^-|-$/g, '').toUpperCase();
      const match = option.values.find((item) => String(getBcpoValueKey(item) || '').toUpperCase().includes(sku));
      return match ? getBcpoValueKey(match) : '';
    };

    const ensureTemplateBcpoColorField = () => {
      const template = root.querySelector('[data-fd-vo-template]');
      if (!template) return null;

      if (usesNativeBcpoColorOnly) {
        const existingField = template.querySelector('[data-fd-template-color-field]');
        if (existingField) existingField.remove();
        return null;
      }

      const option = getBcpoColorOption();
      if (!option || !Array.isArray(option.values) || !option.values.length) return null;

      if (!usesStableTemplateColorField && hasNativeBcpoColorWrapper()) {
        const existingField = template.querySelector('[data-fd-template-color-field]');
        if (existingField) existingField.remove();
        return null;
      }

      const usableValues = option.values.filter((item) => getBcpoValueKey(item));
      if (!usableValues.length) return null;

      const getGeneratedColorFieldAnchor = (currentField) => {
        if (forceTopGeneratedColorField && form) {
          const bcpoRoot = root.querySelector('#bcpo') || form.querySelector('#bcpo');
          if (bcpoRoot && bcpoRoot.parentNode === form) return bcpoRoot;
        }
        return Array.from(template.querySelectorAll('[data-fd-vo-template-field]'))
          .find((candidate) => candidate !== currentField && !candidate.hasAttribute('data-fd-template-color-field')) || null;
      };

      const insertGeneratedColorField = (colorField, anchor) => {
        if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(colorField, anchor);
        else template.appendChild(colorField);
      };

      let field = (forceTopGeneratedColorField && form ? form.querySelector('[data-fd-template-color-field]') : null)
        || template.querySelector('[data-fd-template-color-field]');
      const hadField = Boolean(field);
      if (!field) {
        field = document.createElement('fieldset');
        field.className = 'fd-pdp-option fd-pdp-option--color fd-pdp-option--media fd-pdp-option--vo-color';
        field.setAttribute('data-fd-vo-template-field', '');
        field.setAttribute('data-fd-template-color-field', '');
        const anchor = getGeneratedColorFieldAnchor(field);
        insertGeneratedColorField(field, anchor);
      }

      if (forceTopGeneratedColorField) {
        const anchor = getGeneratedColorFieldAnchor(field);
        if (anchor && anchor.previousElementSibling !== field) insertGeneratedColorField(field, anchor);
      }

      const signature = usableValues.map((item) => `${getBcpoValueKey(item)}=${item && item.value ? item.value : ''}`).join('|');
      if (field.dataset.fdColorSignature !== signature) {
        const firstValue = getBcpoValueKey(usableValues[0]);
        field.innerHTML = [
          '<legend class="fd-pdp-step-label"><b></b><span>Color: <em data-fd-generated-color-label data-fd-color-label></em></span></legend>',
        '<div class="fd-pdp-color-note">Lighting, screen, and batch variations may affect color. Compare Fabric Samples first.</div>',
          `<input type="hidden" name="properties[Color]" value="${firstValue.replace(/"/g, '&quot;')}" data-fd-template-color-property>`,
          '<div class="fd-pdp-option__values fd-pdp-vo-color-values"></div>'
        ].join('');
        const valuesRoot = field.querySelector('.fd-pdp-vo-color-values');
        usableValues.forEach((item, index) => {
          valuesRoot.appendChild(createColorSwatchButton(item, index));
        });
        field.dataset.fdColorSignature = signature;
      }

      field.hidden = false;
      field.dataset.fdVoUnavailable = 'false';

      const currentSelected = hadField ? field.querySelector('[data-fd-template-bcpo-color].is-selected') : null;
      const currentHidden = hadField ? field.querySelector('[data-fd-template-color-property]') : null;
      const currentValue = field.dataset.fdCurrentColorValue
        || (currentHidden ? String(currentHidden.value || '').trim() : '')
        || (currentSelected ? String(currentSelected.dataset.value || '').trim() : '');
      const selectedValue = currentValue || getInitialSkuColorValue(option) || String(option.preselect_value || '').trim();
      const selectedButton = Array.from(field.querySelectorAll('[data-fd-template-bcpo-color]')).find((button) => (
        valueMatches(button.dataset.value, selectedValue)
      )) || field.querySelector('[data-fd-template-bcpo-color].is-selected') || field.querySelector('[data-fd-template-bcpo-color]');
      selectTemplateBcpoColor(selectedButton, true, { updateMainImage: false });
      return field;
    };

    const dispatchVoChange = (control) => {
      if (!control) return;
      control.dispatchEvent(new Event('input', { bubbles: true }));
      control.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const syncTemplateRadioGroup = (control) => {
      if (!control || control.type !== 'radio') return;
      const field = control.closest('[data-fd-vo-template-field]') || control.closest('[data-fd-vo-template]');
      if (!field) return;
      const optionName = control.dataset.fdVoOption || '';
      field.querySelectorAll('input[type="radio"][data-fd-vo-sync]').forEach((input) => {
        if ((input.dataset.fdVoOption || '') === optionName) input.checked = input === control;
      });
    };

    const setTemplateControlToVoMode = (control, enabled) => {
      if (!control) return;
      const shell = control.closest('label');
      if (shell && shell.closest('[data-fd-vo-template-field]')) shell.hidden = !enabled;
      if (enabled) {
        if (!control.dataset.fdOriginalName && control.name) control.dataset.fdOriginalName = control.name;
        control.removeAttribute('name');
        control.disabled = false;
        control.dataset.fdVoReady = 'true';
      } else {
        if (control.dataset.fdOriginalName) control.name = control.dataset.fdOriginalName;
        control.disabled = true;
        delete control.dataset.fdVoReady;
      }
    };

    const refreshCompositeTemplateLabels = (template) => {
      if (!template) return;
      template.querySelectorAll('[data-fd-vo-template-field]').forEach((field) => {
        const fieldsGrid = field.querySelector('.fd-pdp-fields');
        if (fieldsGrid) {
          const visibleFields = Array.from(fieldsGrid.children || []).filter((child) => !child.hidden);
          fieldsGrid.classList.toggle('fd-pdp-fields--single', visibleFields.length === 1);
        }

        const title = field.querySelector('.fd-pdp-step-label span');
        if (!title || normalizeVoText(title.dataset.fdOriginalLabel || title.textContent) !== 'lining and edge binding') return;
        if (!title.dataset.fdOriginalLabel) title.dataset.fdOriginalLabel = title.textContent;

        const controls = Array.from(field.querySelectorAll('[data-fd-vo-sync]'));
        const hasLining = controls.some((control) => control.dataset.fdVoReady === 'true' && normalizeVoText(control.dataset.fdVoOption).includes('lining'));
        const hasEdgeBinding = controls.some((control) => control.dataset.fdVoReady === 'true' && normalizeVoText(control.dataset.fdVoOption).includes('edge binding'));

        if (hasLining && hasEdgeBinding) title.textContent = title.dataset.fdOriginalLabel;
        else if (hasLining) title.textContent = 'Lining';
        else if (hasEdgeBinding) title.textContent = 'Edge Binding';
        else title.textContent = title.dataset.fdOriginalLabel;
      });
    };

    const activateNativeBcpoFallback = (template, wrappers) => {
      if (!template) {
        root.dataset.fdVoMappingError = 'true';
        return false;
      }

      Array.from(wrappers || []).forEach((wrapper) => {
        if (
          wrapper.classList.contains('fd-bcpo-template-hidden')
          || wrapper.dataset.fdVoSyncConfirmed === 'true'
        ) {
          setBcpoWrapperProxyHidden(wrapper, false);
        }
      });

      template.querySelectorAll('[data-fd-vo-template-field]').forEach((field) => {
        const controls = Array.from(field.querySelectorAll('[data-fd-vo-sync]'));
        controls.forEach((control) => {
          const binding = voProxyBindings.get(control);
          if (binding && binding.wrapper) setBcpoWrapperProxyHidden(binding.wrapper, false);
          voProxyBindings.delete(control);
          control.dataset.fdVoFallback = 'true';
          control.dataset.fdVoSyncConfirmed = 'false';
          setTemplateControlToVoMode(control, false);
        });
        field.dataset.fdVoUnavailable = 'true';
        field.hidden = true;
        field.querySelectorAll('input, select, textarea, button').forEach((control) => {
          control.disabled = true;
        });
      });

      const hasVisibleNativeFallback = Array.from(wrappers || []).some((wrapper) => (
        isVisibleBcpoNode(wrapper)
        && Array.from(wrapper.querySelectorAll('input, select, textarea')).some((control) => (
          !control.disabled && String(control.type || '').toLowerCase() !== 'hidden'
        ))
      ));
      root.dataset.fdVoMappingError = hasVisibleNativeFallback ? 'false' : 'true';
      refreshCompositeTemplateLabels(template);
      refreshTemplateStepNumbers();
      return hasVisibleNativeFallback;
    };

    const syncSelectOptionsFromVo = (control, option) => {
      if (!control || control.tagName !== 'SELECT' || !option || !Array.isArray(option.values) || !option.values.length) return;
      if (control.dataset.fdVoOptionsLoaded === normalizeVoText(option.title)) return;
      const currentValue = control.value;
      control.innerHTML = '';
      option.values.forEach((item) => {
        const key = String(item && item.key ? item.key : '').trim();
        if (!key) return;
        const optionElement = document.createElement('option');
        optionElement.value = key;
        optionElement.textContent = key;
        control.appendChild(optionElement);
      });
      const matchingOption = findUniqueVoValue(control.options, (item) => [item.value, item.textContent], currentValue);
      if (matchingOption) control.value = matchingOption.value;
      control.dataset.fdVoOptionsLoaded = normalizeVoText(option.title);
    };

    const syncNumberConstraintsFromVo = (control, option) => {
      if (!control || control.type !== 'number' || !option || !Array.isArray(option.values) || !option.values.length) return;
      const numbers = option.values
        .map((item) => Number.parseFloat(String(item && item.key ? item.key : '').trim()))
        .filter((value) => Number.isFinite(value))
        .sort((a, b) => a - b);
      if (!numbers.length) return;

      const min = numbers[0];
      const max = numbers[numbers.length - 1];
      control.min = String(min);
      control.max = String(max);
      control.step = '1';

      const placeholder = Number.parseFloat(control.getAttribute('placeholder') || '');
      if (Number.isFinite(placeholder) && (placeholder < min || placeholder > max)) {
        control.setAttribute('placeholder', String(max));
      }
    };

    const syncTemplateControlToVo = (control, options = {}) => {
      if (!control) {
        root.dataset.fdVoMappingError = 'true';
        return false;
      }

      const field = control.closest('[data-fd-vo-template-field]');
      const previousBinding = voProxyBindings.get(control) || null;
      if (isInactiveVoTemplateField(field)) {
        if (previousBinding && previousBinding.wrapper) {
          setBcpoWrapperProxyHidden(previousBinding.wrapper, false);
          clearStaleBcpoWrapperValue(previousBinding.wrapper);
        }
        voProxyBindings.delete(control);
        control.dataset.fdVoSyncConfirmed = 'true';
        if (!options.deferAggregate) refreshVoMappingErrorState();
        return true;
      }

      const option = findBcpoOption(control.dataset.fdVoOption);
      const wrapper = findBcpoWrapperForOption(option);
      const binding = previousBinding || (option && wrapper ? { option, wrapper } : null);
      const value = String(control.dataset.fdVoValue || control.value || '').trim();
      if (
        control.dataset.fdVoReady !== 'true'
        || control.dataset.fdVoFallback === 'true'
        || !option
        || !wrapper
        || !isTemplateProxyCoverageComplete(option)
        || !value
      ) {
        restoreFailedVoProxyBinding(control, binding);
        voProxyBindings.delete(control);
        if (!options.deferAggregate) refreshVoMappingErrorState();
        return false;
      }

      if (previousBinding && previousBinding.wrapper && previousBinding.wrapper !== wrapper) {
        setBcpoWrapperProxyHidden(previousBinding.wrapper, false);
        clearStaleBcpoWrapperValue(previousBinding.wrapper);
      }
      const confirmed = syncBcpoOptionValue(option, value);
      const confirmedWrapper = findBcpoWrapperForOption(option) || wrapper;
      if (!confirmed) {
        restoreFailedVoProxyBinding(control, { option, wrapper: confirmedWrapper });
        voProxyBindings.delete(control);
      } else {
        control.dataset.fdVoSyncConfirmed = 'true';
        delete control.dataset.fdVoFallback;
        voProxyBindings.set(control, { option, wrapper: confirmedWrapper, writtenByProxy: true });
        setBcpoWrapperProxyHidden(confirmedWrapper, confirmed);
      }
      if (!options.deferAggregate) refreshVoMappingErrorState();
      return confirmed;
    };

    const refreshTemplateStepNumbers = () => {
      const template = root.querySelector('[data-fd-vo-template]');
      if (!template) return;
      let number = 0;
      template.querySelectorAll('[data-fd-vo-template-field]').forEach((field) => {
        if (field.hidden || field.dataset.fdVoUnavailable === 'true') return;
        const badge = field.querySelector('.fd-pdp-step-label b');
        if (badge) {
          number += 1;
          badge.textContent = String(number);
        }
      });
    };

    const positionRomanNeutralConfigurator = () => {
      if (!usesRomanNeutralParityConfigurator) return false;
      const bcpoRoot = root.querySelector('#bcpo') || document.querySelector('#bcpo');
      const template = root.querySelector('[data-fd-vo-template]');
      if (!bcpoRoot || !template) return false;

      if (template.parentElement !== bcpoRoot) bcpoRoot.appendChild(template);
      const resources = root.querySelector('[data-fd-roman-config-resources]');
      if (resources && resources.parentElement !== bcpoRoot) bcpoRoot.appendChild(resources);

      const orderAnchors = [
        '_nc_color',
        '_nc_shade_style',
        '_nc_composite_fabric',
        '_nc_install_type',
        '_nc_width_inch',
        '_nc_height_inch',
        '_nc_fit_guarantee',
        '_nc_lift_style',
        '_nc_lining',
        '_nc_upgrades',
        '_nc_warranty_options',
        '_nc_room_label'
      ];
      const anchorCount = orderAnchors.filter((key) => (
        bcpoRoot.querySelector(`[data-unique="${key}"]`)
      )).length;
      bcpoRoot.dataset.fdRomanOrderAnchorCount = String(anchorCount);
      bcpoRoot.classList.add('fd-bcpo-neutral-order');
      template.dataset.fdRomanConfigPositioned = 'true';
      return true;
    };

    const refreshVoTemplate = () => {
      const template = root.querySelector('[data-fd-vo-template]');
      const bcpoRoot = root.querySelector('#bcpo') || document.querySelector('#bcpo');
      const bcpoWrappers = getBcpoWrappers();

      if (usesNativeBcpoOnly) {
        if (template) {
          template.hidden = true;
          template.setAttribute('aria-hidden', 'true');
          template.querySelectorAll('input, select, textarea, button').forEach((control) => {
            control.disabled = true;
          });
        }
        bcpoWrappers.forEach((wrapper) => {
          const forceHidden = isForceHiddenBcpoWrapper(wrapper);
          setForceHiddenBcpoWrapper(wrapper, forceHidden);
          if (forceHidden) return;
          wrapper.classList.remove('fd-bcpo-template-hidden');
          wrapper.removeAttribute('aria-hidden');
        });
        const nativeReady = syncNativeBcpoReadiness();
        root.dataset.fdVoMappingError = nativeReady ? 'false' : 'true';
        return nativeReady;
      }

      if (!template) {
        root.dataset.fdVoMappingError = 'true';
        return false;
      }
      if (!getBcpoOptions().length) return activateNativeBcpoFallback(template, bcpoWrappers);

      const generatedColorField = ensureTemplateBcpoColorField();
      if (!bcpoRoot && !bcpoWrappers.length) {
        root.dataset.fdVoMappingError = 'true';
        refreshCompositeTemplateLabels(template);
        refreshTemplateStepNumbers();
        return false;
      }

      const confirmedProxyWrappers = new Set();
      const fields = Array.from(template.querySelectorAll('[data-fd-vo-template-field]'));
      fields.forEach((field) => {
        const controls = Array.from(field.querySelectorAll('[data-fd-vo-sync]'));
        let hasMappedControl = false;

        controls.forEach((control) => {
          const option = findBcpoOption(control.dataset.fdVoOption);
          const wrapper = findBcpoWrapperForOption(option);
          const hasBinding = Boolean(option && wrapper);
          const useNativeLiningSelector = Boolean(
            option && normalizeVoText(option.title) === 'lining'
          );
          if (useNativeLiningSelector) {
            // Lining owns conditional child groups with photos, shading details,
            // and add-on prices. Keep BCPO's native selector beside those groups
            // instead of replacing it with the later generic template dropdown.
            setTemplateControlToVoMode(control, false);
            control.dataset.fdVoFallback = 'true';
            control.dataset.fdVoSyncConfirmed = 'false';
            if (wrapper) setBcpoWrapperProxyHidden(wrapper, false);
            return;
          }
          if (hasBinding && control.tagName === 'SELECT') syncSelectOptionsFromVo(control, option);
          const hasSafeBinding = Boolean(
            hasBinding && isTemplateProxyCoverageComplete(option)
          );
          if (hasSafeBinding) syncNumberConstraintsFromVo(control, option);
          setTemplateControlToVoMode(control, hasSafeBinding);
          if (!hasSafeBinding) {
            control.dataset.fdVoFallback = 'true';
            control.dataset.fdVoSyncConfirmed = 'false';
            if (wrapper) setBcpoWrapperProxyHidden(wrapper, false);
            return;
          }

          delete control.dataset.fdVoFallback;
          hasMappedControl = true;
        });

        if (controls.length) {
          field.dataset.fdVoUnavailable = hasMappedControl ? 'false' : 'true';
          field.hidden = !hasMappedControl;
          field.querySelectorAll('input, select, textarea').forEach((control) => {
            if (!controls.includes(control)) control.disabled = !hasMappedControl;
          });
        } else if (field.dataset.fdVoOptionalField === 'true' || field.hasAttribute('data-fd-vo-optional-field')) {
          field.dataset.fdVoUnavailable = 'true';
          field.hidden = true;
          field.querySelectorAll('input, select, textarea').forEach((control) => {
            control.disabled = true;
          });
        }
      });

      const checkedLift = template.querySelector('[data-fd-lift-input]:checked');
      if (checkedLift) updateCordedControls(checkedLift.value);

      template.querySelectorAll('[data-fd-vo-sync]').forEach((control) => {
        if (control.dataset.fdVoReady !== 'true' || control.dataset.fdVoFallback === 'true') return;
        if ((control.type === 'radio' || control.type === 'checkbox') && !control.checked) return;
        const option = findBcpoOption(control.dataset.fdVoOption);
        const wrapper = findBcpoWrapperForOption(option);
        if (!syncTemplateControlToVo(control, { deferAggregate: true })) return;
        const confirmedWrapper = findBcpoWrapperForOption(option) || wrapper;
        if (confirmedWrapper) confirmedProxyWrappers.add(confirmedWrapper);
      });

      if (generatedColorField && generatedColorField.dataset.fdVoSyncConfirmed === 'true') {
        const colorOption = getBcpoColorOption();
        const colorWrapper = findBcpoWrapperForOption(colorOption);
        const colorValue = String(generatedColorField.dataset.fdCurrentColorValue || '').trim();
        if (colorWrapper && isBcpoWrapperValueConfirmed(colorWrapper, colorValue)) {
          confirmedProxyWrappers.add(colorWrapper);
        }
      }

      bcpoWrappers.forEach((wrapper) => {
        setBcpoWrapperProxyHidden(wrapper, confirmedProxyWrappers.has(wrapper));
      });

      refreshDuplicateThemeColorOptions();

      refreshCompositeTemplateLabels(template);
      refreshTemplateStepNumbers();
      const mappingReady = refreshVoMappingErrorState();
      positionRomanNeutralConfigurator();
      return mappingReady;
    };

    const isHiddenForValidation = (element) => {
      if (!element) return true;
      if (element.hidden || element.getAttribute('aria-hidden') === 'true') return true;
      if (element.closest('[hidden], .fd-bcpo-template-hidden, .fd-bcpo-force-hidden, [aria-hidden="true"]')) return true;
      if (!window.getComputedStyle) return false;
      const style = window.getComputedStyle(element);
      return style.display === 'none' || style.visibility === 'hidden';
    };

    const isPlaceholderChoice = (control) => {
      if (!control || control.tagName !== 'SELECT') return false;
      const selected = control.options[control.selectedIndex];
      const valueText = normalizeVoText(control.value || (selected ? selected.textContent : ''));
      const optionText = normalizeVoText(selected ? selected.textContent : '');
      return !valueText || valueText === 'choose one' || optionText === 'choose one' || optionText === 'select one' || optionText === 'select';
    };

    const isHiddenControlForValidation = (control) => {
      if (!control) return true;
      const type = String(control.type || '').toLowerCase();
      if ((type === 'radio' || type === 'checkbox') && !control.closest('[hidden], .fd-bcpo-template-hidden, .fd-bcpo-force-hidden, [aria-hidden="true"]')) {
        return false;
      }
      return isHiddenForValidation(control);
    };

    const getFieldControls = (field) => Array.from(field ? field.querySelectorAll('input, select, textarea') : [])
      .filter((control) => control.type !== 'hidden' && !control.disabled && !isHiddenControlForValidation(control));

    const getChoiceGroupKey = (control, controls) => {
      const key = control.name || control.dataset.fdOriginalName || control.dataset.fdVoOption || control.id || '';
      if (key) return `${control.type}:${key}`;
      return `${control.type}:field:${controls.indexOf(control)}`;
    };

    const controlHasValue = (control, controls) => {
      if (!control || control.disabled || isHiddenForValidation(control)) return true;
      const type = String(control.type || '').toLowerCase();
      if (type === 'radio' || type === 'checkbox') {
        const groupKey = getChoiceGroupKey(control, controls);
        const group = controls.filter((item) => item.type === control.type && getChoiceGroupKey(item, controls) === groupKey);
        return group.some((item) => item.checked);
      }
      if (control.tagName === 'SELECT') return !isPlaceholderChoice(control);
      if (type === 'file') return Boolean(control.files && control.files.length);
      const value = String(control.value || '').trim();
      if (!value) return false;
      return typeof control.checkValidity === 'function' ? control.checkValidity() : true;
    };

    const getFieldLabelText = (field, fallback) => {
      const label = field && (field.querySelector('.fd-pdp-step-label span, .bcpo-title, .bcpo-label, label') || field);
      return String(label ? label.textContent : fallback || 'this option').replace(/\s+/g, ' ').trim() || fallback || 'this option';
    };

    const getValidationError = () => {
      let error = form.querySelector('[data-fd-pdp-form-error]');
      if (error) return error;
      error = document.createElement('div');
      error.className = 'fd-pdp-form-error';
      error.setAttribute('role', 'alert');
      error.setAttribute('data-fd-pdp-form-error', '');
      error.hidden = true;
      if (atc && atc.parentNode === form) form.insertBefore(error, atc);
      else form.appendChild(error);
      return error;
    };

    const getFieldValidationError = (field) => {
      if (!field) return null;
      let error = Array.from(field.children || []).find((child) => (
        child && child.hasAttribute && child.hasAttribute('data-fd-pdp-field-error')
      ));
      if (error) return error;
      error = document.createElement('div');
      error.className = 'fd-pdp-field-error';
      error.setAttribute('role', 'alert');
      error.setAttribute('data-fd-pdp-field-error', '');
      error.hidden = true;
      field.insertBefore(error, field.firstElementChild || null);
      return error;
    };

    const getValidationMessage = (label) => {
      const cleanLabel = String(label || '').replace(/\s+/g, ' ').trim();
      if (/colou?r|fabric/i.test(cleanLabel)) {
        return 'Please choose a fabric color before adding to cart.';
      }
      if (/width|height|length|size|measurement/i.test(cleanLabel)) {
        return 'Please enter your measurements before adding to cart.';
      }
      return `Please complete ${cleanLabel || 'this option'} before adding to cart.`;
    };

    const setInvalidField = (field, invalid) => {
      if (!field) return;
      field.classList.toggle('is-fd-invalid', invalid);
      if (invalid) field.setAttribute('aria-invalid', 'true');
      else field.removeAttribute('aria-invalid');
    };

    const clearValidationState = () => {
      root.querySelectorAll('.is-fd-invalid').forEach((field) => setInvalidField(field, false));
      document.querySelectorAll('#bcpo .is-fd-invalid').forEach((field) => setInvalidField(field, false));
      const error = form ? form.querySelector('[data-fd-pdp-form-error]') : null;
      if (error) error.hidden = true;
      root.querySelectorAll('[data-fd-pdp-field-error]').forEach((fieldError) => {
        fieldError.hidden = true;
        fieldError.textContent = '';
      });
      document.querySelectorAll('#bcpo [data-fd-pdp-field-error]').forEach((fieldError) => {
        fieldError.hidden = true;
        fieldError.textContent = '';
      });
    };

    const validateRequiredField = (field) => {
      if (!field || isHiddenForValidation(field)) return null;
      const controls = getFieldControls(field);
      if (!controls.length) return null;
      const checkedGroups = new Set();
      const invalidControl = controls.find((control) => {
        const type = String(control.type || '').toLowerCase();
        if (type === 'radio' || type === 'checkbox') {
          const groupKey = getChoiceGroupKey(control, controls);
          if (checkedGroups.has(groupKey)) return false;
          checkedGroups.add(groupKey);
        }
        return !controlHasValue(control, controls);
      });
      return invalidControl ? { field, control: invalidControl, label: getFieldLabelText(field) } : null;
    };

    const validateCustomizationBeforeSubmit = () => {
      if (!form || root.dataset.windowTreatment !== 'true') return true;
      clearValidationState();
      applyForceHiddenBcpoOptions();
      refreshVoTemplate();

      if (usesNativeBcpoOnly && !syncNativeBcpoReadiness()) {
        const error = getValidationError();
        error.textContent = 'Customization options are still loading. Please wait a moment and try again.';
        error.hidden = false;
        return false;
      }

      const invalidFields = [];
      if (root.dataset.fdVoMappingError === 'true') {
        const control = getRequiredVoProxyControls().find((item) => item.dataset.fdVoSyncConfirmed !== 'true') || null;
        const field = (control && control.closest('[data-fd-vo-template-field]'))
          || Array.from(root.querySelectorAll('[data-fd-vo-template-field]')).find((item) => (
            item.dataset.fdVoUnavailable === 'true' && !isInactiveVoTemplateField(item)
          ))
          || root.querySelector('[data-fd-vo-template-field]')
          || root;
        if (field) {
          invalidFields.push({
            field,
            control,
            label: getFieldLabelText(field),
            unavailable: true
          });
        }
      }
      root.querySelectorAll('[data-fd-vo-template-field]').forEach((field) => {
        if (field.dataset.fdVoOptionalField === 'true' || field.hasAttribute('data-fd-vo-optional-field')) return;
        if (field.dataset.fdVoUnavailable === 'true') {
          return;
        }
        const invalid = validateRequiredField(field);
        if (invalid) invalidFields.push(invalid);
      });

      const colorIndexes = getBcpoColorOptionIndexes();
      getBcpoWrappers().forEach((wrapper) => {
        if (isHiddenForValidation(wrapper)) return;
        const title = getBcpoWrapperOptionTitle(wrapper);
        if (isForceHiddenBcpoWrapper(wrapper)) return;
        const option = getBcpoWrapperOption(wrapper);
        const shouldRequire = (option && option.required === 'on') || isBcpoColorWrapper(wrapper, colorIndexes) || isBcpoColorTitle(title);
        if (!shouldRequire) return;
        const invalid = validateRequiredField(wrapper);
        if (invalid) invalidFields.push(invalid);
      });

      if (!invalidFields.length) return true;

      invalidFields.forEach((item) => setInvalidField(item.field, true));
      const first = invalidFields[0];
      const message = first.unavailable
        ? 'A required customization option could not be matched. Please refresh the page and try again.'
        : getValidationMessage(first.label);
      const error = getValidationError();
      error.textContent = message;
      error.hidden = false;
      const fieldError = getFieldValidationError(first.field);
      if (fieldError) {
        fieldError.textContent = `${message} The highlighted section is required.`;
        fieldError.hidden = false;
      }

      const focusTarget = !first.unavailable && first.control && typeof first.control.focus === 'function'
        ? first.control
        : (first.unavailable ? atc : first.field);
      if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus({ preventScroll: true });
      window.requestAnimationFrame(() => {
        const scrollTarget = fieldError || first.field;
        scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      return false;
    };

    const pdpTabs = Array.from(root.querySelectorAll('.fd-pdp-tabs a[href^="#"]'));
    const getScrollOffset = () => {
      const header = document.querySelector('[data-fd-global-header], .site-header, header');
      return (header ? header.getBoundingClientRect().height : 0) + 18;
    };
    const activateDetailTab = (link, shouldPushState) => {
      if (!link) return false;
      const hash = link.getAttribute('href');
      if (!hash || hash.charAt(0) !== '#') return false;
      const target = document.getElementById(hash.slice(1));
      if (!target) return false;

      if (target.tagName === 'DETAILS') target.open = true;
      pdpTabs.forEach((tab) => tab.classList.toggle('is-active', tab === link));

      if (shouldPushState && window.history && window.history.replaceState) {
        window.history.replaceState(null, '', hash);
      }

      window.requestAnimationFrame(() => {
        const top = target.getBoundingClientRect().top + window.pageYOffset - getScrollOffset();
        window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
      });

      return true;
    };

    const initMobileStickyAtc = () => {
      const sticky = root.querySelector('[data-fd-sticky-atc]');
      const stickyButton = sticky ? sticky.querySelector('[data-fd-sticky-submit]') : null;
      const getCurrentAtc = () => root.querySelector('[data-fd-atc]');
      const getCurrentAtcText = () => root.querySelector('[data-fd-atc-text]');
      if (!sticky || !stickyButton || !form) return;
      if (root.dataset.fdStickyControllerReady === 'true') return;
      root.dataset.fdStickyControllerReady = 'true';

      const mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 768px)') : null;
      let frame = 0;

      sticky.removeAttribute('aria-hidden');
      sticky.inert = false;
      stickyButton.tabIndex = -1;
      const formId = form.getAttribute('id');
      if (formId) stickyButton.setAttribute('aria-controls', formId);

      const isMobile = () => !mobileQuery || mobileQuery.matches;

      const syncButtonState = () => {
        const currentAtc = getCurrentAtc();
        const currentAtcText = getCurrentAtcText();
        const label = currentAtcText && currentAtcText.textContent ? currentAtcText.textContent.trim() : '';
        if (label) stickyButton.textContent = label;
        stickyButton.disabled = Boolean(currentAtc && currentAtc.disabled);
        if (currentAtc && currentAtc.disabled) stickyButton.setAttribute('aria-disabled', 'true');
        else stickyButton.removeAttribute('aria-disabled');
      };

      const setVisible = (visible) => {
        sticky.classList.toggle('is-visible', visible);
        root.classList.toggle('fd-pdp-sticky-visible', visible);
        document.body.classList.toggle('fd-pdp-sticky-visible', visible);
        sticky.dataset.fdStickyState = visible ? 'visible' : 'hidden';
        sticky.removeAttribute('aria-hidden');
        sticky.inert = false;
        delete sticky.dataset.fdAriaHiddenInertApplied;
        delete sticky.dataset.fdAriaHiddenInertWas;
        stickyButton.tabIndex = visible ? 0 : -1;
      };

      const syncPreviewOffset = () => {
        const previewBar = document.getElementById('PBarNextFrameWrapper') || document.getElementById('PBarNextFrame');
        let offset = 0;
        if (previewBar && window.getComputedStyle) {
          const rect = previewBar.getBoundingClientRect();
          const style = window.getComputedStyle(previewBar);
          const isBottomBar = rect.height > 20 && rect.bottom > window.innerHeight - 8 && style.display !== 'none' && style.visibility !== 'hidden';
          if (isBottomBar) offset = Math.min(Math.ceil(rect.height), 96);
        }
        sticky.style.setProperty('--fd-pdp-sticky-bottom-offset', `${offset}px`);
        document.body.style.setProperty('--fd-pdp-sticky-bottom-offset', `${offset}px`);
      };

      const updateSticky = () => {
        frame = 0;
        syncButtonState();
        syncPreviewOffset();
        if (!isMobile()) {
          setVisible(false);
          return;
        }

        const currentAtc = getCurrentAtc();
        if (!currentAtc) {
          setVisible(false);
          return;
        }
        const atcRect = currentAtc.getBoundingClientRect();
        const formRect = form.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
        const inlineAtcVisible = atcRect.top < window.innerHeight - 16 && atcRect.bottom > 16;
        const hasEnteredDecisionPath = formRect.top < window.innerHeight * 0.82 && scrollTop > 320;
        setVisible(hasEnteredDecisionPath && !inlineAtcVisible);
      };

      const scheduleUpdate = () => {
        if (frame) return;
        if (window.requestAnimationFrame) frame = window.requestAnimationFrame(updateSticky);
        else updateSticky();
      };

      window.addEventListener('scroll', scheduleUpdate, { passive: true });
      window.addEventListener('resize', scheduleUpdate);
      if (mobileQuery && mobileQuery.addEventListener) mobileQuery.addEventListener('change', scheduleUpdate);
      else if (mobileQuery && mobileQuery.addListener) mobileQuery.addListener(scheduleUpdate);

      if (window.IntersectionObserver) {
        const scrollObserver = new IntersectionObserver(scheduleUpdate, { threshold: [0, 0.01, 1] });
        const currentAtc = getCurrentAtc();
        if (currentAtc) scrollObserver.observe(currentAtc);
        scrollObserver.observe(form);
      }

      if (window.MutationObserver) {
        const buttonObserver = new MutationObserver(scheduleUpdate);
        const currentAtc = getCurrentAtc();
        const currentAtcText = getCurrentAtcText();
        if (currentAtc) {
          buttonObserver.observe(currentAtc, {
            attributes: true,
            attributeFilter: ['disabled', 'aria-disabled', 'class']
          });
        }
        if (currentAtcText) {
          buttonObserver.observe(currentAtcText, {
            childList: true,
            characterData: true,
            subtree: true
          });
        }
      }

      scheduleUpdate();
      window.setTimeout(scheduleUpdate, 700);
      window.setTimeout(scheduleUpdate, 1800);
    };

    initMobileStickyAtc();

    root.addEventListener('click', (event) => {
      const target = event.target && event.target.closest ? event.target : null;
      if (!target) return;

      const detailTab = target.closest('.fd-pdp-tabs a[href^="#"]');
      if (detailTab) {
        event.preventDefault();
        activateDetailTab(detailTab, true);
        return;
      }

      const qtyButton = target.closest('[data-fd-qty-action]');
      if (qtyButton) {
        updateQuantity(qtyButton.dataset.fdQtyAction);
        return;
      }

      const generatedColor = target.closest('[data-fd-template-bcpo-color]');
      if (generatedColor) {
        clearValidationState();
        if (isDirectUserClick(event)) markUserMainImageInteraction();
        selectTemplateBcpoColor(generatedColor, true);
        return;
      }

      const mediaSwatch = target.closest('[data-fd-media-swatch]');
      if (mediaSwatch) {
        if (isDirectUserClick(event)) markUserMainImageInteraction();
        const selectedColor = mediaSwatch.dataset.label || mediaSwatch.dataset.alt || '';
        const group = mediaSwatch.closest('.fd-pdp-option--media');
        if (group) {
          group.querySelectorAll('[data-fd-media-swatch]').forEach((button) => {
            button.classList.toggle('is-selected', button === mediaSwatch);
          });
        }
        root.querySelectorAll('[data-fd-color-label]').forEach((label) => {
          label.textContent = selectedColor;
        });
        if (colorProperty && selectedColor) colorProperty.value = selectedColor;
        const swatchImage = mediaSwatch.dataset.image || getColorImage(selectedColor);
        if (swatchImage) mediaSwatch.dataset.image = swatchImage;
        setMainImage(swatchImage, mediaSwatch.dataset.alt || selectedColor);
        return;
      }

      const thumb = target.closest('[data-fd-thumb]');
      if (thumb) {
        if (isDirectUserClick(event)) markUserMainImageInteraction();
        clearTargetBcpoMainImage();
        activateThumb(thumb);
        return;
      }

      const valueButton = target.closest('[data-fd-option-value]');
      if (valueButton) {
        const position = Number(valueButton.dataset.optionPosition || '1') - 1;
        const group = valueButton.closest('[data-fd-option-position]');
        selectedOptions[position] = valueButton.dataset.optionValue;

        if (group) {
          group.querySelectorAll('[data-fd-option-value]').forEach((button) => {
            button.classList.toggle('is-selected', button === valueButton);
          });
        }

        if (group && group.classList.contains('fd-pdp-option--color')) {
          if (isDirectUserClick(event)) markUserMainImageInteraction();
          updateVariant(findSelectedVariant());

          root.querySelectorAll('[data-fd-color-label]').forEach((label) => {
            label.textContent = valueButton.dataset.optionValue;
          });
          const optionImage = valueButton.dataset.image || getColorImage(valueButton.dataset.optionValue);
          if (optionImage) {
            valueButton.dataset.image = optionImage;
            setMainImage(optionImage, valueButton.dataset.optionValue);
          }
          updateGalleryGroup(valueButton.dataset.valueHandle, optionImage);
        } else {
          updateVariant(findSelectedVariant());
        }
        return;
      }

      const seeMore = target.closest('[data-fd-see-more]');
      if (seeMore) {
        const expanded = seeMore.getAttribute('aria-expanded') === 'true';
        const nextExpanded = !expanded;
        thumbs.forEach((item) => {
          if (item.classList.contains('is-extra')) item.hidden = !nextExpanded;
        });
        syncSeeMoreState(seeMore, nextExpanded);
        return;
      }

      const copyButton = target.closest('[data-fd-copy]');
      if (copyButton) {
        const value = copyButton.dataset.fdCopy;
        if (navigator.clipboard && value) {
          navigator.clipboard.writeText(value).catch(() => {});
        }
        copyButton.classList.add('is-copied');
        window.setTimeout(() => copyButton.classList.remove('is-copied'), 1200);
        return;
      }

      const stickySubmit = target.closest('[data-fd-sticky-submit]');
      if (stickySubmit && form) {
        event.preventDefault();
        event.stopPropagation();
        const submit = root.querySelector('[data-fd-atc]') || form.querySelector('[data-fd-atc], button[type="submit"], input[type="submit"], [type="submit"]');
        if (submit) {
          if (typeof form.requestSubmit === 'function' && submit.form === form) form.requestSubmit(submit);
          else submit.click();
        }
        return;
      }

      const cookieClose = target.closest('[data-fd-cookie-close]');
      if (cookieClose) {
        const cookie = root.querySelector('[data-fd-cookie]');
        if (cookie) cookie.hidden = true;
      }
    });

    document.addEventListener('click', (event) => {
      const target = event.target && event.target.closest ? event.target : null;
      if (!target) return;
      const bcpoColorTarget = target.closest('#bcpo .bcpo-image-parent, #bcpo .bcpo-color-parent, #bcpo .bcpo-front-image-label, #bcpo .bcpo-front-color-label, #bcpo .bcpo-front-image-option, #bcpo .bcpo-front-color-option, #bcpo input, #bcpo label');
      if (event.isTrusted && bcpoColorTarget && isBcpoColorTarget(bcpoColorTarget)) {
        if (isDirectUserClick(event)) markUserMainImageInteraction();
        const nativeInputOrLabel = target.closest('#bcpo input, #bcpo label');
        if (!nativeInputOrLabel) activateNativeBcpoColorChoice(bcpoColorTarget);
        scheduleBcpoColorImageUpdate(bcpoColorTarget);
      }
    }, true);

    root.addEventListener('change', (event) => {
      const liftInput = event.target && event.target.closest ? event.target.closest('[data-fd-lift-input]') : null;
      if (liftInput) {
        updateCordedControls(liftInput.value);
      }

      const voTemplateControl = event.target && event.target.closest ? event.target.closest('[data-fd-vo-sync]') : null;
      if (voTemplateControl) {
        clearValidationState();
        syncTemplateRadioGroup(voTemplateControl);
        syncTemplateControlToVo(voTemplateControl);
      }
      if (liftInput) refreshVoTemplate();

      if (event.target === quantityInput && quantityInput) {
        quantityInput.value = String(Math.max(Number(quantityInput.value || 1), 1));
      }

      const changedBcpoInput = event.target && event.target.closest
        ? event.target.closest('#bcpo input')
        : null;
      if (changedBcpoInput) {
        if (changedBcpoInput.closest(
          '[data-unique="_nc_upgrades"], [data-unique="_nc_trim_border"], [data-unique="_nc_trim_border_style"]'
        )) {
          syncRomanNeutralTrimFlow(changedBcpoInput.closest('#bcpo'));
        }
        window.setTimeout(decorateBcpoRadioAccessibility, 80);
      }

    });

    root.addEventListener('input', (event) => {
      const voTemplateControl = event.target && event.target.closest ? event.target.closest('[data-fd-vo-sync]') : null;
      if (!voTemplateControl || !/^(number|text|search|tel|url|email)?$/i.test(voTemplateControl.type || '')) return;
      clearValidationState();
      window.clearTimeout(voTemplateControl.fdVoSyncTimer);
      voTemplateControl.fdVoSyncTimer = window.setTimeout(() => {
        syncTemplateControlToVo(voTemplateControl);
      }, 200);
    });

    document.addEventListener('change', (event) => {
      const target = event.target && event.target.closest ? event.target : null;
      if (!target) return;
      const bcpoInput = target.closest('#bcpo input, #bcpo .bcpo-front-image-option, #bcpo .bcpo-front-color-option');
      if (event.isTrusted && bcpoInput && isBcpoColorTarget(bcpoInput)) {
        clearValidationState();
        scheduleBcpoColorImageUpdate(bcpoInput);
      }
    }, true);

    thumbs.forEach((thumb) => {
      if (thumb.classList.contains('is-active')) activateThumb(thumb);
    });
    initMobileGallerySwipe();

    const checkedLift = root.querySelector('[data-fd-lift-input]:checked');
    if (checkedLift) {
      updateCordedControls(checkedLift.value);
    }

    const initialColor = root.querySelector('.fd-pdp-option--color:not([hidden]) [data-fd-option-value].is-selected');
    if (initialColor) {
      updateGalleryGroup(initialColor.dataset.valueHandle, initialColor.dataset.image);
    }

    if (window.location.hash) {
      const initialTab = pdpTabs.find((tab) => tab.getAttribute('href') === window.location.hash);
      if (initialTab) window.setTimeout(() => activateDetailTab(initialTab, false), 300);
    }

    const syncSelectedBcpoColor = () => {
      applyForceHiddenBcpoOptions();
      decorateBcpoColorOptions();
      decorateBcpoRadioAccessibility();
      refreshDuplicateThemeColorOptions();
      refreshVoTemplate();
      const initialColorOption = getBcpoColorOption();
      const initialSkuColorValue = getInitialSkuColorValue(initialColorOption);
      if (initialSkuColorValue) syncBcpoColorValue(initialColorOption, initialSkuColorValue);
      const selectedBcpoColor = Array.from(document.querySelectorAll('#bcpo input:checked')).find((input) => isBcpoColorTarget(input));
      if (selectedBcpoColor) updateBcpoColorImage(selectedBcpoColor, { updateMainImage: false });
      scheduleInitialActiveThumbRestore();
    };
    syncSelectedBcpoColor();
    window.setTimeout(syncSelectedBcpoColor, 600);
    window.setTimeout(syncSelectedBcpoColor, 1800);
    window.setTimeout(syncSelectedBcpoColor, 3200);
    if (usesStableTemplateColorField) {
      const stableColorRetryDelays = [500, 1200, 2500, 5000, 9000];
      let stableColorRetryIndex = 0;
      const retryNeutralBambooColorField = () => {
        syncSelectedBcpoColor();
        const hasColorData = Boolean(getBcpoColorOption());
        const hasGeneratedColorField = Boolean(root.querySelector('[data-fd-template-color-field]'));
        if ((hasColorData && hasGeneratedColorField) || stableColorRetryIndex >= stableColorRetryDelays.length) return;
        const delay = stableColorRetryDelays[stableColorRetryIndex];
        stableColorRetryIndex += 1;
        window.setTimeout(retryNeutralBambooColorField, delay);
      };
      window.setTimeout(retryNeutralBambooColorField, 250);
    }
    if (window.MutationObserver) {
      let decorateFrame = 0;
      const scheduleDecorate = () => {
        if (decorateFrame) return;
        const decorate = () => {
          decorateFrame = 0;
          applyForceHiddenBcpoOptions();
          decorateBcpoColorOptions();
          decorateBcpoRadioAccessibility();
          refreshDuplicateThemeColorOptions();
          refreshVoTemplate();
          enforceTargetBcpoMainImage();
          restoreInitialActiveThumbImage();
        };
        if (window.requestAnimationFrame) decorateFrame = window.requestAnimationFrame(decorate);
        else decorate();
      };
      const decorationObserver = new MutationObserver((mutations) => {
        if (mutations.some((mutation) => mutation.type === 'childList')) scheduleDecorate();
      });
      let observedDecorationBcpoRoot = null;
      const observeBcpoDecorations = () => {
        const bcpoRoot = root.querySelector('#bcpo') || document.querySelector('#bcpo');
        if (!bcpoRoot) return false;
        if (observedDecorationBcpoRoot === bcpoRoot) return true;
        decorationObserver.disconnect();
        observedDecorationBcpoRoot = bcpoRoot;
        decorationObserver.observe(observedDecorationBcpoRoot, { childList: true, subtree: true });
        scheduleDecorate();
        return true;
      };
      const decorationObserverRetryDelays = [150, 400, 900, 1800, 3600, 7000];
      let decorationObserverRetryIndex = 0;
      const connectDecorationObserver = () => {
        if (observeBcpoDecorations()) return;
        if (decorationObserverRetryIndex >= decorationObserverRetryDelays.length) return;
        const delay = decorationObserverRetryDelays[decorationObserverRetryIndex];
        decorationObserverRetryIndex += 1;
        window.setTimeout(connectDecorationObserver, delay);
      };
      connectDecorationObserver();

      if ((preferBcpoColorImageAsMain || preserveInitialMainImageDuringColorSync) && mainImage) {
        const mainImageObserver = new MutationObserver(enforceTargetBcpoMainImage);
        mainImageObserver.observe(mainImage, {
          attributes: true,
          attributeFilter: ['src', 'srcset']
        });
      }
    }
  });

  const initMobileStickyAtcFallback = () => {
    const fallbackRoots = Array.from(document.querySelectorAll('[data-fd-product]')).filter((root) => (
      root.dataset.fdStickyControllerReady !== 'true'
      && root.dataset.fdStickyFallbackReady !== 'true'
      && root.querySelector('[data-fd-sticky-atc]')
      && root.querySelector('[data-fd-sticky-submit]')
      && root.querySelector('.fd-pdp-form')
      && root.querySelector('[data-fd-atc]')
    ));
    if (!fallbackRoots.length) return;
    fallbackRoots.forEach((root) => {
      root.dataset.fdStickyFallbackReady = 'true';
    });

    const mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 768px)') : null;
    let frame = 0;

    const cleanInertState = (sticky) => {
      sticky.removeAttribute('aria-hidden');
      sticky.inert = false;
      delete sticky.dataset.fdAriaHiddenInertApplied;
      delete sticky.dataset.fdAriaHiddenInertWas;
    };

    const syncPreviewOffset = (sticky) => {
      const previewBar = document.getElementById('PBarNextFrameWrapper') || document.getElementById('PBarNextFrame');
      let offset = 0;
      if (previewBar && window.getComputedStyle) {
        const rect = previewBar.getBoundingClientRect();
        const style = window.getComputedStyle(previewBar);
        const isBottomBar = rect.height > 20 && rect.bottom > window.innerHeight - 8 && style.display !== 'none' && style.visibility !== 'hidden';
        if (isBottomBar) offset = Math.min(Math.ceil(rect.height), 96);
      }
      sticky.style.setProperty('--fd-pdp-sticky-bottom-offset', `${offset}px`);
      document.body.style.setProperty('--fd-pdp-sticky-bottom-offset', `${offset}px`);
    };

    const syncStickyBars = () => {
      frame = 0;
      const isMobile = !mobileQuery || mobileQuery.matches;
      fallbackRoots.forEach((root) => {
        if (!document.documentElement.contains(root) || root.dataset.fdStickyControllerReady === 'true') return;
        const sticky = root.querySelector('[data-fd-sticky-atc]');
        const stickyButton = sticky ? sticky.querySelector('[data-fd-sticky-submit]') : null;
        const form = root.querySelector('.fd-pdp-form');
        const atc = root.querySelector('[data-fd-atc]');
        if (!sticky || !stickyButton || !form || !atc) return;

        cleanInertState(sticky);
        syncPreviewOffset(sticky);
        const atcRect = atc.getBoundingClientRect();
        const formRect = form.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
        const inlineAtcVisible = atcRect.top < window.innerHeight - 16 && atcRect.bottom > 16;
        const hasEnteredDecisionPath = formRect.top < window.innerHeight * 0.82 && scrollTop > 320;
        const visible = isMobile && hasEnteredDecisionPath && !inlineAtcVisible;
        sticky.classList.toggle('is-visible', visible);
        root.classList.toggle('fd-pdp-sticky-visible', visible);
        document.body.classList.toggle('fd-pdp-sticky-visible', visible);
        sticky.dataset.fdStickyState = visible ? 'visible' : 'hidden';
        stickyButton.tabIndex = visible ? 0 : -1;
      });
    };

    const scheduleSync = () => {
      if (frame) return;
      if (window.requestAnimationFrame) frame = window.requestAnimationFrame(syncStickyBars);
      else syncStickyBars();
    };

    window.addEventListener('scroll', scheduleSync, { passive: true });
    window.addEventListener('resize', scheduleSync);
    if (mobileQuery && mobileQuery.addEventListener) mobileQuery.addEventListener('change', scheduleSync);
    else if (mobileQuery && mobileQuery.addListener) mobileQuery.addListener(scheduleSync);
    document.addEventListener('DOMContentLoaded', scheduleSync, { once: true });
    window.addEventListener('load', scheduleSync, { once: true });
    scheduleSync();
    window.setTimeout(scheduleSync, 700);
    window.setTimeout(scheduleSync, 1800);
    window.setTimeout(scheduleSync, 3200);
  };

  initMobileStickyAtcFallback();
})();

(function () {
  const isJudgeMeImage = (img) => {
    if (!img || img.tagName !== 'IMG') return false;
    const source = `${img.currentSrc || ''} ${img.src || ''} ${img.getAttribute('data-src') || ''}`;
    if (/judgeme|jdgm/i.test(source)) return true;
    return !!(img.closest && img.closest('.jdgm-widget, .jdgm-rev, .fd-pdp-reviews'));
  };

  const removeBrokenJudgeMeImage = (img) => {
    if (!isJudgeMeImage(img)) return;
    const target = img.closest && img.closest('.jdgm-rev__pic-link, .jdgm-rev__pic-img, .jdgm-picture-fieldset, a');
    (target || img).remove();
  };

  document.addEventListener('error', (event) => {
    removeBrokenJudgeMeImage(event.target);
  }, true);

  const pruneExistingBrokenImages = () => {
    document.querySelectorAll('.jdgm-widget img, .fd-pdp-reviews img').forEach((img) => {
      if (img.complete && img.naturalWidth === 0) removeBrokenJudgeMeImage(img);
    });
  };

  window.addEventListener('load', () => {
    window.setTimeout(pruneExistingBrokenImages, 300);
    window.setTimeout(pruneExistingBrokenImages, 1500);
    window.setTimeout(pruneExistingBrokenImages, 3500);
  }, { once: true });

  const pruneTimer = window.setInterval(pruneExistingBrokenImages, 1000);
  window.setTimeout(() => window.clearInterval(pruneTimer), 12000);
  pruneExistingBrokenImages();
})();
